import React, {
  useState,
  useRef,
  useEffect,
  useCallback,
  useMemo,
  memo,
  forwardRef,
  useImperativeHandle,
} from "react";
import { AsyncPaginate } from "react-select-async-paginate";
import { useTheme } from "@mui/material/styles";
import {
  Box,
  Button,
  Container,
  Dialog,
  DialogContent,
  Paper,
  Step,
  StepLabel,
  Stepper,
  Typography,
  Checkbox,
  FormControlLabel,
  Grid,
  TextField,
  tableCellClasses,
  Card,
  CardContent,
  FormGroup,
  IconButton,
  AppBar,
  Toolbar,
  Icon,
  Radio,
  Alert,
  StepButton,
  MenuItem,
  Stack,
  Switch,
  Chip,
  DialogContentText,
  DialogActions,
  useMediaQuery,
} from "@mui/material";
import ListPageHeader from "../../utilities/ListPageHeader";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { styled, alpha } from "@mui/material/styles";
import customStyles from "app/shared-components/SelectCustomStyle";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.min.css";
import PRJOrderSummary from "./PRJOrderSummary";
import { Formik, Form, Field } from "formik";
import moment from "moment";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import OAuthService from "src/app/auth/services/oAuthService";

import FormPageHeader from "../../utilities/FormPageHeader";
import jwtDecode from "jwt-decode";
import { m } from "framer-motion";
import OrderSuccess from "./OrderSuccess";
import ProjectOverview from "./ProjectOverview";
import { useFormik } from "formik";
import * as Yup from "yup";
import { DataThresholdingSharp } from "@mui/icons-material";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Select, { components } from "react-select";
import DeleteIcon from "@mui/icons-material/Delete";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";

import {
  clearOrderFormData,
  setHasBack,
  setHasBackOrderForm,
  setOrderFormData,
  setPreviousStepData,
  setRowDataValue,
  clearRowDataValue,
  clearStepData,
} from "app/store/projectSlice";
import { set } from "lodash";

const ColorButton = styled(Button)(({ theme }) => ({
  color: `${theme.palette.primary.contrastText} !important`,
  backgroundColor: theme.palette.secondary.main,
  padding: "5px 15px",
  borderRadius: "20px",
  cursor: "pointer",
  display: "block",
  textAlign: "center",
  position: "relative",
  fontSize: "12px",
  "&:hover": {
    backgroundColor: theme.palette.secondary.dark,
  },

  "&[disabled]": {
    opacity: 0.4,
    background: theme.palette.action.disabledBackground,
    color: theme.palette.text.disabled,
    "& .file": {
      cursor: "not-allowed",
    },
  },

  "& .file": {
    opacity: 0,
    width: "100%",
    height: "100%",
    position: "absolute",
    top: 0,
    left: 0,
    cursor: "pointer",
  },
}));

const CustomOption = (props) => {
  const { data, innerRef, innerProps, selectProps } = props;

  const handleDeleteClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    selectProps.setSelectedDeleteOption(data);
    selectProps.setOpenDeleteModel(true);
  };

  return (
    <div
      ref={innerRef}
      {...innerProps}
      className="flex items-center justify-between px-3 py-2 cursor-default"
    >
      <span style={{ color: "inherit" }}>{data.label}</span>

      <button
        type="button"
        onMouseDown={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
        onClick={handleDeleteClick}
        className="text-red-500 ml-2"
      >
        🗑
      </button>
    </div>
  );
};

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,

  height: 16,

  padding: 0,

  display: "flex",

  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },

    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },

  "& .MuiSwitch-switchBase": {
    padding: 2,

    "&.Mui-checked": {
      transform: "translateX(12px)",

      color: theme.palette.primary.contrastText,

      "& + .MuiSwitch-track": {
        opacity: 1,

        backgroundColor: theme.palette.primary.main,
      },
    },
  },

  "& .MuiSwitch-thumb": {
    boxShadow: theme.shadows[1],

    width: 12,

    height: 12,

    borderRadius: 6,

    backgroundColor: theme.palette.background.paper,

    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },

  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,

    opacity: 1,

    backgroundColor:
      theme.palette.mode === "dark"
        ? theme.palette.grey[700]
        : theme.palette.grey[400],

    boxSizing: "border-box",
  },
}));

const yearOptions = [
  { value: 2023, label: "2023" },
  { value: 2024, label: "2024" },
];

const weekOptions = [
  { value: 40, label: "40" },
  { value: 42, label: "42" },
  { value: 46, label: "46" },
  { value: 48, label: "48" },
];

const projectOptionsDummy = [
  {
    id: "65855a11359b1c0606ce293a",
    projectName: "Test Project 1",
    quantity: 10,
  },
  {
    id: "65855a11359b1c0606ce293b",
    projectName: "Test Project 2",
    quantity: 20,
  },
];

const factoryVendorUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.factoryVendor}`;
const rangeUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.findRanges}`;
const colorUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.ranges}`;
const handleUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.findAllHandlesByVendor}`;
const carcassUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.findAllCarcassByVendor}`;
const newOrderUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.newCustomerOrder}`;
const newPrjOrderUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.newCustomerProjectOrder}`;
const priceUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.ranges}`;
const uploadOrderFileUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.uploadOrderFile}`;
const downloadOrderFileUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.downloadOrderFile}`;
const editOrderUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.orders}`;
const projectForeCastUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.getProjectForecastData}`;
const projectUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.getProjectByForecast}`;
const hubSpotDealsUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.getallhubspotdeals}`;
const loadingWeekUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.deliveryInfoes}`;
const companiesUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}`;
const deleteFileUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.deleteFile}`;
const searchProjectUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.searchProjectName}`;
const projectDraftUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.projectDraft}`;
const draftProjectByRoleUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.draftProjectByRole}`;

const ProjectStepper = React.memo(
  ({ steps, activeStep, completed, handleStep }) => {
    const theme = useTheme();
    const stepRefs = useRef([]);
    const prevStepRef = useRef(activeStep);

    useEffect(() => {
      if (prevStepRef.current !== activeStep) {
        stepRefs.current[activeStep]?.scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "nearest",
        });

        prevStepRef.current = activeStep;
      }
    }, [activeStep]);

    return (
      <div
        style={{
          overflowX: "auto",
          overflowY: "hidden",
          width: "100%",
          padding: "12px 0",
        }}
      >
        <Stepper
          activeStep={activeStep}
          alternativeLabel
          style={{ minWidth: steps.length * 120 }}
          sx={{
            "& .MuiStepIcon-root": {
              color: theme.palette.grey[400],
            },
            "& .MuiStepIcon-text": {
              fill: theme.palette.common.white,
            },

            "& .MuiStepIcon-root.Mui-active": {
              color: theme.palette.secondary.main,
            },

            "& .MuiStepIcon-root.Mui-completed": {
              color: theme.palette.success.main,
            },

            "& .MuiStepLabel-label": {
              color: theme.palette.text.secondary,
            },

            "& .MuiStepLabel-label.Mui-active": {
              color: theme.palette.text.primary,
              fontWeight: 600,
            },

            "& .MuiStepLabel-label.Mui-completed": {
              color: theme.palette.text.primary,
            },
            "& .MuiStepConnector-line": {
              borderColor: theme.palette.divider,
            },
          }}
        >
          {steps?.map((label, index) => (
            <Step
              key={index}
              completed={completed[index]}
              ref={(el) => (stepRefs.current[index] = el)}
            >
              <StepButton
                onClick={(e) => {
                  e.stopPropagation();
                  handleStep(index)();
                }}
              >
                TYPE {label.typeName.toUpperCase()}
              </StepButton>
            </Step>
          ))}
        </Stepper>
      </div>
    );
  },
);

const ModalToast = ({ message, show }) => {
  const theme = useTheme();

  if (!show) return null;

  return (
    <div className="absolute top-6 left-1/2 transform -translate-x-1/2 z-50 transition-opacity duration-500">
      <div
        className="flex items-center px-8 py-6 rounded-lg shadow-lg max-w-xs w-full opacity-100"
        style={{
          backgroundColor: theme.palette.background.paper,
          color: theme.palette.text.primary,
          border: `4px solid ${theme.palette.error.main}`,
        }}
      >
        <ErrorOutlineOutlinedIcon
          sx={{
            color: theme.palette.error.main,
            mr: 1.5,
            fontSize: "1.25rem",
          }}
        />
        <span className="text-md">{message}</span>
      </div>
    </div>
  );
};

const CreateOrder = (props) => {
  const { mode } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"), {
    noSsr: true,
  });
  // const [activeStep, setActiveStep] = useState(0);
  const { id } = useParams();
  const [open, setOpen] = useState(false);
  const [openSuccessOrder, setOpenSuccessOrder] = useState(false);
  const [projectOverviewOpen, setProjectOverviewOpen] = useState(false);
  const [showPaginationDropdown, setShowPaginationDropdown] = useState(false);
  const navigate = useNavigate();
  const [orderCategoryValue, setOrderCategoryValue] = useState();
  const [qtyValue, setQtyValue] = useState(1);
  const [rowData, setRowData] = useState([]);
  const [phasesRowData, setPhasesRowData] = useState([]);
  const [typeRowData, setTypeRowData] = useState([]);
  const [selectedValue, setSelectedValue] = useState(1);
  const gridRef = useRef();
  const phaseGridRef = useRef();
  const typeGridRef = useRef();
  const [gridApi, setGridApi] = useState(null);
  const [selectedQty, setSelectedQty] = useState("");
  const [selectedPhases, setSelectedPhases] = useState("");
  const [typesPhaseQty, setTypesPhaseQty] = useState("");
  const [showType, setShowType] = useState(false);
  const [showProjectTypeQty, setShowProjectTypeQty] = useState(false);
  const [displayName, setDisplayName] = useState("");
  const [phaseNameCode, setPhaseNameCode] = useState("");
  const [phasesTotalValue, setPhasesTotalValue] = useState(0);
  const [typeTotalValue, setTypeTotalValue] = useState(0);
  const [showAlert, setShowAlert] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [showPhasesAlert, setShowPhasesAlert] = useState(false);
  const [InitialPhaseQty, setInitialPhaseQty] = useState("");
  const [initialQty, setInitialQty] = useState("");
  const [initialRowData, setInitialRowData] = useState("");
  const [newPhases, setNewPhase] = useState("");
  const [newQty, setNewQty] = useState("");
  const [apiProjectTypes, setApiProjectTypes] = useState([]);
  const [originalPhasesRowData, setOriginalPhasesRowData] = useState([]);
  const [formValues, setFormValues] = useState([
    {
      range: {},
      priceGroup: {},
      color: {},
      carcass: {},
      handle: {},
    },
  ]);
  const [uploadValue, setUploadValue] = useState([{ uploadFile: null }]);
  const [vendors, setVendors] = useState([]);
  const [range, setRange] = useState([]);
  const [color, setColor] = useState([]);
  const [priceGroup, setPriceGroup] = useState([]);
  const [handles, setHandles] = useState([]);
  const [carcass, setCarcass] = useState([]);
  const [error, setError] = useState();
  const [checksubmit, setCheckSubmit] = useState(false);
  const [validError, setValidError] = useState({});
  const [snackState, setSnackState] = useState(false);
  const [successMsg, setSuccessMsg] = useState();
  const [customerId, setCustomerId] = useState();
  const [currentOrder, setCurrentOrder] = useState([]);
  const [customerName, setCustomerName] = useState("");
  const [selectedPartner, setSelectedPartner] = useState(null);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [showroom, setShowroom] = useState(null);
  const [hubspot, setHubspot] = useState();
  const [product, setProduct] = useState();
  const [draftOrder, setDraftOrder] = useState();
  const [category, setCategory] = useState();
  const [orderReference, setOrderReference] = useState("");
  const [prjOrderReference, setPrjOrderReference] = useState("");
  const [typeNumber, setTypeNumber] = useState("");
  const [uniqueID, setUniqueID] = useState("");
  const bqSubAccounts = {
    30097: "NR1",
    30098: "NR2",
    30099: "NR3",
    30100: "NQ1",
    30107: "NR5",
    30201: "NJ3",
    30127: "NJ2",
    30133: "NTF1",
    30142: "ND1",
    30101: "NJ1",
    30108: "NMK1",
    30134: "NT1",
    30102: "NK1",
    30103: "NK2",
    30104: "NH1",
    30106: "NF1",
    30109: "DM1",
    30141: "NZ1",
    30105: "NM1",
  };
  const [isUniqueIdChecking, setIsUniqueIdChecking] = useState(false);
  const [isUniqueIdDuplicate, setIsUniqueIdDuplicate] = useState(false);
  const [clientName, setClientName] = useState("");
  const [commissionName, setCommissionName] = useState();
  const [WG1Price, setWG1Price] = useState("");
  const [WG2Price, setWG2Price] = useState("");
  const [totalWGPrice, setTotalWGPrice] = useState("");
  const [volume, setVolume] = useState("");
  const [weight, setWeight] = useState("");
  const [selectedRange, setSelectedRange] = useState({});
  const [selectedColor, setSelectedColor] = useState({});
  const [selectedCarcass, setSelectedCarcass] = useState({});
  const [selectedHandle, setSelectedHandle] = useState({});
  const [containerNo, setContainerNo] = useState();
  const [loadingWeek, setLoadingWeek] = useState();
  const [freight, setFreight] = useState();
  const [comment, setComment] = useState();
  const [discountChecked, setDiscountChecked] = useState(false);
  const [showroomOptions, setShowroomOptions] = useState([]);
  const [loadingWeekOptions, setLoadingWeekOptions] = useState([]);
  const [newOrderData, setNewOrderData] = useState([]);
  const [typeOrderData, setTypeOrderData] = useState([]);
  const [productOptions, setProductOptions] = useState([]);
  const [freightOptions, setFreightOptions] = useState([]);
  const [orderCategoryOptions, setOrderCategoryOptions] = useState([]);
  const [hubSpot, setHubSpot] = useState(false);
  const [btnDisable, setBtnDisable] = useState(true);
  const [loading, setLoading] = useState(false);
  const [SDFile, setSDFile] = useState(null);
  const [DRWFile, setDRWFile] = useState(null);
  const [sdFileId, setSdFileId] = useState("");
  const [drwFileId, setDrwFileId] = useState("");
  const [PRWFile, setPRWFile] = useState(null);
  const [prwFileId, setPrwFileId] = useState("");
  const [appliancesDetailFileId, setAppliancesDetailFileId] = useState("");
  const [orderCheckFileId, setOrderCheckFileId] = useState("");
  const [drawingFileId, setDrawingFileId] = useState("");
  const [appliancesDetail, setAppliancesDetail] = useState(null);
  const [orderCheckFile, setOrderCheckFile] = useState(null);
  const [drawingFile, setDrawingFile] = useState(null);
  const [sharedLater, setSharedLater] = useState(false);
  const [prwSelected, setPrwSelected] = useState(false);
  const [isPRWFile, setIsPRWFile] = useState(false);
  const [notApplicable, setNotApplicable] = useState(false);
  const [drwFileSupersedes, setDrwFileSupersedes] = useState(false);
  const [productIdNull, setProductIdNull] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isSubmitEnabled, setIsSubmitEnabled] = useState(true);
  const [projectForeCast, setProjectForeCast] = useState([]);
  const [foreCastProduct, setForeCastProduct] = useState(null);
  const [draftOrderOptions, setDraftOrderOptions] = useState([]);
  const [draftList, setDraftList] = useState();
  const [selectedDraftOrder, setSelectedDraftOrder] = useState();
  const [isDraftOrder, setIsDraftOrder] = useState(false);
  const [dealOptions, setDealOptions] = useState(null);
  const [selectedDeal, setSelectedDeal] = useState(null);
  const [selectedReferenceHubSpot, setSelectedReferenceHubSpot] = useState("");
  const [exitingProject, setExitingProject] = useState([]);
  const [deals, setDeals] = useState([]);
  const [costOfHubSpot, setCostOfHubSpot] = useState(0);
  const [hubSpotReference, setHubSpotReference] = useState("");
  const [defaultProductOption, setDefaultProductOption] = useState(null);
  const [activeStep, setActiveStep] = useState(0);
  const [completed, setCompleted] = useState({});
  const dispatch = useDispatch();
  const hiddenDRWFile = useRef(null);
  const hiddenDicountFile = useRef(null);
  const hiddenADFile = useRef(null);
  const hiddenOrderCheckFile = useRef(null);
  const hiddenDrawingFile = useRef(null);
  const [projectOptions, setProjectOptions] = useState([]);
  const [existingProjectOptions, setExistingProjectOptions] = useState([]);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [selectedProName, setSelectedProName] = useState(null);
  const [currentQuery, setCurrentQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [isSectionVisible, setIsSectionVisible] = useState(false);
  const [draftId, setDraftId] = useState();
  const [editPhases, setEditPhases] = useState(false);
  const [steps, setSteps] = useState();
  const [draftProjectInfo, setDraftProjectInfo] = useState([]);
  const [lastEdited, setLastEdited] = useState(null);
  const [originalQty, setOriginalQty] = useState(null);
  const [prjOrderChanged, setPrjOrderChange] = useState(false);
  const [placeOrderBtnDisable, setPlaceOrderBtnDisable] = useState(false);
  const [isPasting, setIsPasting] = useState(false);
  const TOTAL_MAX_LENGTH = 21;
  const negativeQtyRef = useRef(false);
  const zeroQtyRef = useRef(false);
  const pageSize = 30;
  const rowDataSaved = useSelector((state) => state.project.rowData);
  const previousStepRowData = useSelector((state) => state.project.stepData);
  const hasBack = useSelector((state) => state.project.hasBack);
  const hasBackForm = useSelector((state) => state.project.hasBackOrderForm);
  const orderFormData = useSelector((state) => state.project.orderFormData);
  const [showToastMsg, setShowToastMsg] = useState(false);
  const [openDeleteModel, setOpenDeleteModel] = useState(false);
  const [selectedDeleteOption, setSelectedDeleteOption] = useState(null);
  const [savedDraft, setSavedDraft] = useState(null);
  const token =
    localStorage &&
    localStorage.getItem("token") &&
    jwtDecode(localStorage.getItem("token"));

  const hasSupperUser = [
    "ROLE_ADMIN",
    "ROLE_MD",
    "ROLE_ORDERPRO",
    "ROLE_SOPDIR",
  ].some((role) => {
    if (token) {
      return token.scope.includes(role);
    }
  });

  const KEY_BACKSPACE = "Backspace";
  const KEY_F2 = "F2";
  const KEY_ENTER = "Enter";
  const KEY_TAB = "Tab";
  const TOTAL_LENGTH = 21;
  const currentCustomer = hasSupperUser ? selectedPartner?.value : customerId;
  const [uniqueIdSuffix, setUniqueIdSuffix] = useState(null);
  const kOptions = Array.from({ length: 10 }, (_, i) => ({
    value: `K${i + 1}`,
    label: `K${i + 1}`,
  }));
  const fullUniqueID =
    currentCustomer === 30004 && uniqueIdSuffix
      ? `${uniqueID}-${uniqueIdSuffix.value}`
      : uniqueID;

  const suffixLength =
    currentCustomer === 30004 && uniqueIdSuffix
      ? uniqueIdSuffix.value.length + 1
      : 0;
  const maxUniqueIdLength =
    TOTAL_LENGTH - clientName.length - suffixLength > 0
      ? TOTAL_LENGTH - clientName.length - suffixLength
      : 0;

  const maxClientNameLength =
    TOTAL_LENGTH - fullUniqueID.length > 0
      ? TOTAL_LENGTH - fullUniqueID.length
      : 0;
  const NumericEditor = memo(
    forwardRef((props, ref) => {
      const createInitialState = () => {
        let startValue;
        let highlightAllOnFocus = true;
        const eventKey = props.eventKey;

        if (eventKey === KEY_BACKSPACE) {
          startValue = "";
        } else if (eventKey && eventKey.length === 1) {
          startValue = eventKey;
          highlightAllOnFocus = false;
        } else {
          startValue = props.value;
          if (props.eventKey === KEY_F2) {
            highlightAllOnFocus = false;
          }
        }

        return {
          value: startValue,
          highlightAllOnFocus,
        };
      };

      const initialState = createInitialState();
      const [value, setValue] = useState(initialState.value);
      const [highlightAllOnFocus, setHighlightAllOnFocus] = useState(
        initialState.highlightAllOnFocus,
      );
      const refInput = useRef(null);

      useEffect(() => {
        const eInput = refInput.current;
        eInput.focus();
        if (highlightAllOnFocus) {
          eInput.select();
          setHighlightAllOnFocus(false);
        } else {
          const length = eInput.value ? eInput.value.length : 0;
          if (length > 0) {
            eInput.setSelectionRange(length, length);
          }
        }
      }, []);

      const cancelBeforeStart =
        props.eventKey &&
        props.eventKey.length === 1 &&
        "1234567890".indexOf(props.eventKey) < 0;

      const isLeftOrRight = (event) => {
        return ["ArrowLeft", "ArrowLeft"].indexOf(event.key) > -1;
      };

      const isCharNumeric = (charStr) => {
        return !!/\d/.test(charStr);
      };

      const isNumericKey = (event) => {
        const charStr = event.key;
        return isCharNumeric(charStr);
      };

      const isBackspace = (event) => {
        return event.key === KEY_BACKSPACE;
      };

      const finishedEditingPressed = (event) => {
        const key = event.key;
        return key === KEY_ENTER || key === KEY_TAB;
      };

      const onKeyDown = (event) => {
        // Let OS/browser shortcuts (paste, copy, cut, select-all, undo) through
        // untouched — otherwise Ctrl+V's "v" keydown gets treated as a bad
        // character and blocked before the browser can paste anything.
        if (event.ctrlKey || event.metaKey) {
          return;
        }

        if (isLeftOrRight(event) || isBackspace(event)) {
          event.stopPropagation();
          return;
        }

        if (!finishedEditingPressed(event) && !isNumericKey(event)) {
          if (event.preventDefault) event.preventDefault();
        }

        if (finishedEditingPressed(event)) {
          props.stopEditing();
        }
      };

      useImperativeHandle(ref, () => {
        return {
          getValue() {
            if (value === "" || value == null) return null;
            const parsed = parseInt(value, 10);
            // Reject non-numeric paste content instead of silently
            // returning NaN, which would corrupt total calculations.
            return isNaN(parsed) ? null : parsed;
          },

          isCancelBeforeStart() {
            return cancelBeforeStart;
          },

          isCancelAfterEnd() {
            const finalValue = this.getValue();
            return finalValue != null && finalValue > 1000000;
          },
        };
      });

      return (
        <input
          ref={refInput}
          value={value}
          onChange={(event) => setValue(event.target.value)}
          onKeyDown={(event) => onKeyDown(event)}
          className="numeric-input"
        />
      );
    }),
  );
  const ExpectWeekEditor = forwardRef((props, ref) => {
    const getWeekUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.getWeek}`;
    const [selectedWeek, setSelectedWeek] = useState(() =>
      props.value ? { label: props.value, value: props.value } : null,
    );
    const [weekOption, setWeekOption] = useState([]);
    const [actualLoadingDate, setActualLoadingDate] = useState(
      moment().add(7, "weeks").format("YYYY-MM-DD"), // Default to current date + 7 weeks
    );
    useEffect(() => {
      const getLoadingWeekList = async () => {
        try {
          const list = await OAuthService.getList(
            `${getWeekUrl}?date=${actualLoadingDate}`,
          );
          const week = list.data;

          if (week) {
            let defaultWeek = week;
            const generateDateStrings = (startYear) => {
              const result = [];
              let weeks = defaultWeek;
              for (let year = startYear; year <= startYear + 4; year++) {
                if (year === startYear) {
                  weeks = defaultWeek;
                } else {
                  weeks = 1;
                }
                for (; weeks <= 52; weeks++) {
                  result.push({
                    value: weeks,
                    label: `${weeks}/${year}`,
                    year,
                  });
                }
              }
              return result;
            };

            const currentYear = moment().add(7, "weeks").year();
            const weekOptions = generateDateStrings(currentYear);
            setWeekOption(weekOptions);
          }
        } catch (error) {
          console.error("Error fetching loading weeks", error);
        }
      };

      getLoadingWeekList();
    }, [actualLoadingDate]);

    const handleChangeWeek = (option) => {
      setSelectedWeek(option);

      if (props.node && props.node.data) {
        props.node.setDataValue("year", option.year);
      }
    };

    useImperativeHandle(ref, () => ({
      getValue() {
        return selectedWeek?.label || "";
      },
    }));

    return (
      <Box
        style={{ width: 250, padding: "2px" }}
        onKeyDownCapture={(e) => {
          if (e.key === "Tab") {
            e.preventDefault();
            e.stopPropagation();
            if (selectedWeek) {
              props.node.setDataValue("year", selectedWeek.year);
            }
            props.stopEditing();
          }
        }}
      >
        <Select
          value={selectedWeek}
          options={weekOption}
          onChange={handleChangeWeek}
          styles={customStyles()}
          className="w-full"
          menuPlacement="auto"
          menuPosition="fixed"
          tabSelectsValue={false}
        />
      </Box>
    );
  });
  const CustomTextEditorPhaseName = forwardRef((props, ref) => {
    const [value, setValue] = useState(props.value || "");

    const handleChange = (event) => {
      setValue(event.target.value);
    };

    useImperativeHandle(ref, () => ({
      getValue: () => {
        const validationValue = value.toUpperCase();

        if (validationValue.trim() === "") {
          setToastMessage("Phase Name cannot be empty or spaces only!");
          setShowToast(true);
          setTimeout(() => setShowToast(false), 5000);
          return props.value; // reject — keep old value
        }

        const specialCharRegex = /^[A-Z0-9()_\- ]*$/;
        if (!specialCharRegex.test(validationValue)) {
          setToastMessage("Special characters are not allowed!");
          setShowToast(true);
          setTimeout(() => setShowToast(false), 5000);
          return props.value;
        }

        return validationValue.trim();
      },
    }));

    return (
      <input
        type="text"
        value={value}
        onChange={handleChange}
        autoFocus
        style={{
          width: "100%",
          height: "100%",
          border: "none",
          outline: "none",
          textTransform: "uppercase",
          backgroundColor: "transparent",
          color: "inherit",
        }}
      />
    );
  });
  const CustomTextEditorType = forwardRef((props, ref) => {
    const [value, setValue] = useState(props.value || "");

    const handleChange = (event) => {
      const rawValue = event.target.value;
      const validationValue = rawValue.toUpperCase();

      if (validationValue.trim() === "" && rawValue !== "") {
        setToastMessage("Type Name cannot be spaces only!");
        setShowToast(true);
        setTimeout(() => setShowToast(false), 5000);
        return;
      }

      const specialCharRegex = /^[A-Z0-9()_\- ]*$/;
      if (!specialCharRegex.test(validationValue)) {
        setToastMessage("Special characters are not allowed!");
        setShowToast(true);
        setTimeout(() => setShowToast(false), 5000);
        return;
      }

      if (validationValue.includes("/") || validationValue.includes("\\")) {
        setToastMessage("Type Name must not contain '/' or '\\'.");
        setShowToast(true);
        setTimeout(() => setShowToast(false), 5000);
        return;
      }

      setValue(rawValue);
    };

    useImperativeHandle(ref, () => ({
      getValue: () => value.trim().toUpperCase(),
    }));

    return (
      <input
        type="text"
        value={value}
        onChange={handleChange}
        autoFocus
        style={{
          width: "100%",
          height: "100%",
          border: "none",
          outline: "none",
          textTransform: "uppercase",
          backgroundColor: "transparent",
          color: "inherit",
        }}
      />
    );
  });
  const sanitizeTypeName = (rawValue) => {
    if (rawValue === undefined || rawValue === null)
      return { ok: false, value: "" };

    let value = String(rawValue).toUpperCase();

    if (value.trim() === "" && value !== "") {
      return { ok: false, reason: "Type Name cannot be spaces only!" };
    }

    const specialCharRegex = /^[A-Z0-9()_\- ]*$/;
    if (!specialCharRegex.test(value)) {
      return { ok: false, reason: "Special characters are not allowed!" };
    }

    if (value.includes("/") || value.includes("\\")) {
      return { ok: false, reason: "Type Name must not contain '/' or '\\'." };
    }

    return { ok: true, value: value.trim() };
  };
  const sanitizeQtyRows = useCallback(() => {
    if (!gridRef.current?.api) return;
    let hadInvalid = false;

    gridRef.current.api.forEachNode((node) => {
      const raw = node.data.qty;
      if (raw === "" || raw === null || raw === undefined) return;

      const isValid = /^\d+$/.test(String(raw).trim());
      if (!isValid) {
        hadInvalid = true;
        node.setDataValue("qty", 0);
      }
    });

    if (hadInvalid) {
      setToastMessage(
        "Only numeric values are allowed in Quantity — invalid entries were reset to 0",
      );
      setShowToast(true);
      setTimeout(() => setShowToast(false), 5000);
    }
  }, []);
  const columnDefs = useMemo(
    () => [
      { headerName: "Sno.", valueGetter: "node.rowIndex + 1", maxWidth: 70 },
      {
        field: "typeName",
        editable: true,
        valueFormatter: (params) =>
          params.value ? params.value.toUpperCase() : "",
        cellEditor: CustomTextEditorType,
        valueSetter: (params) => {
          const result = sanitizeTypeName(params.newValue);
          if (!result.ok) {
            setToastMessage(result.reason);
            setShowToast(true);
            setTimeout(() => setShowToast(false), 5000);
            return false;
          }
          params.data.typeName = result.value;
          return true;
        },

        processCellFromClipboard: (params) => {
          const result = sanitizeTypeName(params.value);
          if (!result.ok) {
            setToastMessage(result.reason);
            setShowToast(true);
            setTimeout(() => setShowToast(false), 5000);
            return params.node.data.typeName || "";
          }
          return result.value;
        },
      },
      {
        field: "qty",
        editable: true,
        cellEditor: NumericEditor,
        valueParser: (params) => {
          const newValue = parseInt(params.newValue, 10);
          return isNaN(newValue) || newValue < 0 ? null : newValue;
        },
        processCellFromClipboard: (params) => {
          const raw = params.value == null ? "" : String(params.value).trim();
          const isValidQty = /^\d+$/.test(raw);

          if (!isValidQty) {
            setToastMessage("Only numeric values are allowed in Quantity");
            setShowToast(true);
            setTimeout(() => setShowToast(false), 5000);
            return params.node.data.qty ?? "";
          }
          return parseInt(raw, 10);
        },
      },
    ],
    [],
  );

  const phasesColumnDefs = useMemo(
    () => [
      {
        field: "id",
        headerName: "Sno.",
        valueGetter: "node.rowIndex + 1",
        maxWidth: 70,
      },
      {
        field: "phaseName",
        editable: (params) => !params.data.orderPlaced,
        cellEditor: CustomTextEditorPhaseName,
        valueFormatter: (params) =>
          params.value ? params.value.toUpperCase() : "",
        processCellFromClipboard: (params) => {
          const raw = params.value ? String(params.value).trim() : "";
          if (raw === "") {
            setToastMessage("Phase Name cannot be empty!");
            setShowToast(true);
            setTimeout(() => setShowToast(false), 5000);
            return params.node.data.phaseName || "";
          }
          return raw.toUpperCase();
        },
      },
      {
        field: "qty",
        headerName: "Qty/Phase",
        maxWidth: 100,
        cellEditor: NumericEditor,
        hide: true,
      },
      {
        field: "phaseViseQty",
        headerName: "Qty/Phase",
        maxWidth: 100,
        editable: (params) => !params.data.orderPlaced,
        cellEditor: NumericEditor,
        valueParser: (params) => {
          const newValue = parseFloat(params.newValue);
          return isNaN(newValue) || newValue < 0 ? null : newValue;
        },

        processCellFromClipboard: (params) => {
          const value = parseFloat(params.value);
          return isNaN(value) || value < 0 ? null : value;
        },
      },
      {
        field: "expectedProductionWeek",
        headerName: "Expected Week",
        editable: (params) => !params.data.orderPlaced,
        cellEditorPopup: true,
        cellEditorPopupPosition: "under",
        minWidth: 200,
        cellEditor: ExpectWeekEditor,
        suppressKeyboardEvent: (params) => {
          const { event } = params;

          return (
            (event.ctrlKey || event.metaKey) && event.key.toLowerCase() === "v"
          );
        },
      },
      {
        field: "year",
        headerName: "Year",
        editable: false,
      },
    ],
    [product],
  );

  const CustomTextEditor = forwardRef((props, ref) => {
    const [value, setValue] = useState(props.value || "");

    const handleChange = (event) => {
      const rawValue = event.target.value;
      setValue(rawValue);
    };

    useImperativeHandle(ref, () => ({
      getValue: () => {
        const validationValue = value.toUpperCase();

        if (validationValue.trim() === "") {
          toast.warning("Unique ID cannot be empty or spaces only!");
          return props.value;
        }

        const specialCharRegex = /^[A-Z0-9()_\- ]*$/;
        if (!specialCharRegex.test(validationValue)) {
          toast.warning("Special characters are not allowed!");
          return props.value;
        }

        if (validationValue.includes("/") || validationValue.includes("\\")) {
          toast.warning("Unique ID must not contain '/' or '\\'.");
          return props.value;
        }

        return validationValue.trim();
      },
    }));

    return (
      <input
        type="text"
        value={value}
        onChange={handleChange}
        autoFocus
        style={{
          width: "100%",
          height: "100%",
          border: "none",
          outline: "none",
          textTransform: "uppercase",
          backgroundColor: "transparent",
          color: "inherit",
        }}
      />
    );
  });

  const typeColumnDefs = useMemo(
    () => [
      { headerName: "Sno.", valueGetter: "node.rowIndex + 1", maxWidth: 70 },
      {
        field: "typeName",
        valueFormatter: (params) =>
          params.value ? params.value.toUpperCase() : "",
      },
      {
        field: "uniqId",
        editable: true,
        valueFormatter: (params) =>
          params.value ? params.value.toUpperCase() : "",
        cellEditor: CustomTextEditor,
        valueSetter: (params) => {
          const result = sanitizeTypeName(params.newValue);
          if (!result.ok) {
            setToastMessage(result.reason);
            setShowToast(true);
            setTimeout(() => setShowToast(false), 5000);
            return false;
          }
          params.data.uniqId = result.value;
          return true;
        },

        processCellFromClipboard: (params) => {
          const result = sanitizeTypeName(params.value);
          if (!result.ok) {
            setToastMessage(result.reason);
            setShowToast(true);
            setTimeout(() => setShowToast(false), 5000);
            return params.node.data.uniqId || "";
          }
          return result.value;
        },
      },
      {
        field: "commisionName",
        valueFormatter: (params) =>
          params.value ? params.value.toUpperCase() : "",
      },
    ],
    [],
  );
  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
  }, []);
  const onGridReadyType = (params) => {
    gridRef.current = params.api;
    setTimeout(() => {
      const firstRow = params.api.getDisplayedRowAtIndex(0);
      if (firstRow) {
        params.api.forEachNode((node) => node.setSelected(node === firstRow));
      }
    }, 100);
  };
  const onGridReadyPhaseGrid = (params) => {
    const { api } = params;
    // When grid is ready, select the first row where orderPlaced is false.
    if (phasesRowData.length > 0) {
      let firstSelectableIndex = -1;
      for (let i = 0; i < phasesRowData.length; i++) {
        if (!phasesRowData[i].orderPlaced) {
          firstSelectableIndex = i;
          break;
        }
      }
      if (firstSelectableIndex !== -1) {
        api.forEachNode((node) => {
          if (node.rowIndex === firstSelectableIndex) {
            node.setSelected(true);
            api.ensureIndexVisible(firstSelectableIndex);
          }
        });
        setSelectedRows(api.getSelectedRows());
      }
    }
  };

  const onSelectionChanged = (params) => {
    const api = params.api;
    let selectedRow = api.getSelectedRows()[0];
    let selectedNode = api.getSelectedNodes()[0];

    setSelectedRows(api.getSelectedRows());

    if (!isDraftOrder && !prjOrderChanged) {
      setTypesPhaseQty(hasBackForm ? orderFormData.typesPhaseQty : "");
      setTypeTotalValue(hasBackForm ? orderFormData.typeTotalValue : 0);
      setRowData(hasBackForm ? orderFormData.rowData : []);
    }
    setShowAlert(false);

    if (selectedNode) {
      setPhaseNameCode(
        `P${(selectedNode.rowIndex + 1).toString().padStart(3, "0")}`,
      );
    } else {
      setPhaseNameCode("");
    }

    let firstSelectableIndex = -1;
    for (let i = 0; i < phasesRowData.length; i++) {
      if (!phasesRowData[i].orderPlaced) {
        firstSelectableIndex = i;
        break;
      }
    }
    if (firstSelectableIndex !== -1) {
      if (
        !selectedNode ||
        selectedNode.rowIndex !== firstSelectableIndex ||
        selectedNode.data.orderPlaced === true
      ) {
        api.deselectAll();
        api.getRowNode(firstSelectableIndex).setSelected(true);
      }
    }

    selectedRow = api.getSelectedRows()[0];
    setTypeTotalValue(api.getSelectedRows()[0]?.phaseViseQty || 0);
    runMasterValidation(api.getSelectedNodes()[0]);
  };

  // useEffect(() => {
  //   if (phasesRowData && phasesRowData.length > 0) {

  //     const allRowsValid = phasesRowData.every(row =>
  //       Number(row.phaseViseQty) > 0 &&
  //      row.expectedProductionWeek !== null &&
  //     row.expectedProductionWeek !== ""
  //     );
  //     const totalPhaseQty = phasesRowData.reduce(
  //       (sum, row) => sum + Number(row.phaseViseQty || 0), 0
  //     );

  //     const totalMatchesQty = totalPhaseQty === Number(selectedQty);
  //     setIsSubmitEnabled(!(allRowsValid && totalMatchesQty));
  //   } else {
  //     setIsSubmitEnabled(true);
  //   }
  // }, [phasesRowData, selectedQty]);

  useEffect(() => {
    const currentCustomer = hasSupperUser ? selectedPartner?.value : customerId;
    if (
      currentCustomer === 30004 &&
      showroom?.value &&
      bqSubAccounts[showroom.value]
    ) {
      const prefix = `${bqSubAccounts[showroom.value]}-`;
      setUniqueID(prefix);
      setIsUniqueIdDuplicate(false);
    } else {
      setUniqueID("");
      setIsUniqueIdDuplicate(false);
    }
  }, [showroom, selectedPartner, customerId]);

  useEffect(() => {
    const checkUniqueId = async () => {
      if (currentCustomer !== 30004) {
        setIsUniqueIdDuplicate(false);
        return;
      }

      let requiredPrefix = "";
      if (showroom?.value && bqSubAccounts[showroom.value]) {
        requiredPrefix = `${bqSubAccounts[showroom.value]}-`;
      }

      if (!fullUniqueID || fullUniqueID === requiredPrefix) {
        setIsUniqueIdDuplicate(false);
        return;
      }

      setIsUniqueIdChecking(true);
      try {
        const url = `${
          process.env.REACT_APP_RESOURCE_API_KEY_URL
        }/api/orders/search/existsByDocumentTypeAndCustomerNumAndUniqueId?documentType=SO&customerNum=${currentCustomer}&uniqueId=${encodeURIComponent(
          fullUniqueID,
        )}`;
        const response = await OAuthService.getList(url);
        if (response.data === true) {
          setIsUniqueIdDuplicate(true);
          toast.error(
            "This Unique ID already exists. Please enter a different one.",
          );
        } else {
          setIsUniqueIdDuplicate(false);
        }
      } catch (err) {
        console.error("Unique ID check failed:", err);
      } finally {
        setIsUniqueIdChecking(false);
      }
    };

    const timer = setTimeout(checkUniqueId, 1000);
    return () => clearTimeout(timer);
  }, [
    uniqueID,
    uniqueIdSuffix,
    showroom,
    selectedPartner,
    customerId,
    fullUniqueID,
  ]);

  const getNewOrder = async () => {
    let list;
    let newOrder = null;
    try {
      if (mode === "new") {
        if (hasSupperUser) {
          if (selectedPartner) {
            list = await OAuthService.getList(
              newOrderUrl + `?customerId=${selectedPartner?.value}`,
            );
            newOrder = list?.data;
          } else {
            //list = await OAuthService.getList(newOrderUrl + `?customerId=${token.company}`);
            //newOrder = list?.data;
          }
        } else {
          list = await OAuthService.getList(newOrderUrl);
          newOrder = list?.data;
        }
        if (newOrder) {
          const products = newOrder?.products.map((value) => {
            return {
              label: value.name,
              value: value.shortKey,
              id: value.id,
            };
          });

          const loadingWeek = Object.keys(newOrder?.loadingWeek).map((key) => ({
            value: key,
            label: newOrder.loadingWeek[key],
          }));
          const showrooms = Object.keys(newOrder?.showrooms).map((key) => ({
            value: key,
            label: newOrder.showrooms[key],
          }));
          // console.log('showrooms', showrooms)
          // const filterOrderCategory = newOrder?.orderCategories.filter(
          //   (item) => item.name !== "SAM"
          // );
          const orderCategories = newOrder?.orderCategories.map((value) => {
            return { label: `${value.displayName}`, value: value.name };
          });
          const freight = newOrder?.freightOptions.map((value) => {
            return {
              label: `${value.shippingMethodName}`,
              value: value.shippingMethodName,
              id: value.code,
            };
          });
          setShowroom({
            value: newOrder?.showroomId,
            label: newOrder?.showroomName,
          });
          setFreightOptions(freight);
          setOrderCategoryOptions(orderCategories);
          setProductOptions(products);
          setForeCastProduct(products);
          setDefaultProductOption(products);
          setLoadingWeekOptions(loadingWeek);
          setShowroomOptions(showrooms);
          setCustomerName(newOrder?.companyName);
          setCustomerId(newOrder?.partnerCompany);
          setOrderReference(newOrder?.projectNum);
          setTypeNumber(newOrder?.typeNumber);
          setUniqueID(newOrder?.uniqueId === null ? "" : newOrder?.uniqueId);
          setClientName(
            newOrder?.clientName === null ? "" : newOrder?.clientName,
          );
          setHubSpot(newOrder);
          setNewOrderData(newOrder);
        }
        //return { products, showrooms, loadingWeek, orderCategories, freight };
      }
    } catch (error) {
      console.log("error.message", error);
      toast.error(error.message);
    }
  };
  const getNewOrderType = async () => {
    try {
      if (mode === "new-type") {
        const list = await OAuthService.getList(`${newOrderUrl}/${id}`);
        const typeOrder = list.data;
        setTypeOrderData(typeOrder);
        const products = typeOrder?.products.map((value) => {
          return {
            label: value.name,
            value: value.shortKey,
            id: value.id,
          };
        });
        const findProduct = products.find(
          (product) => typeOrder.product === product.id,
        );
        const loadingWeek = Object.keys(typeOrder?.loadingWeek).map((key) => ({
          value: key,
          label: typeOrder.loadingWeek[key],
        }));
        const freight = typeOrder?.freightOptions.map((value) => {
          return {
            label: `${value.shippingMethodName}`,
            value: value.shippingMethodName,
            id: value.code,
          };
        });
        setProduct({
          label: findProduct.label,
          value: findProduct.value,
          id: findProduct.id,
        });
        setOrderCategoryValue({
          label: typeOrder.orderCategory,
          value: typeOrder.orderCategory,
        });
        setProductOptions(products);
        setDefaultProductOption(products);
        setShowroom({
          value: typeOrder.showroomId,
          label: typeOrder.showroomName,
        });
        setClientName(typeOrder?.clientName);
        setCustomerName(typeOrder?.companyName);
        setCustomerId(typeOrder?.partnerCompany);
        setOrderReference(typeOrder?.projectNum);
        setTypeNumber(typeOrder?.typeNumber);
        setLoadingWeekOptions(loadingWeek);
        setFreightOptions(freight);
        setUniqueID("");
        setWG1Price("");
        setWG2Price("");
        setVolume("");
        setWeight("");
        setContainerNo("");
        setLoadingWeek(null);
        setFreight(null);
        setComment("");
        setDRWFile("");
        setDrwFileId("");
        setAppliancesDetail("");
        setAppliancesDetailFileId("");
        setOrderCheckFile("");
        setOrderCheckFileId("");
        setDrawingFile("");
        setDrawingFileId("");
        setSDFile("");
        setSdFileId("");
        setDiscountChecked(false);
        setSharedLater(false);
        setNotApplicable(false);
        setDrwFileSupersedes(false);
        setFormValues([
          {
            range: {},
            priceGroup: {},
            color: {},
            carcass: {},
            handle: {},
          },
        ]);
        setUploadValue([{ uploadFile: null }]);
        // if (typeOrder.deal) {
        //   setSelectedDeal({
        //     value: typeOrder?.deal?.properties?.hs_object_id,
        //     label: typeOrder?.deal?.properties?.dealname,
        //     referenceNumber: typeOrder?.deal?.properties?.reference_number,
        //     final_amount_eco: typeOrder?.deal?.properties?.final_amount_eco,
        //     final_amount_ek: typeOrder?.deal?.properties?.final_amount_ek,
        //     final_amount_neo: typeOrder?.deal?.properties?.final_amount_neo,
        //     final_amount_nk: typeOrder?.deal?.properties?.final_amount_nk,
        //     final_amount_spa: typeOrder?.deal?.properties?.final_amount_spa,
        //   });
        //   setHubSpotReference(typeOrder?.deal?.properties?.reference_number);
        //   if (typeOrder?.hubspotEnabled) {
        //     const getDealProducts =
        //       typeOrder?.deal?.properties?.product_group_quoted__test_.split(
        //         ";"
        //       );
        //     const dealUpperCase = getDealProducts?.map((item) =>
        //       item.toUpperCase()
        //     );
        //     const changeWord = dealUpperCase?.map((item) =>
        //       item.replace("KITCHEN", "KUECHEN")
        //     );
        //     const filterProduct = products.filter((item, index) => {
        //       return changeWord?.includes(item.label);
        //     });
        //     setProductOptions(filterProduct);
        //     if (typeOrder.product == 60001) {
        //       setCostOfHubSpot(typeOrder?.deal?.properties?.final_amount_nk);
        //     } else if (typeOrder.product == 60002) {
        //       setCostOfHubSpot(typeOrder?.deal?.properties?.final_amount_ek);
        //     } else if (typeOrder.product == 60006) {
        //       setCostOfHubSpot(typeOrder?.deal?.properties?.final_amount_eco);
        //     } else if (typeOrder.product == 60009) {
        //       setCostOfHubSpot(typeOrder?.deal?.properties?.final_amount_neo);
        //     } else if (typeOrder.product == 60008) {
        //       setCostOfHubSpot(typeOrder?.deal?.properties?.final_amount_spa);
        //     }
        //   }
        // }
      }
    } catch (error) {
      console.log("error", error);
      toast.error(
        error?.response?.data?.errorMessage ||
          error?.response?.data ||
          error.message,
      );
    }
  };

  const getProjectForeCastList = async () => {
    OAuthService.getList(
      `${projectForeCastUrl}?companyId=${
        hasSupperUser ? selectedPartner?.value : customerId
      }`,
    )
      .then((list) => {
        const data = list.data;
        if (data) {
          setProjectForeCast(data);
          setProjectOptions(
            data.map((item) => ({
              value: item.overallQty,
              label: item.projectName,
              id: item.id,
            })),
          );
        }
      })
      .catch((err) => toast.error(err.message));
  };

  const getProject = async () => {
    try {
      const list = await OAuthService.getList(
        `${projectUrl}?forecastId=${selectedProName.id}`,
      );
      if (list.status === 200) {
        setExitingProject(list.data);
        setBaseTypeCount(list?.data?.types?.length || 0);
      } else {
        setExitingProject([]);
        setBaseTypeCount(0);
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.errorMessage ||
          error?.response?.data ||
          error.message,
      );
    }
  };

  const getCustomer = async () => {
    const list = await OAuthService.getList(
      companiesUrl +
        `/search/findActiveByCustomerTypes?&customerTypes=REGULAR&customerTypes=WHOLESALE&page=0&sort=id,ase,&size=1000`,
    );
    let companies = list.data?._embedded?.companies;
    companies = companies.map((company) => {
      return {
        value: company.id,
        label: `${company?.id}-${company?.shortKey}-${company?.countryName}`,
      };
    });
    setCustomerOptions(companies);
    if (customerId) {
      const defaultCustomer = companies.find((item) => item.id === customerId);
      setCustomerName(defaultCustomer);
    }
  };

  const getShowroom = async () => {
    try {
      if (Number(customerName.value)) {
        const showroomByCompanyUrl = `${companiesUrl}/${customerName.value}/showrooms`;
        const list = await OAuthService.getList(showroomByCompanyUrl);
        let showrooms = list.data?._embedded?.showrooms;
        showrooms = showrooms.map((showroom) => {
          return {
            value: showroom.id,
            label: showroom.name,
          };
        });
        setShowroomOptions(showrooms);
      }
    } catch (error) {
      toast.error("Showroom data not available");
      toast.error(error.message);
    }
  };

  const getHubSpotDeal = async (query, page) => {
    const size = 20;
    if (query !== currentQuery) {
      setCurrentPage(0);
      setCurrentQuery(query);
    }
    try {
      let url = `${hubSpotDealsUrl}/${customerId}`;
      if (query) {
        url += `?query=${query}&after=${page}`;
      } else if (page !== undefined) {
        url += `?after=${page}`;
      }
      const list = await OAuthService.getList(url);
      const results = list.data?.results;
      const getDeals = results.map((item) => item.properties);
      setDeals(getDeals);
      setDealOptions(
        getDeals.map((item) => ({
          value: item.hs_object_id,
          label: item.dealname,
          referenceNumber: item.reference_number,
          final_amount_eco: item.final_amount_eco,
          final_amount_ek: item.final_amount_ek,
          final_amount_neo: item.final_amount_neo,
          final_amount_nk: item.final_amount_nk,
          final_amount_spa: item.final_amount_spa,
        })),
      );
      return {
        options: getDeals,
        hasMore: list.data?.paging?.next?.after > 0 ? true : false,
        additional: {
          page: list.data?.paging?.next?.after,
        },
      };
    } catch (error) {
      toast.error(
        error?.response?.data?.errorMessage ||
          error?.response?.data ||
          error.message,
      );
    }
  };

  const getRangeList = async () => {
    OAuthService.getList(`${rangeUrl}?vendorId=${product?.id}`)
      .then((list) => {
        const ranges = list.data;
        setRange(
          ranges?.map((range) => ({
            value: range?.productId,
            label: `${range?.priceGroup?.pgId || "NA"}-${range?.productName}`,
            id: range.id,
            priceGroup: range?.priceGroup?.pgId,
          })),
        );
      })
      .catch((err) => toast.error(err.message));
  };

  const getHandleList = async () => {
    OAuthService.getList(`${handleUrl}?vendorId=${product?.id}`)
      .then((list) => {
        const { handles } = list.data?._embedded;
        setHandles(
          handles?.map((handle) => ({
            value: handle.productId,
            label: `${handle.productId}-${handle.productName}`,
          })),
        );
      })
      .catch((err) => toast.error(err.message));
  };

  const getCarcassList = async () => {
    OAuthService.getList(`${carcassUrl}?vendorId=${product?.id}`)
      .then((list) => {
        const { carcasses } = list.data?._embedded;
        setCarcass(
          carcasses?.map((carcasse) => ({
            value: carcasse.productId,
            label: `${carcasse.productId}-${carcasse.productName}`,
          })),
        );
      })
      .catch((err) => toast.error(err.message));
  };
  const getOrders = async ({ loadingWeek, orderCategories, freight }) => {
    try {
      if (mode === "edit") {
        const list = await OAuthService.getList(editOrderUrl + `/${id}`);
        const order = list.data;
        const findCategory = orderCategories.find(
          (category) => order.orderCategory === category.value,
        );
        const findLoadingWeek = loadingWeek.find(
          (week) => order.loadingWeek === week.value,
        );
        const findFreight = freight.find((item) => order.freightId === item.id);
        setShowroom({ value: order.showroomNum, label: order.showroomName });
        setProduct({
          value: order.vendorShortKey,
          label: order.vendorName,
          id: order.vendorNum,
        });
        setOrderCategoryValue({
          label: findCategory.label,
          value: findCategory.value,
        });
        setOrderReference(order.projectNum);
        setTypeNumber(order?.typeNumber);
        if (order.uniqueId) {
          const match = order.uniqueId.match(/-(K10|K[1-9])$/);
          if (match) {
            setUniqueIdSuffix({ label: match[1], value: match[1] });
            setUniqueID(order.uniqueId.substring(0, match.index));
          } else {
            setUniqueID(order.uniqueId);
            setUniqueIdSuffix(null);
          }
        } else {
          setUniqueID("");
          setUniqueIdSuffix(null);
        }
        setClientName(order.clientName);
        setWG1Price(order.lpWg1);
        setWG2Price(order.lpWg2);
        setCommissionName(order.commissionName);
        setDiscountChecked(order.specialDiscountRequested);
        setVolume(order.volume);
        setWeight(order.volume);
        setContainerNo(order.requestedContainer);
        setLoadingWeek({
          value: findLoadingWeek.value,
          label: findLoadingWeek.label,
        });
        setFreight({
          value: findFreight.value,
          label: findFreight.label,
          id: findFreight.id,
        });
        setComment(order.specialRemark1);
        setDRWFile(order?.drwFile);
        setAppliancesDetail(order?.applianceDetail);
        setOrderCheckFile(order?.orderCheckList);
        setDrawingFile(order?.drawingFile);
        setSDFile(order?.specialDiscountFile);
        const initialFormValues = [];
        for (let i = 1; i <= 3; i++) {
          const rangeKey = `range${i}`;
          const colorKey = `color${i}`;
          const carcassKey = `carcass${i}`;
          const handleKey = `handle${i}`;

          if (
            order[rangeKey] ||
            order[colorKey] ||
            order[carcassKey] ||
            order[handleKey]
          ) {
            initialFormValues.push({
              range: order[rangeKey]
                ? { label: order[rangeKey], value: order[`${rangeKey}Id`] }
                : null,
              color: order[colorKey]
                ? { label: order[colorKey], value: order[`${colorKey}Id`] }
                : null,
              carcass: order[carcassKey]
                ? { label: order[carcassKey], value: order[`${carcassKey}Id`] }
                : null,
              handle: order[handleKey]
                ? { label: order[handleKey], value: order[`${handleKey}Id`] }
                : null,
            });
          }
        }
        setFormValues(initialFormValues);
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.errorMessage ||
          error?.response?.data ||
          error.message,
      );
    }
  };

  useEffect(() => {
    if (orderReference && typeNumber) {
      if (
        mode === "new-type" &&
        orderReference.length === 6 &&
        /^[A-Z]{2}\d{4}$/.test(orderReference)
      ) {
        setCommissionName(
          `${orderReference}${typeNumber}-${
            product?.value === undefined ? "" : product?.value
          }-${fullUniqueID}-${clientName}`.toUpperCase(),
        );
      } else {
        setCommissionName(
          `${orderReference}${typeNumber}${
            product?.value === undefined ? "" : product?.value
          }-${fullUniqueID}-${clientName}`.toUpperCase(),
        );
      }
    }
  }, [orderReference, typeNumber, product, fullUniqueID, clientName]);

  useEffect(() => {
    if (previousStepRowData?.[activeStep] && hasBack) {
      setVolume(previousStepRowData[activeStep]?.[activeStep]?.volume ?? "");
      setWeight(previousStepRowData[activeStep]?.[activeStep]?.weight ?? "");
      setWG1Price(previousStepRowData[activeStep]?.[activeStep]?.wg1 ?? "");
      setWG2Price(previousStepRowData[activeStep]?.[activeStep]?.wg2 ?? "");
      const loadingWeekValue =
        previousStepRowData[activeStep]?.[activeStep]?.loadingWeek;
      if (loadingWeekValue) {
        const loadingWeek = loadingWeekOptions.find(
          (option) => option.value === loadingWeekValue,
        );
        if (loadingWeek) {
          setLoadingWeek(loadingWeek);
        }
      }
      const freightValue =
        previousStepRowData[activeStep]?.[activeStep]?.freightId;
      if (freightValue) {
        const freight = freightOptions.find(
          (option) => option.id === freightValue,
        );
        if (freight) {
          setFreight(freight);
        }
      }
      setComment(
        previousStepRowData[activeStep]?.[activeStep]?.specialComments,
      );
      setSharedLater(
        previousStepRowData[activeStep]?.[activeStep]?.sharedLater,
      );
      setNotApplicable(previousStepRowData[activeStep]?.[activeStep]?.na);
      setDrwFileSupersedes(
        previousStepRowData[activeStep]?.[activeStep]?.drawFileSupersedes,
      );
      const savedStep = previousStepRowData[activeStep]?.[activeStep];
      const savedDrw =
        savedStep?.drwFile ||
        (savedStep?.drwFileId && savedStep?.drwFileName
          ? { id: savedStep.drwFileId, name: savedStep.drwFileName }
          : null);

      setDRWFile(prwSelected ? PRWFile : savedDrw);
      setDrwFileId(savedStep?.drwFileId ?? "");
      setAppliancesDetail(previousStepRowData[activeStep]?.appliancesDetail);
      setAppliancesDetailFileId(
        previousStepRowData[activeStep]?.appliancesDetailFileId,
      );
      setOrderCheckFile(previousStepRowData[activeStep]?.orderCheckFile);
      setOrderCheckFileId(previousStepRowData[activeStep]?.orderCheckFileId);
      setUploadValue(previousStepRowData[activeStep]?.uploadValue);
    } else {
      setPrjOrderChange(false);
      setVolume("");
      setWeight("");
      setWG1Price("");
      setWG2Price("");
      setContainerNo("");
      setLoadingWeek(null);
      setFreight(null);
      setComment("");
      setFormValues(formValues);
      setDRWFile(prwSelected ? PRWFile : "");
      setAppliancesDetail("");
      setOrderCheckFile("");
      setDrawingFile("");
      setSDFile("");
      setDiscountChecked(false);
      setSharedLater(false);
      setNotApplicable(false);
      setDrwFileSupersedes(false);
      setUploadValue([{ uploadFile: null }]);
      setIsPRWFile(false);
    }
  }, [hasBack, activeStep]);

  useEffect(() => {
    if (selectedPartner || !hasSupperUser || mode === "new") {
      getNewOrder();
    }
  }, [selectedPartner, hasSupperUser, mode]);

  useEffect(() => {
    if (
      orderCategoryValue?.value === "RET" &&
      (newOrderData.hubspotEnabled || typeOrderData.hubspotEnabled)
    ) {
      getHubSpotDeal();
    }
  }, [orderCategoryValue, newOrderData, typeOrderData]);
  useEffect(() => {
    if (product?.id) {
      getRangeList();
      getHandleList();
      getCarcassList();
    }
  }, [product]);

  useEffect(() => {
    if (id) {
      const editData = async () => {
        const dataForEdit = await getNewOrder();
        if (mode === "edit") {
          await getOrders(dataForEdit);
        }
      };
      editData();
    }
  }, [id, mode === "edit"]);

  useEffect(() => {
    if (id && mode === "new-type") {
      getNewOrderType();
    }
  }, [id, mode]);

  useEffect(() => {
    if (mode === "new") {
      setProduct();
      setOrderCategoryValue();
      setWG1Price("");
      setWG2Price("");
      setVolume("");
      setWeight("");
      setContainerNo("");
      setLoadingWeek();
      setFreight();
      setComment("");
      setSDFile("");
      setDRWFile("");
      setAppliancesDetail("");
      setOrderCheckFile("");
      setDrawingFile("");
      setDiscountChecked(false);
      setSharedLater(false);
      setNotApplicable(false);
      setDrwFileSupersedes(false);
      setFormValues([
        {
          range: {},
          priceGroup: {},
          color: {},
          carcass: {},
          handle: {},
        },
      ]);
    }
  }, [mode === "new"]);

  function isFirstColumn(params) {
    var displayedColumns = params?.columnApi.getAllDisplayedColumns();
    var thisIsFirstColumn =
      displayedColumns && displayedColumns[0] === params?.column;
    return thisIsFirstColumn;
  }

  const defaultColDef = useMemo((params) => {
    return {
      flex: 1,
      minWidth: 100,
      resizable: true,
      checkboxSelection: isFirstColumn,
    };
  }, []);

  const autoGroupColumnDef = useMemo(() => {
    return {
      cellRendererParams: {
        checkbox: true,
      },
    };
  }, []);

  const handleClose = () => {
    setOpen(false);
    dispatch(setHasBackOrderForm(false));
    setOrderReference(prjOrderReference);
    setOrderCategoryValue();
    setSelectedProName(null);
    setDraftOrderOptions([]);
    setDraftId();
    setDraftOrder("");
    setProduct(null);
    setSelectedQty("");
    setSelectedPhases("");
    setPhasesRowData([]);
    setDisplayName("");
    setPhaseNameCode("");
    setTypesPhaseQty("");
    setSelectedPartner(null);
    setShowroom(null);
    setOrderCategoryValue(null);
    setTypeNumber("");
    setCommissionName("");
    setShowroomOptions([]);
    setOrderCategoryOptions([]);
    setOrderReference("");
    setShowToast(false);
    setEditPhases(false);
    setShowPhasesAlert(false);
    //Partner admin account issue related while placing orders-order Reference empty
    if (!hasSupperUser) {
      getNewOrder();
    }
  };
  const handlePlaceOrder = () => {
    setOpen(true);
  };
  const handleChangeQty = (e) => {
    const value = Number(e.target.value);
    if (editPhases) {
      setNewQty(value - initialQty);
    }
    const isExisting = existingProjectOptions?.includes(selectedProName);
    if (hasSupperUser) {
      setSelectedQty(value);

      const totalPhaseQty = phasesRowData.reduce(
        (sum, row) => sum + Number(row.phaseViseQty || 0),
        0,
      );

      if (value !== totalPhaseQty) {
        setShowPhasesAlert(true);
        setToastMessage(
          "Please adjust phase quantities to match the total quantity",
        );
        setShowToast(true);
        setTimeout(() => setShowToast(false), 5000);
      } else {
        setShowPhasesAlert(false);
      }

      return;
    }

    if (isExisting && !hasSupperUser) {
      const maxAllowed = Math.floor(originalQty * 1.05);

      if (value < originalQty) {
        setSelectedQty(originalQty);
        setToastMessage(`You cannot reduce the overall quantity.`);
        setShowToast(true);
        return;
      }

      if (value > maxAllowed) {
        setSelectedQty(maxAllowed);
        setToastMessage(
          `Quantity cannot exceed +5%. Adjusted to ${maxAllowed}.`,
        );
        setShowToast(true);
      } else {
        setSelectedQty(value);
      }

      const totalPhaseQty = phasesRowData.reduce(
        (sum, row) => sum + Number(row.phaseViseQty || 0),
        0,
      );

      const effectiveQty = value > maxAllowed ? maxAllowed : value;

      if (effectiveQty !== totalPhaseQty) {
        setShowPhasesAlert(true);
        setToastMessage(
          "Please adjust phase quantities to match the total quantity",
        );
        setShowToast(true);
        setTimeout(() => setShowToast(false), 5000);
      } else {
        setShowPhasesAlert(false);
      }

      return;
    }

    setSelectedQty(value);

    const totalPhaseQty = phasesRowData.reduce(
      (sum, row) => sum + Number(row.phaseViseQty || 0),
      0,
    );

    if (value !== totalPhaseQty) {
      setShowPhasesAlert(true);
      setToastMessage(
        "Please adjust phase quantities to match the total quantity",
      );
      setShowToast(true);
      setTimeout(() => setShowToast(false), 5000);
    } else {
      setShowPhasesAlert(false);
    }
  };
  const handleBlur = () => {
    if (selectedQty < 10) {
      setSelectedQty(10);
      setToastMessage("Project order minimum quantity is 10");
      setShowToast(true);
      setTimeout(() => setShowToast(false), 5000);
    }
  };
  const handleChangeOrderCategory = (event) => {
    if (!showroom?.label) {
      toast.warning("Please select showroom");
      return;
    }
    setOrderCategoryValue({
      value: event.value,
      label: event.label,
    });
    setProduct(null);
    setProductOptions(defaultProductOption);
    if (event.value === "RET") {
      setSelectedDeal(null);
    }
    if (event.value === "PRJ" || event.value === "CPRJ") {
      setPrjOrderReference(orderReference);
      setOrderReference("");
      setOpen(true);
    }
    if (event.value === "CPRJ") {
      setProduct(null);
      setSelectedPhases("");
      setSelectedQty("");
      setPhasesRowData([]);
      setRowData([]);
      setDisplayName("");
    }
  };
  const placeOrder = () => {
    return (
      <>
        {orderCategoryValue?.value === "PRJ" ||
        orderCategoryValue?.value === "CPRJ" ? (
          <>
            {/* {activeStep !== 0 && (
              <Button
                color="inherit"
                disabled={activeStep === 0}
                onClick={handleBack}
                sx={{ mr: 1 }}
              >
                Back
              </Button>
            )} */}
            <Button
              color="secondary"
              onClick={(e) => {
                e.stopPropagation(); // Stop click bubbling
                activeStep === 0 ? handleBackProjectForm() : handleBack();
              }}
              sx={{ mr: 1 }}
            >
              Back
            </Button>

            <Button
              variant="contained"
              color="secondary"
              onClick={(e) => {
                e.stopPropagation();
                handleSaveDraft();
              }}
              sx={{ mr: 1 }}
            >
              Save as Draft
            </Button>

            <Button
              variant="contained"
              color="secondary"
              onClick={(e) => {
                e.stopPropagation();
                handleNext(e);
              }}
              disabled={
                btnDisable ||
                prwNotYetApplied ||
                previousTypesMissingDrw.length > 0
              }
            >
              {activeStep === rowData?.length - 1 ? "Submit" : "Next"}
            </Button>
          </>
        ) : (
          <Button
            variant="contained"
            onClick={handleSubmit}
            disabled={
              btnDisable ||
              clientName.length < 1 ||
              uniqueID.length < 1 ||
              clientName.length + uniqueID.length > 21 ||
              loading ||
              placeOrderBtnDisable
            }
            color="secondary"
          >
            {mode === "edit" ? "Save" : "Place Order"}
          </Button>
        )}
      </>
    );
  };

  let addFormFields = () => {
    if (formValues.length < 3) {
      setFormValues([
        ...formValues,
        { range: {}, priceGroup: {}, color: {}, carcass: {}, handle: {} },
      ]);
    }
  };

  let addUploadFields = () => {
    const newField = { id: "", uploadFile: null };
    const newUploadValue = [...uploadValue, newField];
    setUploadValue(newUploadValue);

    if (
      orderCategoryValue?.value === "PRJ" ||
      orderCategoryValue?.value === "CPRJ"
    ) {
      dispatch(
        setPreviousStepData({
          stepIndex: activeStep,
          data: { uploadValue: newUploadValue },
        }),
      );
    }
  };

  let removeFormFields = (i) => {
    let newFormValues = [...formValues];
    newFormValues.splice(i, 1);
    setFormValues(newFormValues);
  };

  let removeUploadFields = (i) => {
    const newUploadValue = [...uploadValue];
    newUploadValue.splice(i, 1);
    setUploadValue(newUploadValue);
    if (hasBack) {
      dispatch(
        setPreviousStepData({
          stepIndex: activeStep,
          data: { uploadValue: newUploadValue },
        }),
      );
    }
  };

  const applyPrwToAllTypes = (fileUploaded, fileId) => {
    const totalTypes = steps?.length || rowData?.length || 0;
    const fileIdStr = Array.isArray(fileId) ? fileId.join("") : fileId;

    for (let i = 0; i < totalTypes; i++) {
      const existing = previousStepRowData?.[i]?.[i] || {};
      dispatch(
        setPreviousStepData({
          stepIndex: i,
          data: {
            drwFile: fileUploaded,
            drwFileId: fileIdStr,
            drwFileName: fileUploaded?.name,
          },
        }),
      );
    }

    setStepData((prev) => {
      const updated = [...prev];
      for (let i = 0; i < totalTypes; i++) {
        if (updated[i]?.[i]) {
          updated[i] = {
            [i]: {
              ...updated[i][i],
              drwFileId: fileIdStr,
              drwFileName: fileUploaded?.name,
            },
          };
        }
      }
      return updated;
    });

    setDraftProjectInfo((prev) => {
      const updated = [...prev];
      for (let i = 0; i < totalTypes; i++) {
        if (updated[i]) {
          updated[i] = {
            ...updated[i],
            drwFileId: fileIdStr,
            drwFileName: fileUploaded?.name,
          };
        }
      }
      return updated;
    });
  };

  const removePrwFromAllTypes = () => {
    const totalTypes = steps?.length || rowData?.length || 0;

    for (let i = 0; i < totalTypes; i++) {
      const existing = previousStepRowData?.[i]?.[i] || {};
      dispatch(
        setPreviousStepData({
          stepIndex: i,
          data: {
            drwFile: null,
            drwFileId: null,
            drwFileName: null,
          },
        }),
      );
    }

    setStepData((prev) => {
      const updated = [...prev];
      for (let i = 0; i < totalTypes; i++) {
        if (updated[i]?.[i]) {
          updated[i] = {
            [i]: {
              ...updated[i][i],
              drwFileId: null,
              drwFileName: null,
            },
          };
        }
      }
      return updated;
    });

    setDraftProjectInfo((prev) => {
      const updated = [...prev];
      for (let i = 0; i < totalTypes; i++) {
        if (updated[i]) {
          updated[i] = {
            ...updated[i],
            drwFileId: null,
            drwFileName: null,
          };
        }
      }
      return updated;
    });
  };

  const fetchInitialOptions = async () => {
    try {
      const options = await getProjectName("", 0, pageSize);
      setExistingProjectOptions([
        ...new Set(
          options.projectOptions
            .filter((project) => project.label)
            .map((project) => project.label),
        ),
      ]);
      setProjectOptions(options.projectOptions);
      setFilteredOptions(options.projectOptions);
    } catch (error) {
      toast.error("Failed to fetch project options.");
    }
  };

  const getProjectName = async (query, page, size) => {
    try {
      let url = searchProjectUrl;

      if (query) {
        url += `?companyId=${
          hasSupperUser ? selectedPartner?.value : customerId
        }&projectName=${query}&orderCategory=${
          orderCategoryValue?.value
        }&page=${page}&size=${size}`;
      } else {
        url += `?companyId=${
          hasSupperUser ? selectedPartner?.value : customerId
        }&orderCategory=${orderCategoryValue?.value}&page=${page}&size=${size}`;
      }

      const list = await OAuthService.getList(url);
      const data = list.data?.content || [];

      return {
        projectOptions: data.map((item) => ({
          value: item.id,
          label: item.projectName,
          phases: item.noOfPhases,
          quantity: item.totalQuantity,
          phasesData: item.projectPhases,
          vendor: item.vendor,
          vendorId: item.vendorId,
          orderReference: item.project,
          projectCode: item.clientName,
          types: item.types,
        })),
        hasMore: data.length >= size,
      };
    } catch (error) {
      toast.error(error.message);
      return { projectOptions: [], hasMore: false };
    }
  };
  const normalize = (val) => val?.trim().toLowerCase();
  const loadProjectOptions = async (search, loadedOptions, { page }) => {
    const cleanedSearch = search?.trim();

    const response = await getProjectName(cleanedSearch, page, pageSize);

    let options = response.projectOptions || [];
    setExistingProjectOptions((prev) => [
      ...new Set([
        ...prev,
        ...options
          .filter((project) => project.label)
          .map((project) => project.label),
      ]),
    ]);
    if (cleanedSearch) {
      const normalizedSearch = normalize(cleanedSearch);

      const isAlreadyExists = [...options, ...loadedOptions].some(
        (opt) => normalize(opt.label) === normalizedSearch,
      );

      if (!isAlreadyExists) {
        options = [
          {
            label: `Create "${cleanedSearch}"`,
            value: cleanedSearch,
            __isNew__: true,
          },
          ...options,
        ];
      }
    }

    return {
      options,
      hasMore: response.hasMore,
      additional: {
        page: page + 1,
      },
    };
  };

  const getDraftProjectList = async () => {
    try {
      let url =
        draftProjectByRoleUrl +
        `?customerId=${hasSupperUser ? selectedPartner?.value : customerId}`;

      const list = await OAuthService.getList(url);
      if (list?.data) {
        const filteredList = list.data.sort(
          (a, b) => new Date(b.lastModifiedDate) - new Date(a.lastModifiedDate),
        );
        setDraftList(filteredList);
        setDraftOrderOptions(
          filteredList.map((item) => ({
            value: item.projectName,
            label: item.projectName,
            id: item.id,
          })),
        );
      }
    } catch (error) {
      toast.error(error.message);
      return;
    }
  };

  const handleInputChange = (inputValue) => {
    setCurrentQuery(inputValue);

    if (inputValue) {
      const filtered = projectOptions.filter(
        (option) =>
          option.label &&
          option.label.toLowerCase().includes(inputValue.toLowerCase()),
      );
      setFilteredOptions(filtered);
    } else {
      setFilteredOptions(projectOptions);
    }
  };
  const handleChangeProject = (newValue, action) => {
    if (action.action === "clear") {
      if (
        !existingProjectOptions?.some(
          (name) => normalize(name) === normalize(selectedProName?.label),
        )
      ) {
        const labelToRemove = normalize(selectedProName?.label);
        setProjectOptions((prev) =>
          prev.filter((opt) => normalize(opt.label) !== labelToRemove),
        );

        setFilteredOptions((prev) =>
          prev.filter((opt) => normalize(opt.label) !== labelToRemove),
        );
      }
      setSelectedProName(null);
      setProduct(null);
      setSelectedPhases("");
      setSelectedQty("");
      setPhasesRowData([]);
      setDisplayName("");
      setPhaseNameCode("");
      setTypesPhaseQty("");
      setOriginalQty("");
      setVolume("");
      setWeight("");
      setWG1Price("");
      setWG2Price("");
      setContainerNo("");
      setLoadingWeek(null);
      setFreight(null);
      setComment("");
      setFormValues([
        {
          range: {},
          priceGroup: {},
          color: {},
          carcass: {},
          handle: {},
        },
      ]);
      setDRWFile("");
      setAppliancesDetail("");
      setOrderCheckFile("");
      setDrawingFile("");
      setSDFile("");
      setOrderReference("");
      setDiscountChecked(false);
      setSharedLater(false);
      setNotApplicable(false);
      setDrwFileSupersedes(false);
      setUploadValue([{ uploadFile: null }]);
      setShowPhasesAlert(false);
      setShowToast(false);
      dispatch(clearRowDataValue());
      dispatch(clearStepData());
      setPhasesTotalValue(0);
      setTypeTotalValue(0);
      dispatch(setHasBackOrderForm(false));
      setEditPhases(false);
      setPRWFile("");
      setBaseTypeCount(0);
      return;
    }

    if (newValue?.__isNew__) {
      const normalizedValue = newValue.value.trim();
      const newOption = {
        value: normalizedValue,
        label: normalizedValue.toUpperCase(),
      };

      setSelectedProName(newOption);
      setProjectOptions((prev) => [...prev, newOption]);
      setFilteredOptions((prev) => [...prev, newOption]);
      setForeCastProduct(
        productOptions.map((item) => ({
          value: item.value,
          label: item.label,
          id: item.id,
        })),
      );
      setProduct(null);
      setSelectedPhases("");
      setSelectedQty("");
      setPhasesRowData([]);
      setRowData([]);
      setDisplayName("");
      setOrderReference(prjOrderReference);
      setBaseTypeCount(0);
      setShowType(false);
      setOriginalQty("");
      setVolume("");
      setWeight("");
      setWG1Price("");
      setWG2Price("");
      setContainerNo("");
      setLoadingWeek(null);
      setFreight(null);
      setComment("");
      setFormValues([
        {
          range: {},
          priceGroup: {},
          color: {},
          carcass: {},
          handle: {},
        },
      ]);
      setDRWFile("");
      setAppliancesDetail("");
      setOrderCheckFile("");
      setDrawingFile("");
      setSDFile("");
      setDiscountChecked(false);
      setSharedLater(false);
      setNotApplicable(false);
      setDrwFileSupersedes(false);
      setUploadValue([{ uploadFile: null }]);
      setTypeRowData([]);
      setDraftId();
      setTypesPhaseQty("");
      setShowPhasesAlert(false);
      setShowToast(false);
      setPrjOrderChange(true);
      dispatch(setHasBack(false));
      dispatch(clearRowDataValue());
      dispatch(clearStepData());
      setPhasesTotalValue(0);
      setTypeTotalValue(0);
      dispatch(setHasBackOrderForm(false));
      setEditPhases(false);
      setPRWFile("");
    } else {
      setSelectedProName(newValue);

      setForeCastProduct(
        productOptions.map((item) => ({
          value: item.label,
          label: item.value,
          id: item.id,
        })),
      );
      setProduct({
        label: newValue?.vendor,
        id: newValue?.vendorId,
        value: newValue?.vendor
          .split(" ")
          .map((word) => word[0])
          .join(""),
      });
      setSelectedPhases(newValue?.phases || "");
      setInitialPhaseQty(newValue?.phases || "");
      setSelectedQty(newValue?.quantity || "");
      setInitialQty(newValue?.quantity || "");
      setPhasesRowData(
        newValue?.phasesData
          ? JSON.parse(JSON.stringify(newValue.phasesData))
          : [],
      );
      setInitialRowData(newValue?.phasesData || []);
      const clonedPhases = JSON.parse(
        JSON.stringify(newValue?.phasesData || []),
      );

      setOriginalPhasesRowData(clonedPhases);
      setPhasesTotalValue(newValue?.quantity || 0);
      setOrderReference(newValue?.orderReference || "");
      setBaseTypeCount(newValue?.types.length);
      setPhaseNameCode("");
      setTypesPhaseQty("");
      setRowData([]);
      setDisplayName(newValue?.projectCode || "");
      setOriginalQty("");
      setVolume("");
      setWeight("");
      setWG1Price("");
      setWG2Price("");
      setContainerNo("");
      setLoadingWeek(null);
      setFreight(null);
      setComment("");
      setFormValues([
        {
          range: {},
          priceGroup: {},
          color: {},
          carcass: {},
          handle: {},
        },
      ]);
      setDRWFile("");
      setAppliancesDetail("");
      setOrderCheckFile("");
      setDrawingFile("");
      setSDFile("");
      setDiscountChecked(false);
      setSharedLater(false);
      setNotApplicable(false);
      setDrwFileSupersedes(false);
      setUploadValue([{ uploadFile: null }]);
      setTypeRowData([]);
      setDraftId();
      setShowPhasesAlert(false);
      setShowToast(false);
      setPrjOrderChange(true);
      dispatch(setHasBack(false));
      dispatch(clearRowDataValue());
      dispatch(clearStepData());
      dispatch(setHasBackOrderForm(false));
      setEditPhases(false);
      setPRWFile("");
    }
  };

  useEffect(() => {
    if (
      orderCategoryValue?.value === "PRJ" ||
      orderCategoryValue?.value === "CPRJ"
    ) {
      if (customerId) {
        fetchInitialOptions();
        getDraftProjectList();
      }
    }
  }, [orderCategoryValue?.value, customerId]);

  useEffect(() => {
    if (hasBackForm && orderFormData && !isDraftOrder) {
      setSelectedProName(orderFormData.selectedProName);
      setProduct(orderFormData.product);
      setSelectedQty(orderFormData.selectedQty);
      setSelectedPhases(orderFormData.selectedPhases);

      const clonedPhases = orderFormData.phasesRowData
        ? JSON.parse(JSON.stringify(orderFormData.phasesRowData))
        : [];

      setPhasesRowData(clonedPhases);
      setPhasesTotalValue(orderFormData.phasesTotalValue);
      setDisplayName(orderFormData.displayName);
      setPhaseNameCode(orderFormData.phaseNameCode);
      setTypesPhaseQty(orderFormData.typesPhaseQty);
      setRowData(
        orderFormData.rowData
          ? JSON.parse(JSON.stringify(orderFormData.rowData))
          : [],
      );
      setTypeTotalValue(orderFormData.typeTotalValue);
    }
  }, [hasBackForm, orderFormData]);

  const handleChangeProjectName = (e) => {
    setSelectedProName(e.target.value);
    setForeCastProduct(
      productOptions.map((item) => ({
        value: item.label,
        label: item.value,
        id: item.id,
      })),
    );
    setProduct(null);
    setSelectedPhases("");
    setSelectedQty("");
    setPhasesRowData([]);
    setRowData([]);
    setDisplayName("");
  };
  const blockInvalidKeys = (e) => {
    if (["e", "E", "+", "-"].includes(e.key)) {
      e.preventDefault();
    }
  };

  const handleChangePhases = (e) => {
    const newPhaseCount = parseInt(e?.target?.value);
    if (!newPhaseCount || newPhaseCount <= 0) return;

    if (editPhases) {
      setNewPhase(e.target.value - InitialPhaseQty);
    }

    const isExistingProject = existingProjectOptions?.includes(
      selectedProName?.label,
    );
    const currentPhases = Array.isArray(phasesRowData)
      ? [...phasesRowData]
      : [];
    const currentCount = currentPhases.length;
    const confirmedCount = currentPhases.filter(
      (row) => row.orderPlaced,
    ).length;

    const isRestricted = hasSupperUser
      ? selectedPartner?.value === 30058 ||
        selectedPartner?.value === 30002 ||
        selectedPartner?.value === 30005 ||
        selectedPartner?.value === 30092
      : customerId === 30058 ||
        customerId === 30002 ||
        customerId === 30005 ||
        customerId === 30092;

    if (isExistingProject) {
      // For existing projects: allow only increasing phase count
      if (newPhaseCount <= currentCount) {
        setToastMessage("Phase count must be increased.");
        setShowToast(true);
        setTimeout(() => setShowToast(false), 5000);
        return;
      }

      let wasClamped = false;
      const clampedPhases = currentPhases.map((row) => {
        const qty = Number(row.phaseViseQty || 0);
        if (!isRestricted && qty > 0 && qty < 5) {
          wasClamped = true;
          return { ...row, phaseViseQty: 5 };
        }
        return row;
      });

      const phasesToAdd = newPhaseCount - currentCount;
      const newRows = [];
      for (let i = 0; i < phasesToAdd; i++) {
        newRows.push({
          phaseName: `Phase ${currentCount + i + 1}`,
          qty: 0,
          phaseViseQty: 0,
          expectedProductionWeek: "",
          year: moment().add(7, "weeks").year(),
          orderPlaced: false,
        });
      }

      const totalUsedQty = clampedPhases.reduce(
        (acc, row) => acc + Number(row.phaseViseQty || 0),
        0,
      );
      const remainingQty = selectedQty - totalUsedQty;

      newRows[newRows.length - 1].phaseViseQty =
        remainingQty > 0 ? remainingQty : 0;

      const updatedRows = [...clampedPhases, ...newRows];

      setPhasesRowData(updatedRows);
      setSelectedPhases(newPhaseCount);
      setPhasesTotalValue(
        updatedRows.reduce(
          (sum, row) => sum + Number(row.phaseViseQty || 0),
          0,
        ),
      );

      if (wasClamped) {
        setToastMessage("Phase-wise quantity minimum should be 5");
        setShowToast(true);
        setTimeout(() => setShowToast(false), 5000);
      }

      const newTotal = updatedRows.reduce(
        (sum, row) => sum + Number(row.phaseViseQty || 0),
        0,
      );
      if (selectedQty !== newTotal) {
        setShowPhasesAlert(true);
        setToastMessage(
          "Please adjust phase quantities to match the total quantity",
        );
        setShowToast(true);
        setTimeout(() => setShowToast(false), 5000);
      } else {
        setShowPhasesAlert(false);
      }

      setTimeout(() => {
        if (phaseGridRef.current?.api) {
          const api = phaseGridRef.current.api;
          const newRowIndex = updatedRows.length - 1;
          const node = api.getDisplayedRowAtIndex(newRowIndex);
          if (node) {
            api.deselectAll();
            node.setSelected(true);
            api.ensureIndexVisible(newRowIndex);
          }
        }
      }, 100);
    } else {
      if (newPhaseCount < confirmedCount) {
        setToastMessage(
          `Cannot reduce phases below ${confirmedCount} because they are already confirmed/placed.`,
        );
        setShowToast(true);
        setTimeout(() => setShowToast(false), 5000);
        setSelectedPhases(currentCount);
        return;
      }
      let updatedRows;
      if (newPhaseCount > currentCount) {
        const additionalRows = [];
        for (let i = currentCount; i < newPhaseCount; i++) {
          additionalRows.push({
            phaseName: `Phase ${i + 1}`,
            qty: 0,
            phaseViseQty: 0,
            expectedProductionWeek: "",
            year: moment().add(7, "weeks").year(),
            isCurrentPhase: true,
            orderPlaced: false,
          });
        }
        updatedRows = [...currentPhases, ...additionalRows];
      } else {
        updatedRows = currentPhases.slice(0, newPhaseCount);
      }

      setPhasesRowData(updatedRows);
      setSelectedPhases(newPhaseCount);

      const newTotal = updatedRows.reduce(
        (sum, row) => sum + Number(row.phaseViseQty || 0),
        0,
      );
      setPhasesTotalValue(newTotal);
      if (newTotal !== selectedQty) {
        setShowPhasesAlert(true);
        setToastMessage(
          "Please adjust phase quantities to match the total quantity",
        );
        setShowToast(true);
        setTimeout(() => setShowToast(false), 5000);
      } else {
        setShowPhasesAlert(false);
      }
    }
  };

  const handleUpdateProject = () => {
    if (selectedProName?.quantity) {
      setOriginalQty(selectedProName.quantity);
      setSelectedQty(selectedProName.quantity);
    }
    setNewQty("");
    setNewPhase("");
    setEditPhases(true);
    setRowData([]);
    setTypeRowData([]);
    setSteps([]);
    setShowType(false);
    setTypesPhaseQty("");
    setPhaseNameCode("");
    setIsSubmitEnabled(true);
    setTimeout(() => {
      if (
        phaseGridRef.current?.api &&
        selectedProName?.phasesData?.length > 0
      ) {
        const firstSelectableIndex = selectedProName.phasesData.findIndex(
          (row) => !row.orderPlaced,
        );

        if (firstSelectableIndex !== -1) {
          const api = phaseGridRef.current.api;
          api.deselectAll();
          const node = api.getDisplayedRowAtIndex(firstSelectableIndex);
          if (node) {
            node.setSelected(true);
            api.ensureIndexVisible(firstSelectableIndex);
          }
        }
      }
    }, 100);
  };

  const hasChanges = useMemo(() => {
    return (
      selectedQty !== originalQty ||
      selectedPhases !== selectedProName?.phases ||
      JSON.stringify(phasesRowData) !==
        JSON.stringify(selectedProName?.phasesData)
    );
  }, [
    selectedQty,
    originalQty,
    selectedPhases,
    selectedProName?.phases,
    phasesRowData,
    selectedProName?.phasesData,
  ]);

  const handleRevertChanges = () => {
    if (!selectedProName) return;

    setEditPhases(false);

    setSelectedQty(selectedProName.quantity || "");
    setPhasesRowData(
      selectedProName.phasesData
        ? JSON.parse(JSON.stringify(selectedProName.phasesData))
        : [],
    );
    setPhasesTotalValue(selectedProName.quantity || 0);
    setSelectedPhases(selectedProName.phases || "");
    setOriginalQty(null);
    setPhaseNameCode("");
    setTypesPhaseQty("");
    setShowPhasesAlert(false);
    setNewQty("");
    setNewPhase("");
    setTimeout(() => {
      if (
        phaseGridRef.current?.api &&
        selectedProName?.phasesData?.length > 0
      ) {
        const firstSelectableIndex = selectedProName.phasesData.findIndex(
          (row) => !row.orderPlaced,
        );

        if (firstSelectableIndex !== -1) {
          const api = phaseGridRef.current.api;
          api.deselectAll();
          const node = api.getDisplayedRowAtIndex(firstSelectableIndex);
          if (node) {
            node.setSelected(true);
            api.ensureIndexVisible(firstSelectableIndex);
          }
        }
      }
    }, 100);
  };

  const handleChangeTypesPhaseQty = (event) => {
    setTypesPhaseQty(Number(event.target.value));
    setRowData([]);
  };

  const handleAddRow = () => {
    const newData = [];
    for (let i = 0; i < typesPhaseQty; i++) {
      newData.push({ typeName: "", qty: "" });
    }
    setShowType(true);
    setRowData(newData);
    setIsSubmitEnabled(true);
  };

  const handleCloseDeleteModel = () => {
    setOpenDeleteModel(false);
    setSelectedDeleteOption(null);
  };

  const handleDeleteDraftOrder = async () => {
    try {
      if (!selectedDeleteOption?.id) return;

      await OAuthService.deleteData(projectDraftUrl, selectedDeleteOption.id);

      const updatedOptions = draftOrderOptions.filter(
        (item) => item.id !== selectedDeleteOption.id,
      );

      setDraftOrderOptions(updatedOptions);

      if (draftOrder?.id === selectedDeleteOption.id) {
        setDraftOrder(null);
      }

      handleCloseDeleteModel();
    } catch (error) {
      console.error("Delete failed:", error);
    }
  };
  const handleSubmitRowAdd = () => {
    dispatch(setRowDataValue(rowData));
    setSteps(rowData);
    dispatch(setHasBackOrderForm(false));
    dispatch(
      setOrderFormData({
        selectedProName,
        product,
        selectedQty,
        selectedPhases,
        phasesRowData: JSON.parse(JSON.stringify(phasesRowData)),
        phasesTotalValue,
        displayName,
        phaseNameCode,
        typesPhaseQty,
        rowData: JSON.parse(JSON.stringify(rowData)),
        typeTotalValue,
      }),
    );

    // Always get the first row node, regardless of selection
    const firstRowNode = gridRef.current.api.getDisplayedRowAtIndex(0);
    const typeNum =
      orderReference?.length === 6
        ? (count + 1).toString().padStart(2, "0")
        : (count + 1).toString().padStart(3, "0");

    if (firstRowNode) {
      const value = firstRowNode.data.qty;
      const newRow = [];
      for (let i = 0; i < value; i++) {
        newRow.push({
          typeNum,
          typeName: firstRowNode.data.typeName.toUpperCase(),
          uniqId:
            hasBack && previousStepRowData[0]?.[0]?.orderList
              ? previousStepRowData[0]?.[0]?.orderList[i]?.uniqId || ""
              : "",
          commisionName:
            hasBack && previousStepRowData[0]?.[0]?.orderList
              ? previousStepRowData[0]?.[0]?.orderList[i]?.commissionName || ""
              : "",
        });
      }
      setTypeRowData(newRow);
      setOpen(false);
      setShowProjectTypeQty(true);
    }
  };

  const isTaiwan = hasSupperUser
    ? selectedPartner?.value === 30058
    : customerId === 30058;
  const handleChangeDisplayName = (event) => {
    const rawValue = event.target.value;
    let validationValue = rawValue.toUpperCase();

    const maxLength = isTaiwan ? 2 : 4;
    if (validationValue.trim() === "") {
      setToastMessage("Project Short Name cannot be empty or spaces only!");
      setShowToast(true);
      setTimeout(() => setShowToast(false), 5000);
      setDisplayName("");
      return;
    }
    if (validationValue.includes("/") || validationValue.includes("\\")) {
      setToastMessage("Project Short Name must not contain '/' or '\\'!");
      setShowToast(true);
      setTimeout(() => setShowToast(false), 5000);
      return;
    }
    const specialCharRegex = /^[a-zA-Z0-9()_\- ]*$/;
    if (!specialCharRegex.test(validationValue)) {
      setToastMessage("Special characters are not allowed!");
      setShowToast(true);
      setTimeout(() => setShowToast(false), 5000);
      return;
    }

    if (validationValue.length > TOTAL_MAX_LENGTH) {
      setToastMessage(
        `Display Name cannot exceed ${TOTAL_MAX_LENGTH} characters!`,
      );
      setShowToast(true);
      setTimeout(() => setShowToast(false), 5000);
      setDisplayName(rawValue.slice(0, TOTAL_MAX_LENGTH));
      return;
    }

    setDisplayName(rawValue);
  };

  const checkAllCellsFilled = () => {
    return phasesRowData.every(
      (row) =>
        row.phaseName &&
        row.phaseName.trim() !== "" &&
        row.phaseViseQty &&
        row.phaseViseQty > 0 &&
        row.expectedProductionWeek,
    );
  };

  useEffect(() => {
    if (!isDraftOrder) {
      const allCellsFilled = checkAllCellsFilled();
      setIsSectionVisible(allCellsFilled);
    }
  }, [phasesRowData]);
  const isQtySufficientForPhases = (qty, phases) => {
    if (phases <= 0) return false;
    if (phases === 1) return qty >= 1;
    return qty >= 5 * (phases - 1);
  };
  const runMasterValidation = (activePhaseRow) => {
    let allPhasesValid = true;
    let totalPhaseQty = 0;

    if (phaseGridRef.current?.api) {
      phaseGridRef.current.api.forEachNode((node) => {
        const row = node.data;
        const nameValid = !!row.phaseName && row.phaseName.trim() !== "";
        const qtyValid = Number(row.phaseViseQty) > 0;
        const weekValid =
          row.expectedProductionWeek !== null &&
          row.expectedProductionWeek !== undefined &&
          row.expectedProductionWeek !== "";
        if (!nameValid || !qtyValid || !weekValid) allPhasesValid = false;
        totalPhaseQty += Number(row.phaseViseQty || 0);
      });
    }

    const totalMatchesQty = totalPhaseQty === Number(selectedQty);
    const isPhaseSectionValid = allPhasesValid && totalMatchesQty;

    if (!isPhaseSectionValid) {
      setIsSubmitEnabled(true);
      return;
    }

    if (showType && gridRef.current?.api) {
      let typeTotalQty = 0;
      let hasNegativeQty = false;
      let hasZeroQty = false;
      let allTypeCellsFilled = true;

      gridRef.current.api.forEachNode((node) => {
        const qty = Number(node.data.qty) || 0;
        typeTotalQty += qty;
        if (!node.data.typeName || qty === 0) allTypeCellsFilled = false;
        if (qty < 0) hasNegativeQty = true;
        if (qty === 0) hasZeroQty = true;
      });

      const selectedPhaseRow =
        activePhaseRow ?? phaseGridRef.current?.api.getSelectedNodes()[0];

      const selectedPhaseViseQty = Number(
        selectedPhaseRow?.data?.phaseViseQty ?? selectedPhaseRow?.phaseViseQty,
      );

      const isTypeSectionValid =
        !!selectedPhaseViseQty &&
        typeTotalQty === selectedPhaseViseQty &&
        !hasNegativeQty &&
        !hasZeroQty &&
        allTypeCellsFilled &&
        !!displayName &&
        !!typesPhaseQty;

      setIsSubmitEnabled(!isTypeSectionValid);
    } else {
      setIsSubmitEnabled(true); // fixed default
    }
  };
  useEffect(() => {
    const validationTimeout = setTimeout(() => {
      if (phaseGridRef.current?.api) {
        runMasterValidation();
      }
    }, 100);
    return () => clearTimeout(validationTimeout);
  }, [selectedQty, phasesRowData, typesPhaseQty, showType, rowData]);

  const validatePhases = () => {
    runMasterValidation();
  };

  const validateGrid = (phaseViseQty) => {
    const api = gridRef.current.api;
    let newTotalValue = 0;
    let hasNegativeQty = false;
    let hasZeroQty = false;
    let allCellsFilled = true;

    api.forEachNode((node) => {
      const qty = Number(node.data.qty) || 0;
      newTotalValue += qty;
      if (!node.data.typeName || qty === 0) {
        allCellsFilled = false;
      }
      if (qty < 0) hasNegativeQty = true;
      if (qty === 0) hasZeroQty = true;
    });

    setTypeTotalValue(newTotalValue);

    if (hasNegativeQty) {
      setToastMessage(
        "Remaining quantity is negative. Please adjust previous rows.",
      );
      setShowToast(true);
      setTimeout(() => setShowToast(false), 5000);
    } else if (hasZeroQty) {
      setToastMessage("Quantity cannot be 0. Minimum quantity is 1");
      setShowToast(true);
      setTimeout(() => setShowToast(false), 5000);
    }

    runMasterValidation();
  };
  const isSyncingPhaseQty = useRef(false);

  const onCellValueChangedPhases = (event) => {
    if (hasBack && event.colDef.field === "phaseViseQty") {
      setTypesPhaseQty("");
      setRowData([]);
    }
    const isRestricted = hasSupperUser
      ? selectedPartner?.value === 30058 ||
        selectedPartner?.value === 30002 ||
        selectedPartner?.value === 30005 ||
        selectedPartner?.value === 30092
      : customerId === 30058 ||
        customerId === 30002 ||
        customerId === 30005 ||
        customerId === 30092;

    if (event.colDef.field === "phaseViseQty") {
      if (editPhases && newQty && newPhases && !isRestricted) {
        if (!isQtySufficientForPhases(newQty, newPhases)) {
          handleRevertChanges();
          setToastMessage(
            `The quantity is not enough to distribute ${newPhases} phases `,
          );
          setShowToast(true);

          setTimeout(() => setShowToast(false), 5000);

          return;
        }
      }
      const newValue = Number(event.newValue);

      if (isNaN(newValue)) {
        setToastMessage("Invalid input! Only numeric values are allowed.");
        setShowToast(true);
        setTimeout(() => setShowToast(false), 5000);
        event.node.setDataValue("phaseViseQty", 0);
        return;
      }

      if (isSyncingPhaseQty.current) {
        return;
      }

      const rowData = [];
      phaseGridRef.current.api.forEachNode((node) => {
        rowData.push(node.data);
      });

      const lastRowIndex = rowData.length - 1;
      const rowIndex = event.node.rowIndex;

      isSyncingPhaseQty.current = true;
      try {
        //Restriction for taiwan and bahrain
        if (!isRestricted && rowIndex !== lastRowIndex && newValue < 5) {
          event.node.setDataValue("phaseViseQty", 5);
          setToastMessage("Phase-wise quantity minimum should be 5");
          setShowToast(true);

          setTimeout(() => setShowToast(false), 5000);
        }

        let totalExcludingLast = 0;
        phaseGridRef.current.api.forEachNode((node, index) => {
          if (index !== lastRowIndex) {
            totalExcludingLast += Number(node.data.phaseViseQty || 0);
          }
        });

        const remainingQty = selectedQty - totalExcludingLast;

        if (remainingQty < 0) {
          event.node.setDataValue("phaseViseQty", event.oldValue);
          setToastMessage("Total quantity exceeds the overall quantity!");
          setShowToast(true);

          setTimeout(() => setShowToast(false), 5000);
        }

        if (lastRowIndex >= 0) {
          const lastNode =
            phaseGridRef.current.api.getDisplayedRowAtIndex(lastRowIndex);

          if (Number(lastNode.data.phaseViseQty || 0) !== remainingQty) {
            lastNode.setDataValue("phaseViseQty", remainingQty);
          }
        }
      } finally {
        isSyncingPhaseQty.current = false;
      }
    }

    const allCellsFilled = checkAllCellsFilled();
    setIsSectionVisible(allCellsFilled);
    let newTotalValue = 0;
    phaseGridRef.current.api.forEachNode((node) => {
      newTotalValue += Number(node.data.phaseViseQty || 0);
    });
    setPhasesTotalValue(newTotalValue);
    if (selectedQty < newTotalValue || selectedQty > newTotalValue) {
      setShowPhasesAlert(true);
    } else {
      setShowPhasesAlert(false);
    }

    validatePhases();
  };

  const onCellValueChanged = (event) => {
    const { newValue, colDef, node } = event;
    const column = colDef.field;

    /* =========================
       TYPE NAME VALIDATION
    ========================= */
    if (column === "typeName") {
      const rowIndex = node.rowIndex;
      let duplicate = false;

      gridRef.current.api.forEachNode((n) => {
        if (
          n.rowIndex !== rowIndex &&
          n.data.typeName &&
          n.data.typeName === newValue
        ) {
          duplicate = true;
        }
      });

      if (duplicate) {
        node.setDataValue("typeName", "");
        setToastMessage(`Duplicate value ${newValue} not allowed!`);
        setShowToast(true);
        setTimeout(() => setShowToast(false), 5000);
        return;
      }

      const displayLen = displayName?.length || 0;
      const maxLen = 20 - displayLen;

      if (maxLen <= 0) {
        node.setDataValue("typeName", "");
        setToastMessage(
          "No space left for Type Name! Please adjust the Project short code",
        );
        setShowToast(true);
        setTimeout(() => setShowToast(false), 5000);
        return;
      }

      if (newValue && newValue.length > maxLen) {
        node.setDataValue("typeName", newValue.substring(0, maxLen));
        setToastMessage(`Type Name can have max ${maxLen} characters`);
        setShowToast(true);
        setTimeout(() => setShowToast(false), 5000);
        return;
      }
    }
    if (event.colDef.field === "qty") {
      const newValue = Number(event.newValue);

      if (isNaN(newValue)) {
        setToastMessage("Invalid input! Only numeric values are allowed.");
        setShowToast(true);
        setTimeout(() => setShowToast(false), 5000);
        event.node.setDataValue("qty", 0);
        return;
      }
    }
    /* =========================
       STOP MID-PASTE CALCULATION
    ========================= */
    if (isPasting) return;

    recalculateTotals();
  };

  const recalculateTotals = () => {
    const api = gridRef.current.api;

    let totalEnteredQty = 0;
    let lastRowNode = null;
    let rowCount = 0;

    api.forEachNode((node) => {
      lastRowNode = node;
      rowCount++;
    });

    api.forEachNode((node, index) => {
      if (index !== rowCount - 1) {
        totalEnteredQty += Number(node.data.qty) || 0;
      }
    });

    const selectedRow = phaseGridRef.current.api.getSelectedNodes()[0];

    const phaseViseQty = Number(selectedRow?.data?.phaseViseQty);

    if (!phaseViseQty && phaseViseQty !== 0) return;

    const remainingQty = phaseViseQty - totalEnteredQty;

    if (lastRowNode) {
      lastRowNode.setDataValue("qty", remainingQty);
    }

    validateGrid(phaseViseQty);
  };

  const onCellEditingStopped = (event) => {
    const { newValue, colDef, node } = event;
    if (colDef.field === "typeName") {
      const rowIndex = node.rowIndex;
      const allNodes = gridRef.current.api.getRenderedNodes();

      const duplicateInOtherRows = allNodes.some((otherNode) => {
        return (
          otherNode.rowIndex !== rowIndex &&
          otherNode.data.typeName === newValue
        );
      });

      if (duplicateInOtherRows) {
        gridRef.current.api.startEditingCell({
          rowIndex: node.rowIndex,
          colKey: colDef.field,
        });

        setToastMessage(`Duplicate value ${newValue} not allowed!`);
        setShowToast(true);

        setTimeout(() => setShowToast(false), 5000);
      }
    }
  };
  const onRowClicked = (event) => {
    const firstRowNode = gridRef.current.api.getDisplayedRowAtIndex(0);
    if (firstRowNode && event.node !== firstRowNode) {
      event.node.setSelected(false);
      firstRowNode.setSelected(true, true);
    }
  };
  const onRowSelected = (event) => {
    const firstRowNode = gridRef.current.api.getDisplayedRowAtIndex(0);

    if (event.node !== firstRowNode && event.node.isSelected()) {
      event.node.setSelected(false);

      firstRowNode.setSelected(true, true);
    }
  };

  const onFirstDataRendered = (params) => {
    const firstRowNode = params.api.getDisplayedRowAtIndex(0);
    if (firstRowNode) {
      firstRowNode.setSelected(true, true);
    }
  };

  const typeCellValueChanged = (params) => {
    const { newValue, colDef, node } = params;
    const rowNode = node;

    if (colDef.field === "uniqId") {
      const rowIndex = node.rowIndex;
      const allNodes = typeGridRef.current.api.getRenderedNodes();

      const duplicateInOtherRows = allNodes.some(
        (otherNode) =>
          otherNode.rowIndex !== rowIndex && otherNode.data.uniqId === newValue,
      );

      if (duplicateInOtherRows) {
        typeGridRef.current.api.startEditingCell({
          rowIndex: node.rowIndex,
          colKey: colDef.field,
        });
        toast.warning(`Duplicate value ${newValue} not allowed!`);
        const updatedRows = [];
        typeGridRef.current.api.forEachNode((node) => {
          updatedRows.push({ ...node.data });
        });

        setTypeRowData(updatedRows);
        return;
      }

      const displayLen = displayName?.length || 0;
      const typeNameLen = node.data.typeName?.length || 0;
      const maxUniqIdLength = 20 - displayLen - typeNameLen;

      if (maxUniqIdLength <= 0) {
        toast.warning(
          "No space left for Unique ID! Please adjust the Typename and project short code",
        );
        rowNode.setDataValue("uniqId", "");
        return;
      }

      if (newValue && newValue.length > maxUniqIdLength) {
        rowNode.setDataValue("uniqId", newValue.substring(0, maxUniqIdLength));
        toast.warning(`Unique ID can have max ${maxUniqIdLength} characters`);
      }
    }

    const finalUniqId = rowNode.data.uniqId || "";

    const updateCommissionName =
      orderReference?.length === 6
        ? `${orderReference}${rowNode.data.typeNum}-${
            product?.value ?? ""
          }-${rowNode.data.typeName?.toUpperCase()}-${displayName?.toUpperCase()}-${finalUniqId.toUpperCase()}`
        : `${orderReference}${rowNode.data.typeNum}${
            product?.value ?? ""
          }-${rowNode.data.typeName?.toUpperCase()}-${displayName?.toUpperCase()}-${finalUniqId.toUpperCase()}`;

    rowNode.setDataValue("commisionName", updateCommissionName);
  };

  const typeCellEditingStopped = (event) => {
    const { newValue, colDef, node } = event;

    if (colDef.field === "uniqId") {
      const rowIndex = node.rowIndex;
      const allNodes = typeGridRef.current.api.getRenderedNodes();

      const duplicateInOtherRows = allNodes.some(
        (otherNode) =>
          otherNode.rowIndex !== rowIndex && otherNode.data.uniqId === newValue,
      );

      if (duplicateInOtherRows) {
        setTimeout(() => {
          typeGridRef.current.api.startEditingCell({
            rowIndex: node.rowIndex,
            colKey: colDef.field,
          });
        }, 0);

        setToastMessage(`Duplicate value ${newValue} not allowed!`);
        setShowToast(true);
        setTimeout(() => setShowToast(false), 5000);
        return;
      }
    }

    const updatedRows = [];
    typeGridRef.current.api.forEachNode((node) => {
      updatedRows.push({ ...node.data });
    });

    setTypeRowData(updatedRows);
  };

  const totalSteps = () => {
    return steps.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const [baseTypeCount, setBaseTypeCount] = useState(0);
  const count = baseTypeCount + activeStep;
  useEffect(() => {
    if (!steps || !Array.isArray(steps) || steps.length === 0) return;
    if (!steps[activeStep] && !rowDataSaved[activeStep]) return;

    if (activeStep || hasBack) {
      const currentStepData =
        hasBack && !isDraftOrder ? rowDataSaved[activeStep] : steps[activeStep];

      if (!currentStepData || !currentStepData.typeName) return;
      const typeName = currentStepData.typeName.toUpperCase();
      const typeNum =
        orderReference?.length === 6
          ? (count + 1).toString().padStart(2, "0")
          : (count + 1).toString().padStart(3, "0");
      if (typeName) {
        const value =
          hasBack && !isDraftOrder
            ? rowDataSaved[activeStep]?.qty
            : steps[activeStep]?.qty;
        const newRow = [];
        const orderList =
          hasBack && !isDraftOrder
            ? previousStepRowData[activeStep]?.[activeStep]?.orderList
            : [];
        for (let i = 0; i < value; i++) {
          newRow.push({
            typeNum,
            typeName,
            uniqId:
              hasBack &&
              !isDraftOrder &&
              previousStepRowData[activeStep]?.[activeStep]?.orderList
                ? orderList[i]?.uniqId || ""
                : "",
            commisionName:
              hasBack &&
              !isDraftOrder &&
              previousStepRowData[activeStep]?.[activeStep]?.orderList
                ? orderList[i]?.commissionName || ""
                : "",
          });
        }

        setTypeRowData(newRow);
        setOpen(false);
        setShowProjectTypeQty(true);
      }
    }
  }, [activeStep, steps, hasBack]);

  const [stepData, setStepData] = useState([]);
  const normalizeToString = (value) => {
    if (value == null) return null;

    if (Array.isArray(value)) {
      return value.length ? String(value[0]) : null;
    }

    return String(value);
  };
  const handleNext = async (e) => {
    e.preventDefault();

    const nextStep = activeStep + 1;

    setActiveStep(nextStep);

    if (!hasBack && activeStep < previousStepRowData.length) {
      dispatch(setHasBack(false));
    } else {
      dispatch(setHasBack(true));
    }

    const typeName = rowData.map((row) => row.typeName.toUpperCase());
    const materialFormData = formValues.flatMap((item, index) => {
      const result = {};
      Object.entries(item).forEach(([key, value]) => {
        const prefix = `${key}${index + 1}`;
        if (key === "priceGroup") {
          result[prefix] = value.label;
        } else {
          result[`${prefix}Id`] = value.value;
          result[prefix] = value.label;
        }
      });
      return result;
    });
    const resultObject = materialFormData.reduce(
      (accumulator, currentObject, index) => {
        Object.entries(currentObject).forEach(([key, value]) => {
          accumulator[key] = value;
        });
        return accumulator;
      },
      {},
    );
    const additionalProps = [];
    let key = "";
    phasesRowData.map((i, index) => {
      key = index;
      additionalProps[key] = i;
    });
    const tempDraft = uploadValue[0]
      ? uploadValue?.map((item) => ({
          drawingFileId: item.id || null,
          drawingFileName: item.uploadFile?.name || null,
        }))
      : [];

    const orderList = typeRowData.map((i) => ({
      uniqId: i.uniqId.toUpperCase(),
      commissionName: i.commisionName,
    }));
    const stepDraft = {
      [activeStep]: {
        ...resultObject,
        // formValueNew,
        vendorId: product?.id,
        vendor: product?.label,
        projectTypeNum: count + 1,
        volume: volume,
        weight: weight,
        orderList: orderList,
        wg1: WG1Price,
        wg2: WG2Price,
        isSpecialDiscount: discountChecked,
        specialDiscountFileUrl: SDFile?.name,
        loadingWeek: loadingWeek?.value,
        freightId: freight?.id,
        freight: freight?.value,
        specialComments: comment?.toUpperCase(),
        sharedLater: sharedLater,
        na: notApplicable,
        drawFileSupersedes: true,
        drwFileId: DRWFile ? String(drwFileId) : "" || null,
        drwFileName: DRWFile?.name || null,
        applianceDetailId: appliancesDetail
          ? String(appliancesDetailFileId)
          : "" || null,
        applianceDetailName: appliancesDetail?.name || null,
        orderCheckListId: orderCheckFile
          ? String(orderCheckFileId)
          : "" || null,
        orderCheckListName: orderCheckFile?.name || null,
        drawingFile: tempDraft,
        typeName: typeName[activeStep].toUpperCase(),
      },
    };
    const resultStepData = Object.values(stepDraft).map((item) => item);

    setDraftProjectInfo((prev) => {
      const updatedDraft = Array.isArray(prev) ? [...prev] : [];
      updatedDraft[activeStep] = resultStepData[0]; // Update step data
      return updatedDraft;
    });

    const temp = uploadValue[0]?.uploadFile ? uploadValue.map((i) => i.id) : [];

    const filterCurrentPhase = phasesRowData.map((row) => {
      const weekString = row.expectedProductionWeek;
      const week =
        weekString && typeof weekString === "string"
          ? weekString.split("/")[0]
          : weekString;
      const isCurrentPhase =
        selectedRows[0] && row.phaseName === selectedRows[0].phaseName
          ? true
          : false;
      const orderPlaced = row?.orderPlaced || false;

      // Base object
      let result = {
        id: row.id,
        phaseName: row.phaseName,
        qty: row.phaseViseQty,
        year: row.year,
        expectedProductionWeek: Number(week),
        phaseViseQty: row.phaseViseQty,
        isCurrentPhase,
      };

      if (!orderPlaced && isCurrentPhase) {
        const typeViseQty = {};

        rowData.forEach((item) => {
          typeViseQty[item.typeName.toUpperCase()] = item.qty;
        });

        result = { ...result, typeViseQty };
      } else if (orderPlaced && !isCurrentPhase) {
        const typeViseQty = row?.typeViseQty || {};
        result = { ...result, typeViseQty };
      }
      return result;
    });

    const step = {
      [activeStep]: {
        ...resultObject,
        // formValueNew,
        vendorId: product?.id,
        vendor: product?.label,
        projectTypeNum: count + 1,
        volume: volume,
        weight: weight,
        orderList: orderList,
        wg1: WG1Price || 0,
        wg2: WG2Price || 0,
        isSpecialDiscount: discountChecked,
        specialDiscountFileUrl: SDFile?.name,
        loadingWeek: loadingWeek?.value,
        freightId: freight?.id,
        freight: freight?.value,
        specialComments: comment?.toUpperCase(),
        sharedLater: sharedLater,
        na: notApplicable,
        drawFileSupersedes: true,
        //  drwFile: normalizeToString(drwFileId),
        // applianceDetail: normalizeToString(appliancesDetailFileId),
        // orderCheckList: normalizeToString(orderCheckFileId),
        // drawingFile: temp,
        drwFileId: DRWFile ? String(drwFileId) : "" || null,
        drwFileName: DRWFile?.name || null,
        applianceDetailId: appliancesDetail
          ? String(appliancesDetailFileId)
          : "" || null,
        applianceDetailName: appliancesDetail?.name || null,
        orderCheckListId: orderCheckFile
          ? String(orderCheckFileId)
          : "" || null,
        orderCheckListName: orderCheckFile?.name || null,
        drawingFile: tempDraft,
        typeName: typeName[activeStep].toUpperCase(),
      },
    };
    const updatedStepData = [...stepData];
    updatedStepData[activeStep] = step;

    dispatch(setPreviousStepData({ stepIndex: activeStep, data: step }));

    setStepData(updatedStepData);
    const isNavigatingExistingType =
      isDraftOrder && activeStep < apiProjectTypes.length;
    // setStepData([...stepData, step]);
    if (nextStep === rowData.length) {
      const savedDraftId = await handleSaveDraft(!isNavigatingExistingType);
      const allStepData = [...stepData, step];
      const resultStepData = allStepData.map((item) => {
        const key = Object.keys(item)[0];
        const originalData = item[key];
        return originalData;
      });
      const updatedProjectTypeInfo = resultStepData.map((item) => ({
        vendorId: item.vendorId,
        vendor: item.vendor,
        vendorShortKey: item.vendorShortKey,
        projectTypeNum: Number(item.projectTypeNum),
        volume: Number(item.volume),
        weight: Number(item.weight),
        orderList: item.orderList,

        range1Id: item.range1Id,
        range1: item.range1,
        priceGroup1: item.priceGroup1,
        color1Id: item.color1Id,
        color1: item.color1,
        carcass1Id: item.carcass1Id,
        carcass1: item.carcass1,
        handle1Id: item.handle1Id,
        handle1: item.handle1,

        wg1: Number(item.wg1),
        wg2: Number(item.wg2),

        isSpecialDiscount: item.isSpecialDiscount,
        loadingWeek: item.loadingWeek,
        freightId: item.freightId,
        freight: item.freight,
        specialComments: item.specialComments,
        sharedLater: item.sharedLater,
        na: item.na,
        drawFileSupersedes: item.drawFileSupersedes,

        drwFile: normalizeToString(item.drwFileId),
        applianceDetail: normalizeToString(item.applianceDetailId),
        orderCheckList: normalizeToString(item.orderCheckListId),
        drawingFile: item.uploadValue?.[0]?.uploadFile
          ? item.uploadValue.map((i) => i.id)
          : [],

        typeName: item.typeName,
      }));
      const payload = {
        customerId: hasSupperUser ? selectedPartner?.value : customerId,
        showroomId: showroom.value,
        orderCategory: orderCategoryValue?.value,
        docType: "SO",
        orderRef: orderReference,
        projectTypeInfo: updatedProjectTypeInfo,
        overallQty: selectedQty,
        projectDisplayName: displayName?.toUpperCase(),
        phasesInfo: filterCurrentPhase,
        currentPhaseId: selectedRows[0].id,
        containerNo: containerNo?.toUpperCase(),
        customerProjectNum: 0,
        //projectForecastId: selectedProName.id,
        // projectTypeNum: 0,
        // projectNum: "string",
        projectName: selectedProName.label,
      };
      console.log(payload);
      navigate("/order/project-order", {
        state: {
          payload,
          draftId: savedDraft || draftId,
        },
      });
    } else {
      await handleSaveDraft(!isNavigatingExistingType);
      setShowToastMsg(false);
    }
  };

  const handleProjectOverviewClose = () => {
    setProjectOverviewOpen(false);
  };

  const handleBack = async () => {
    dispatch(setHasBack(true));

    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    const typeName = rowData.map((row) => row.typeName.toUpperCase());

    const materialFormData = formValues.flatMap((item, index) => {
      const result = {};
      Object.entries(item).forEach(([key, value]) => {
        const prefix = `${key}${index + 1}`;
        if (key === "priceGroup") {
          result[prefix] = value.label;
        } else {
          result[`${prefix}Id`] = value.value;
          result[prefix] = value.label;
        }
      });
      return result;
    });

    const resultObject = materialFormData.reduce((acc, curr) => {
      Object.entries(curr).forEach(([key, value]) => {
        acc[key] = value;
      });
      return acc;
    }, {});
    const additionalProps = [];
    let key = "";
    phasesRowData.map((i, index) => {
      key = index;
      additionalProps[key] = i;
    });
    const tempDraft = uploadValue[0]
      ? uploadValue?.map((item) => ({
          drawingFileId: item.id || null,
          drawingFileName: item.uploadFile?.name || null,
        }))
      : [];
    const orderList = typeRowData.map((i) => ({
      uniqId: i.uniqId.toUpperCase(),
      commissionName: i.commisionName,
    }));
    const stepDraft = {
      [activeStep]: {
        ...resultObject,
        // formValueNew,
        vendorId: product?.id,
        vendor: product?.label,
        projectTypeNum: count + 1,
        volume: volume,
        weight: weight,
        orderList: orderList,
        wg1: WG1Price,
        wg2: WG2Price,
        isSpecialDiscount: discountChecked,
        specialDiscountFileUrl: SDFile?.name,
        loadingWeek: loadingWeek?.value,
        freightId: freight?.id,
        freight: freight?.value,
        specialComments: comment?.toUpperCase(),
        sharedLater: sharedLater,
        na: notApplicable,
        drawFileSupersedes: true,
        drwFileId: DRWFile ? String(drwFileId) : "" || null,
        drwFileName: DRWFile?.name || null,
        applianceDetailId: appliancesDetail
          ? String(appliancesDetailFileId)
          : "" || null,
        applianceDetailName: appliancesDetail?.name || null,
        orderCheckListId: orderCheckFile
          ? String(orderCheckFileId)
          : "" || null,
        orderCheckListName: orderCheckFile?.name || null,
        drawingFile: tempDraft,
        typeName: typeName[activeStep].toUpperCase(),
      },
    };
    const resultStepData = Object.values(stepDraft).map((item) => item);

    setDraftProjectInfo((prev) => {
      const updatedDraft = Array.isArray(prev) ? [...prev] : [];
      updatedDraft[activeStep] = resultStepData[0]; // Update step data
      return updatedDraft;
    });

    const temp = uploadValue[0]?.uploadFile ? uploadValue.map((i) => i.id) : [];

    const step = {
      [activeStep]: {
        ...resultObject,
        vendorId: product?.id,
        vendor: product?.label,
        projectTypeNum: count + 1,
        volume,
        weight,
        orderList,
        wg1: WG1Price || 0,
        wg2: WG2Price || 0,
        isSpecialDiscount: discountChecked,
        specialDiscountFileUrl: SDFile?.name,
        loadingWeek: loadingWeek?.value,
        freightId: freight?.id,
        freight: freight?.value,
        specialComments: comment?.toUpperCase(),
        sharedLater,
        na: notApplicable,
        drawFileSupersedes: true,
        drwFileId: DRWFile ? String(drwFileId) : "" || null,
        drwFileName: DRWFile?.name || null,
        applianceDetailId: appliancesDetail
          ? String(appliancesDetailFileId)
          : "" || null,
        applianceDetailName: appliancesDetail?.name || null,
        orderCheckListId: orderCheckFile
          ? String(orderCheckFileId)
          : "" || null,
        orderCheckListName: orderCheckFile?.name || null,
        drawingFile: tempDraft,
        typeName: typeName[activeStep],
      },
    };

    dispatch(
      setPreviousStepData({
        stepIndex: activeStep,
        data: step,
      }),
    );

    const isNavigatingExistingType =
      isDraftOrder && activeStep <= apiProjectTypes.length;

    await handleSaveDraft(!isNavigatingExistingType);
  };
  const handleBackProjectForm = async () => {
    dispatch(setHasBackOrderForm(true));
    dispatch(setHasBack(true));

    const typeName = rowData.map((row) => row.typeName.toUpperCase());

    const materialFormData = formValues.flatMap((item, index) => {
      const result = {};
      Object.entries(item).forEach(([key, value]) => {
        const prefix = `${key}${index + 1}`;
        if (key === "priceGroup") {
          result[prefix] = value.label;
        } else {
          result[`${prefix}Id`] = value.value;
          result[prefix] = value.label;
        }
      });
      return result;
    });

    const resultObject = materialFormData.reduce((acc, curr) => {
      Object.entries(curr).forEach(([key, value]) => {
        acc[key] = value;
      });
      return acc;
    }, {});
    const additionalProps = [];
    let key = "";
    phasesRowData.map((i, index) => {
      key = index;
      additionalProps[key] = i;
    });
    const tempDraft = uploadValue[0]
      ? uploadValue?.map((item) => ({
          drawingFileId: item.id || null,
          drawingFileName: item.uploadFile?.name || null,
        }))
      : [];
    const orderList = typeRowData.map((i) => ({
      uniqId: i.uniqId.toUpperCase(),
      commissionName: i.commisionName,
    }));
    const stepDraft = {
      [activeStep]: {
        ...resultObject,
        // formValueNew,
        vendorId: product?.id,
        vendor: product?.label,
        projectTypeNum: count + 1,
        volume: volume,
        weight: weight,
        orderList: orderList,
        wg1: WG1Price,
        wg2: WG2Price,
        isSpecialDiscount: discountChecked,
        specialDiscountFileUrl: SDFile?.name,
        loadingWeek: loadingWeek?.value,
        freightId: freight?.id,
        freight: freight?.value,
        specialComments: comment?.toUpperCase(),
        sharedLater: sharedLater,
        na: notApplicable,
        drawFileSupersedes: true,
        drwFileId: DRWFile ? String(drwFileId) : "" || null,
        drwFileName: DRWFile?.name || null,
        applianceDetailId: appliancesDetail
          ? String(appliancesDetailFileId)
          : "" || null,
        applianceDetailName: appliancesDetail?.name || null,
        orderCheckListId: orderCheckFile
          ? String(orderCheckFileId)
          : "" || null,
        orderCheckListName: orderCheckFile?.name || null,
        drawingFile: tempDraft,
        typeName: typeName[activeStep].toUpperCase(),
      },
    };
    const resultStepData = Object.values(stepDraft).map((item) => item);

    setDraftProjectInfo((prev) => {
      const updatedDraft = Array.isArray(prev) ? [...prev] : [];
      updatedDraft[activeStep] = resultStepData[0]; // Update step data
      return updatedDraft;
    });

    const temp = uploadValue[0]?.uploadFile ? uploadValue.map((i) => i.id) : [];

    const step = {
      [activeStep]: {
        ...resultObject,
        vendorId: product?.id,
        vendor: product?.label,
        projectTypeNum: count + 1,
        volume,
        weight,
        orderList,
        wg1: WG1Price || 0,
        wg2: WG2Price || 0,
        isSpecialDiscount: discountChecked,
        specialDiscountFileUrl: SDFile?.name,
        loadingWeek: loadingWeek?.value,
        freightId: freight?.id,
        freight: freight?.value,
        specialComments: comment?.toUpperCase(),
        sharedLater,
        na: notApplicable,
        drawFileSupersedes: true,
        drwFileId: DRWFile ? String(drwFileId) : "" || null,
        drwFileName: DRWFile?.name || null,
        applianceDetailId: appliancesDetail
          ? String(appliancesDetailFileId)
          : "" || null,
        applianceDetailName: appliancesDetail?.name || null,
        orderCheckListId: orderCheckFile
          ? String(orderCheckFileId)
          : "" || null,
        orderCheckListName: orderCheckFile?.name || null,
        drawingFile: tempDraft,
        typeName: typeName[activeStep],
      },
    };

    dispatch(
      setPreviousStepData({
        stepIndex: activeStep,
        data: step,
      }),
    );

    await handleSaveDraft();

    setOpen(true);

    setShowType(true);
  };

  const handleSaveDraft = async (showToast = true) => {
    setShowToastMsg(showToast);
    const typeName = rowData.map((row) => row.typeName.toUpperCase());

    const materialFormData = formValues.flatMap((item, index) => {
      const result = {};
      Object.entries(item).forEach(([key, value]) => {
        const prefix = `${key}${index + 1}`;
        if (key === "priceGroup") {
          result[prefix] = value.label;
        } else {
          result[`${prefix}Id`] = value.value;
          result[prefix] = value.label;
        }
      });
      return result;
    });

    const resultObject = materialFormData.reduce(
      (accumulator, currentObject) => {
        Object.entries(currentObject).forEach(([key, value]) => {
          accumulator[key] = value;
        });
        return accumulator;
      },
      {},
    );

    const temp = uploadValue[0]
      ? uploadValue.map((item) => ({
          drawingFileId: item.id || null,
          drawingFileName: item.uploadFile?.name || null,
        }))
      : [];

    const orderList = typeRowData.map((i) => ({
      uniqId: i.uniqId.toUpperCase(),
      commissionName: i.commisionName,
    }));

    const step = {
      [activeStep]: {
        ...resultObject,
        vendorId: product?.id,
        vendor: product?.label,
        projectTypeNum: count + 1,
        volume,
        weight,
        orderList,
        wg1: WG1Price || 0,
        wg2: WG2Price || 0,
        isSpecialDiscount: discountChecked,
        specialDiscountFileUrl: SDFile?.name,
        loadingWeek: loadingWeek?.value,
        freightId: freight?.id,
        freight: freight?.value,
        specialComments: comment?.toUpperCase(),
        sharedLater,
        na: notApplicable,
        drawFileSupersedes: true,
        drwFileId: DRWFile ? String(drwFileId) : "" || null,
        drwFileName: DRWFile?.name || null,
        applianceDetailId: appliancesDetail
          ? String(appliancesDetailFileId)
          : "" || null,
        applianceDetailName: appliancesDetail?.name || null,
        orderCheckListId: orderCheckFile
          ? String(orderCheckFileId)
          : "" || null,
        orderCheckListName: orderCheckFile?.name || null,
        drawingFile: temp,
        typeName: typeName[activeStep].toUpperCase(),
        currentType:
          steps[activeStep].typeName.toUpperCase() ===
          typeName[activeStep].toUpperCase(),
      },
    };

    const resultStepData = Object.values(step);
    setDraftProjectInfo((prev) => {
      const isExistingDraft = apiProjectTypes && apiProjectTypes.length > 0;
      const base = isExistingDraft
        ? prev.length > 0
          ? prev
          : apiProjectTypes
        : prev;

      let updatedDraftInfo;

      if (isExistingDraft) {
        const currentTypeName = typeName[activeStep].toUpperCase();

        const existingIndex = base.findIndex(
          (item) => item?.typeName === currentTypeName,
        );

        if (existingIndex >= 0) {
          updatedDraftInfo = [...base];
          updatedDraftInfo[existingIndex] = resultStepData[0];
        } else {
          updatedDraftInfo = [...base, resultStepData[0]];
        }
      } else {
        updatedDraftInfo = [...base];
        updatedDraftInfo[activeStep] = resultStepData[0];
      }
      // Remove null, undefined, or empty objects
      const cleanedProjectTypes = updatedDraftInfo.filter(
        (type) => type && Object.keys(type).length > 0 && type.typeName,
      );

      updateProjectTypes(cleanedProjectTypes);

      return updatedDraftInfo;
    });

    const updateProjectTypes = async (updatedDraftInfo) => {
      const filterCurrentPhase = phasesRowData.map((row) => {
        const weekString = row.expectedProductionWeek;
        const week =
          weekString && typeof weekString === "string"
            ? weekString.split("/")[0]
            : weekString;
        const isCurrentPhase =
          selectedRows[0] && row.phaseName === selectedRows[0].phaseName;
        const orderPlaced = row?.orderPlaced || false;

        let result = {
          id: row.id,
          phaseName: row.phaseName,
          qty: row.phaseViseQty,
          year: row.year,
          expectedProductionWeek: Number(week),
          phaseViseQty: row.phaseViseQty,
          isCurrentPhase,
          orderPlaced,
        };

        if (!orderPlaced && isCurrentPhase) {
          const typeViseQty = {};
          rowData.forEach((item) => {
            typeViseQty[item.typeName.toUpperCase()] = item.qty;
          });

          result = { ...result, typeViseQty, projectTypes: updatedDraftInfo };
        } else if (orderPlaced && !isCurrentPhase) {
          result = { ...result, typeViseQty: row?.typeViseQty || {} };
        }

        return result;
      });

      const savedDraftId = await sendDraftData(filterCurrentPhase);
      setSavedDraft(savedDraftId);
      return savedDraftId;
    };

    const sendDraftData = async (filterCurrentPhase) => {
      const payload = {
        customerId: hasSupperUser ? selectedPartner?.value : customerId,
        showroomId: showroom.value,
        orderCategory: orderCategoryValue?.value,
        docType: "SO",
        orderRef: orderReference,
        phasesInfo: filterCurrentPhase,
        overallQty: selectedQty,
        totalPhases: phasesRowData.length,
        projectDisplayName: displayName?.toUpperCase(),
        currentPhaseId: selectedRows[0].id,
        containerNo: containerNo?.toUpperCase(),
        customerProjectNum: 0,
        projectName: selectedProName.label,
        vendorId: product.id,
        vendor: product.label,
        vendorShortKey: product.value,
        createdByUser: token?.email,
      };
      try {
        const response = draftId
          ? await OAuthService.updatePutData(projectDraftUrl, draftId, payload)
          : await OAuthService.addData(projectDraftUrl, payload);

        const data = response.data;
        if (data) {
          if (showToast) {
            toast.success(
              draftId
                ? "Draft Updated Successfully"
                : "Draft Saved Successfully",
            );
          }
          setDraftId(data.id);
          localStorage.setItem("draftId", data.id);
          return data.id;
        }
      } catch (error) {
        setError(error?.response?.data?.errorMessage || error.message);
        return null;
      }
    };
  };
  const handleStep = (step) => async () => {
    if (step === activeStep) return;

    const typeName = rowData.map((row) => row.typeName.toUpperCase());

    if (typeName[activeStep]) {
      const materialFormData = formValues.flatMap((item, index) => {
        const result = {};
        Object.entries(item).forEach(([key, value]) => {
          const prefix = `${key}${index + 1}`;
          if (key === "priceGroup") {
            result[prefix] = value.label;
          } else {
            result[`${prefix}Id`] = value.value;
            result[prefix] = value.label;
          }
        });
        return result;
      });

      const resultObject = materialFormData.reduce((acc, curr) => {
        Object.entries(curr).forEach(([key, value]) => {
          acc[key] = value;
        });
        return acc;
      }, {});

      const tempDraft = uploadValue[0]
        ? uploadValue.map((item) => ({
            drawingFileId: item.id || null,
            drawingFileName: item.uploadFile?.name || null,
          }))
        : [];

      const orderList = typeRowData.map((i) => ({
        uniqId: (i.uniqId || "").toUpperCase(),
        commissionName: i.commisionName,
      }));

      const currentStepData = {
        [activeStep]: {
          ...resultObject,
          vendorId: product?.id,
          vendor: product?.label,
          projectTypeNum: count + 1,
          volume,
          weight,
          orderList,
          wg1: WG1Price || 0,
          wg2: WG2Price || 0,
          isSpecialDiscount: discountChecked,
          specialDiscountFileUrl: SDFile?.name,
          loadingWeek: loadingWeek?.value,
          freightId: freight?.id,
          freight: freight?.value,
          specialComments: comment?.toUpperCase(),
          sharedLater,
          na: notApplicable,
          drawFileSupersedes: true,
          drwFileId: DRWFile ? String(drwFileId) : "" || null,
          drwFileName: DRWFile?.name || null,
          applianceDetailId: appliancesDetail
            ? String(appliancesDetailFileId)
            : "" || null,
          applianceDetailName: appliancesDetail?.name || null,
          orderCheckListId: orderCheckFile
            ? String(orderCheckFileId)
            : "" || null,
          orderCheckListName: orderCheckFile?.name || null,
          drawingFile: tempDraft,
          typeName: typeName[activeStep],
        },
      };

      dispatch(
        setPreviousStepData({ stepIndex: activeStep, data: currentStepData }),
      );

      setStepData((prev) => {
        const updated = [...prev];
        updated[activeStep] = currentStepData;
        return updated;
      });
    }

    dispatch(setHasBack(true));
    setActiveStep(step);
  };
  const handleSubmit = async () => {
    setCheckSubmit(true);
    setLoading(true);
    const materialFormData = formValues.flatMap((item, index) => {
      const result = {};
      Object.entries(item).forEach(([key, value]) => {
        const prefix = `${key}${index + 1}`;
        if (key === "priceGroup") {
          result[prefix] = value.label;
        } else {
          result[`${prefix}Id`] = value.value;
          result[prefix] = value.label;
        }
      });
      return result;
    });
    const resultObject = materialFormData.reduce(
      (accumulator, currentObject, index) => {
        Object.entries(currentObject).forEach(([key, value]) => {
          accumulator[key] = value;
        });
        return accumulator;
      },
      {},
    );

    const temp = uploadValue[0]?.uploadFile ? uploadValue.map((i) => i.id) : [];
    const customerNamePayload = hasSupperUser
      ? selectedPartner?.value
      : customerId;
    const payload = {
      ...resultObject,
      customerId: customerNamePayload,
      companyId: customerNamePayload,
      showroomId: showroom.value,
      orderCategory: orderCategoryValue?.value,
      docType: "SO",
      newOrder: mode === "new-type" ? false : true,
      containerNo: containerNo?.toUpperCase(),
      freightId: freight.id,
      freight: freight.value,
      wg1: WG1Price,
      wg2: WG2Price,
      volume: volume,
      weight: weight,
      vendorId: product.id,
      vendor: product.label,
      projectTypeNum: Number(typeNumber),
      projectUniqueId: fullUniqueID?.toUpperCase(),
      projectClient: clientName?.toUpperCase(),
      commissionName: commissionName,
      orderRef: orderReference,
      specialComments: comment?.toUpperCase(),
      loadingWeek: loadingWeek.value,
      // vendorShortKey: product.value,
      typeName: typeNumber,
      sharedLater: sharedLater,
      na: notApplicable,
      drawFileSupersedes: drwFileSupersedes,
      isSpecialDiscount: discountChecked,
      drwFile: drwFileId,
      applianceDetail: appliancesDetailFileId,
      orderCheckList: orderCheckFileId,
      orderFiles: temp,
      specialDiscountFile: sdFileId,
      customerProjectNum: 0,
      hubspotReference: hubSpotReference,
      hubspotDealAmount: costOfHubSpot,
    };
    try {
      if (mode === "edit" && id) {
        await OAuthService.updateData(editOrderUrl, id, payload);
        setSuccessMsg("Data Updated Successfully");
        setSnackState(true);
        setLoading(false);
      } else {
        await OAuthService.addData(newOrderUrl, payload).then((list) => {
          const data = list.data;
          setCurrentOrder(data);
        });
        setOpenSuccessOrder(true);
        setCheckSubmit(false);
        setLoading(false);
        setPlaceOrderBtnDisable(true);
      }
    } catch (error) {
      toast.error(error?.response?.data?.errorMessage || error.message);
      setLoading(false);
      return;
    }
  };

  const handleRangeChange = (data, index, field) => {
    const newVals = formValues; //[index];
    newVals[index][field] = { value: data.value, label: data.label }; // data.value;
    setSelectedRange({ value: data.value, label: data.label, id: data.id });
    if (field === "range") {
      newVals[index]["color"] = {}; // data.value;
      newVals[index]["priceGroup"] = {
        value: data.priceGroup,
        label: data.priceGroup,
      };
      OAuthService.getList(`${colorUrl}/${data.id}/variations`)
        .then((list) => {
          const rangeVariations = list.data?._embedded?.rangeVariations;
          const colors = color;
          colors[index] = rangeVariations?.map((variations) => ({
            value: variations.productId,
            label: `${variations.productId}-${variations.productName}`,
          }));
          setColor((prev) => [...colors]);
        })
        .catch((err) => toast.error(err.message));
    }
    setFormValues((prev) => [...newVals]);
  };

  const resetFormValues = () => {
    const set = [];
    formValues.map(() => {
      set.push({ range: {}, color: {}, carcass: {}, handle: {} });
    });
    setFormValues(() => [...set]);
  };
  const handleSpecialDicount = (event) => {
    setDiscountChecked(event.target.checked);
  };

  const filterLoadingWeekOptions = loadingWeekOptions.map((option, index) => ({
    ...option,
    isDisabled: sharedLater && index === 1,
  }));

  const [key, setKey] = useState(0);

  const removeSDFile = async () => {
    try {
      await OAuthService.deleteData(deleteFileUrl, sdFileId);
      setSuccessMsg("File removed!");
      setSnackState(true);
      hiddenDicountFile.current.value = null;
      setSDFile(null);
    } catch (error) {
      toast.error(error.message);
    }
  };
  const removePRWFromStepData = () => {
    return stepData?.map((stepObj, index) => {
      const currentData = stepObj?.[index];

      return {
        [index]: {
          ...currentData,
          drwFile: null,
          drwFileId: null,
        },
      };
    });
  };
  const removePRWFromRedux = () => {
    stepData?.forEach((stepObj, index) => {
      const currentData = stepObj?.[index];

      dispatch(
        setPreviousStepData({
          stepIndex: index,
          data: {
            ...currentData,
            drwFile: null,
            drwFileId: null,
          },
        }),
      );
    });
  };
  const removeDRWFile = async () => {
    try {
      await OAuthService.deleteData(deleteFileUrl, drwFileId);
      const wasAppliedToAll = prwSelected;

      setSuccessMsg("File removed!");
      setSnackState(true);
      hiddenDRWFile.current.value = null;
      setDRWFile(null);
      setIsPRWFile(false);
      setPrwSelected(false);
      setPRWFile(null);
      setPrwFileId("");

      if (hasBack) {
        const existing = previousStepRowData?.[activeStep]?.[activeStep] || {};
        dispatch(
          setPreviousStepData({
            stepIndex: activeStep,
            data: {
              [activeStep]: {
                ...existing,
                drwFile: null,
                drwFileId: null,
                drwFileName: null,
              },
            },
          }),
        );
      }

      if (wasAppliedToAll) {
        toast.warn("PRW file is removed from all the types");
        removePrwFromAllTypes();
      }
    } catch (error) {
      toast.error(error.message);
    }
  };
  const prwNotYetApplied =
    isPRWFile && rowData.length - 1 !== 0 && !prwSelected;
  const removeADFile = async () => {
    try {
      await OAuthService.deleteData(deleteFileUrl, appliancesDetailFileId);
      setSuccessMsg("File removed!");
      setSnackState(true);
      hiddenADFile.current.value = null;
      setAppliancesDetail(null);
      if (hasBack) {
        dispatch(
          setPreviousStepData({
            stepIndex: activeStep,
            data: { appliancesDetail: null, appliancesDetailFileId: null },
          }),
        );
      }
    } catch (error) {
      toast.error(error.message);
    }
  };
  const removeOrderCheckFile = async () => {
    try {
      await OAuthService.deleteData(deleteFileUrl, orderCheckFileId);
      setSuccessMsg("File removed!");
      setSnackState(true);
      hiddenOrderCheckFile.current.value = null;
      setOrderCheckFile(null);
      if (hasBack) {
        dispatch(
          setPreviousStepData({
            stepIndex: activeStep,
            data: { orderCheckFile: null, orderCheckFileId: null },
          }),
        );
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const removeDrawingFile = async (index) => {
    try {
      await OAuthService.deleteData(deleteFileUrl, drawingFileId[index]);
      setSuccessMsg("File removed!");
      setSnackState(true);
      hiddenDrawingFile.current.value = null;
      setDrawingFile(null);
      const filteredFiles = [...uploadValue];
      filteredFiles[index] = { id: "", uploadFile: null };
      setUploadValue(filteredFiles);
      if (hasBack) {
        dispatch(
          setPreviousStepData({
            stepIndex: activeStep,
            data: { uploadValue: filteredFiles },
          }),
        );
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleSDUpload = (e) => {
    const fileUploaded = e.target.files[0];
    if (!fileUploaded) return;
    try {
      const payload = {
        file: [fileUploaded],
        customerId: hasSupperUser ? selectedPartner?.value : customerId,
        commissionName: commissionName,
        isOriginal: true,
      };
      OAuthService.addFiles(`${uploadOrderFileUrl}`, payload).then((list) => {
        const data = list.data;
        const fileId = data.map((file) => file.id);
        setSdFileId(fileId.join(""));
      });
      setSDFile(fileUploaded);
      const formData = new FormData();
      formData.append("File", SDFile);
      setKey((prevKey) => prevKey + 1);
    } catch (error) {
      toast.error("An error occurred during the file upload.");
      toast.error(
        error?.response?.data?.errorMessage ||
          error?.response?.data ||
          error.message,
      );
    }
  };
  const updatePreviousStepsWithPRW = (fileUploaded, fileId) => {
    for (let i = 0; i < activeStep; i++) {
      const currentData = stepData?.[i]?.[i];

      dispatch(
        setPreviousStepData({
          stepIndex: i,
          data: {
            ...currentData,
            drwFile: fileUploaded,
            drwFileId: fileId.join(""),
          },
        }),
      );
    }
  };
  const handleDRWUpload = async (e) => {
    if (hasSupperUser && !selectedPartner?.value) {
      toast.warn("Please Select Partner !");
      return;
    }
    const fileUploaded = e.target.files[0];
    if (!fileUploaded) return;

    const fileExtension = fileUploaded.name.split(".").pop().toLowerCase();
    if (fileExtension !== "drw" && fileExtension !== "prw") {
      toast.warning("Please upload a file with .drw or .prw extension");
      return;
    }
    setIsPRWFile(fileExtension === "prw");
    try {
      const payload = {
        file: [fileUploaded],
        customerId: hasSupperUser ? selectedPartner?.value : customerId,
        commissionName: commissionName,
        isOriginal: true,
      };

      const list = await OAuthService.addFiles(
        `${uploadOrderFileUrl}`,
        payload,
      );
      const data = list.data;
      const fileId = data.map((file) => file.id);
      setDrwFileId(fileId.join(""));
      setDRWFile(fileUploaded);

      if (
        orderCategoryValue?.value === "PRJ" ||
        orderCategoryValue?.value === "CPRJ"
      ) {
        const existing = previousStepRowData?.[activeStep]?.[activeStep] || {};
        dispatch(
          setPreviousStepData({
            stepIndex: activeStep,
            data: {
              [activeStep]: {
                ...existing,
                drwFile: fileUploaded,
                drwFileId: fileId.join(""),
                drwFileName: fileUploaded.name,
              },
            },
          }),
        );
      }

      setKey((prevKey) => prevKey + 1);
    } catch (error) {
      toast.error(
        error?.response?.data?.errorMessage ||
          error?.response?.data ||
          error.message,
      );
      hiddenDRWFile.current.value = null;
      setDRWFile(null);
    }
  };
  const handleADUpload = async (e) => {
    const fileUploaded = e.target.files[0];
    if (!fileUploaded) return;
    if (hasSupperUser && !selectedPartner?.value) {
      toast.warn("Please Select Partner !");
      return;
    }
    try {
      const payload = {
        file: [fileUploaded],
        customerId: hasSupperUser ? selectedPartner?.value : customerId,
        commissionName: commissionName,
        isOriginal: true,
      };
      const list = await OAuthService.addFiles(
        `${uploadOrderFileUrl}`,
        payload,
      );
      const data = list.data;
      const fileId = data.map((file) => file.id);
      setAppliancesDetailFileId(fileId.join(""));
      setAppliancesDetail(fileUploaded);
      if (
        orderCategoryValue?.value === "PRJ" ||
        orderCategoryValue?.value === "CPRJ"
      ) {
        dispatch(
          setPreviousStepData({
            stepIndex: activeStep,
            data: {
              appliancesDetail: fileUploaded,
              appliancesDetailFileId: fileId,
            },
          }),
        );
      }

      const formData = new FormData();
      formData.append("File", appliancesDetail);
      setKey((prevKey) => prevKey + 1);
    } catch (error) {
      toast.error(
        error?.response?.data?.errorMessage ||
          error?.response?.data ||
          error.message,
      );
    }
  };
  const handleOrderCheckUpload = async (e) => {
    const fileUploaded = e.target.files[0];
    if (!fileUploaded) return;
    if (hasSupperUser && !selectedPartner?.value) {
      toast.warn("Please Select Partner !");
      return;
    }
    try {
      const payload = {
        file: [fileUploaded],
        customerId: hasSupperUser ? selectedPartner?.value : customerId,
        commissionName: commissionName,
        isOriginal: true,
      };
      const list = await OAuthService.addFiles(
        `${uploadOrderFileUrl}`,
        payload,
      );
      const data = list.data;
      const fileId = data.map((file) => file.id);
      setOrderCheckFileId(fileId.join(""));
      setOrderCheckFile(fileUploaded);
      if (
        orderCategoryValue?.value === "PRJ" ||
        orderCategoryValue?.value === "CPRJ"
      ) {
        dispatch(
          setPreviousStepData({
            stepIndex: activeStep,
            data: { orderCheckFile: fileUploaded, orderCheckFileId: fileId },
          }),
        );
      }

      const formData = new FormData();
      formData.append("File", orderCheckFile);
      setKey((prevKey) => prevKey + 1);
    } catch (error) {
      toast.error(
        error?.response?.data?.errorMessage ||
          error?.response?.data ||
          error.message,
      );
    }
  };
  const handleDrawingUpload = async (e, index) => {
    const file = e.target.files[0];
    if (!file) return;
    if (hasSupperUser && !selectedPartner?.value) {
      toast.warn("Please Select Partner !");
      return;
    }

    try {
      const newUploadValue = [...uploadValue];
      const updatedItem = { ...newUploadValue[index], uploadFile: file };
      newUploadValue[index] = updatedItem;

      const payload = {
        file,
        customerId: hasSupperUser ? selectedPartner?.value : customerId,
        commissionName: commissionName,
        isOriginal: true,
      };

      const list = await OAuthService.addFiles(
        `${uploadOrderFileUrl}`,
        payload,
      );
      const data = list.data;
      const fileId = data.map((file) => file.id)[0];

      updatedItem.id = fileId;
      setDrawingFileId((prevIds) => [...prevIds, fileId]);
      setUploadValue(newUploadValue);

      if (
        orderCategoryValue?.value === "PRJ" ||
        orderCategoryValue?.value === "CPRJ"
      ) {
        dispatch(
          setPreviousStepData({
            stepIndex: activeStep,
            data: { uploadValue: newUploadValue },
          }),
        );
      }

      setKey((prevKey) => prevKey + 1);
    } catch (error) {
      toast.error(
        error?.response?.data?.errorMessage ||
          error?.response?.data ||
          error.message,
      );
    }
  };

  const handleUniqueIDChange = (e) => {
    const rawValue = e.target.value;
    const validationValue = rawValue.toUpperCase();

    if (validationValue.trim() === "" && rawValue !== "") {
      toast.warn("Unique ID cannot be spaces only!");
      return;
    }

    const specialCharRegex = /^[a-zA-Z0-9()_\- ]*$/;
    if (!specialCharRegex.test(validationValue)) {
      toast.warn("Special characters are not allowed!");
      return;
    }

    if (validationValue.includes("/") || validationValue.includes("\\")) {
      toast.warn("Unique ID must not contain '/' or '\\'.");
      return;
    }

    setUniqueID(rawValue);
    setLastEdited("uniqueID");
  };

  const handleClientNameChange = (e) => {
    const rawValue = e.target.value;
    const validationValue = rawValue.toUpperCase();
    if (validationValue.trim() === "") {
      toast.warn("Client Name cannot be empty or spaces only!");
      setClientName("");
      return;
    }
    const specialCharRegex = /^[a-zA-Z0-9()_\- ]*$/;
    if (!specialCharRegex.test(validationValue)) {
      toast.warn("Special characters are not allowed!");
      return;
    }

    const hasForwardSlash = validationValue.includes("/");
    const hasBackwardSlash = validationValue.includes("\\");
    if (hasForwardSlash || hasBackwardSlash) {
      let errorMessage = "Client Name must not contain";
      if (hasForwardSlash) errorMessage += " '/'.";
      if (hasBackwardSlash) errorMessage += " '\\'.";
      toast.warn(errorMessage);
      return;
    }

    setClientName(rawValue);
    setLastEdited("clientName");
  };

  const totalListPrice = useMemo(() => {
    const wg1 = parseFloat(WG1Price) || 0;
    const wg2 = parseFloat(WG2Price) || 0;
    const sum = wg1 + wg2;
    return sum.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
  }, [WG1Price, WG2Price, hasBack, previousStepRowData, activeStep]);

  useEffect(() => {
    if (sharedLater) {
      //const selectedOptionIsDisabled = loadingWeek?.value;
      /*
      if (
        selectedOptionIsDisabled === "CURRENT" ||
        selectedOptionIsDisabled === "FLEXIBLE"
      ) { */
      setLoadingWeek({ value: "ONHOLD", label: "On Hold" });
      //}
    }
  }, [sharedLater]);
  useEffect(() => {
    if (prwSelected) {
      if (isDraftOrder) {
        const currentProjectType = previousStepRowData?.[0]?.[0];
        setDRWFile(
          currentProjectType.drwFileId && currentProjectType.drwFileName
            ? {
                id: currentProjectType.drwFileId,
                name: currentProjectType.drwFileName,
              }
            : null,
        );
        setPRWFile(currentProjectType.drwFileName);
        setPrwFileId(currentProjectType.drwFileId);
      } else {
        setPRWFile(DRWFile);
        setPrwFileId(drwFileId);
      }
    } else {
      setPRWFile(null);
      setPrwFileId("");
    }
  }, [isDraftOrder, activeStep]);
  useEffect(() => {
    if (prwSelected) {
      setPRWFile(DRWFile);
      setPrwFileId(drwFileId);
    } else {
      setPRWFile(null);
      setPrwFileId("");
    }
  }, [prwSelected]);

  useEffect(() => {
    if (prwSelected && !isDraftOrder) {
      setDRWFile(PRWFile);
      setDrwFileId(prwFileId);
    }
  }, [activeStep]);

  const handleDownloadFile = async (fileId, fileName) => {
    const download = await OAuthService.getDownload(
      `${downloadOrderFileUrl}?orderAttachmentId=${fileId}`,
    );
    const blob = download?.data;
    if (blob) {
      const url = window.URL.createObjectURL(
        new Blob([blob], { type: "application/octet-stream" }),
      );
      const link = document.createElement("a");
      link.href = url;
      link.download = `${commissionName}-${fileName}`;
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    }
  };
  const previousTypesMissingDrw = useMemo(() => {
    const missing = [];

    for (let i = 0; i < activeStep; i++) {
      const typeData = previousStepRowData?.[i]?.[i];
      const hasFile = !!(typeData?.drwFileId || typeData?.drwFile);
      if (!hasFile) {
        missing.push(i + 1); // 1-based, for a human-readable message
      }
    }
    return missing;
  }, [previousStepRowData, activeStep]);
  const isValid = useMemo(() => {
    let isCategoryValid = true;
    if (
      orderCategoryValue?.value !== "PRJ" &&
      orderCategoryValue?.value !== "CPRJ"
    ) {
      const isHubspotValid =
        orderCategoryValue?.value === "RET" &&
        (newOrderData?.hubspotEnabled || typeOrderData?.hubspotEnabled)
          ? !!hubSpotReference
          : true;
      isCategoryValid = !!(
        showroom?.label &&
        product &&
        orderCategoryValue &&
        fullUniqueID &&
        !isUniqueIdDuplicate &&
        !isUniqueIdChecking &&
        clientName &&
        WG1Price &&
        WG2Price &&
        volume !== "" &&
        volume !== null &&
        volume !== undefined &&
        loadingWeek?.value &&
        freight?.value &&
        isHubspotValid &&
        !!DRWFile &&
        (!!appliancesDetail || sharedLater || notApplicable) &&
        (!!orderCheckFile || drwFileSupersedes) &&
        (!discountChecked || (discountChecked && SDFile)) &&
        formValues.every((value) =>
          Object.values(value).every(
            (field) => field && Object.keys(field).length > 0,
          ),
        )
      );
    } else {
      const hasDuplicateUniqIds = (() => {
        const uniqIds = typeRowData
          .map((row) => row.uniqId?.trim().toUpperCase())
          .filter(Boolean);

        return new Set(uniqIds).size !== uniqIds.length;
      })();
      isCategoryValid = !!(
        showroom?.label &&
        product &&
        orderCategoryValue &&
        WG1Price !== null &&
        WG1Price !== undefined &&
        WG2Price !== null &&
        WG2Price !== undefined &&
        volume !== "" &&
        volume !== null &&
        volume !== undefined &&
        loadingWeek?.value &&
        freight?.value &&
        !!(DRWFile || PRWFile) &&
        !prwNotYetApplied &&
        previousTypesMissingDrw.length === 0 &&
        (!!appliancesDetail || sharedLater || notApplicable) &&
        (!!orderCheckFile || drwFileSupersedes) &&
        formValues.every((value) =>
          Object.values(value).every(
            (field) => field && Object.keys(field).length > 0,
          ),
        ) &&
        typeRowData.every(
          (row) => row.uniqId !== undefined && row.uniqId !== "",
        ) &&
        !hasDuplicateUniqIds
      );
    }

    return isCategoryValid;
  }, [
    showroom,
    product,
    orderCategoryValue,
    uniqueID,
    clientName,
    WG1Price,
    WG2Price,
    volume,
    loadingWeek,
    freight,
    DRWFile,
    PRWFile,
    appliancesDetail,
    orderCheckFile,
    drwFileSupersedes,
    sharedLater,
    notApplicable,
    formValues,
    typeRowData,
    discountChecked,
    SDFile,
    previousTypesMissingDrw,
    prwNotYetApplied,
  ]);

  useEffect(() => {
    setBtnDisable(!isValid);
  }, [isValid]);
  const getRowStyle = (params) => {
    if (params.data.orderPlaced) {
      return {
        background: alpha(theme.palette.success.main, 0.25),
      };
    }
    return null;
  };

  const isRowSelectable = (params) => {
    return !params.data.orderPlaced;
  };

  const handleProductChange = (event) => {
    setProduct({
      value: event.value,
      label: event.label,
      id: event.id,
    });
    setSelectedPhases("");
    setPhasesTotalValue(0);
    setPhasesRowData([]);
    setDisplayName("");
    resetFormValues();
    setSelectedPhases("");
    setSelectedQty("");
    setPhasesRowData([]);
    setRowData([]);
    setDisplayName("");
    setBaseTypeCount(0);
    setShowType(false);
    setOriginalQty("");
    setVolume("");
    setWeight("");
    setWG1Price("");
    setWG2Price("");
    setContainerNo("");
    setLoadingWeek(null);
    setFreight(null);
    setComment("");
    setFormValues([
      {
        range: {},
        priceGroup: {},
        color: {},
        carcass: {},
        handle: {},
      },
    ]);
    setDRWFile("");
    setAppliancesDetail("");
    setOrderCheckFile("");
    setDrawingFile("");
    setSDFile("");
    setDiscountChecked(false);
    setSharedLater(false);
    setNotApplicable(false);
    setDrwFileSupersedes(false);
    setUploadValue([{ uploadFile: null }]);
    setTypeRowData([]);
    setDraftId();
    setTypesPhaseQty("");
    setShowPhasesAlert(false);
    setShowToast(false);
    setPrjOrderChange(true);
    dispatch(setHasBack(false));
    dispatch(clearRowDataValue());
    dispatch(clearStepData());
    setPhasesTotalValue(0);
    setTypeTotalValue(0);
    dispatch(setHasBackOrderForm(false));
  };
  const handleDraftOrderChange = (event) => {
    setDraftOrder({
      value: event.label,
      label: event.label,
      id: event.id,
    });
  };
  useEffect(() => {
    if (!draftOrder) return;
    const draftProject = draftList.find((item) => item.id === draftOrder.id);
    setSelectedDraftOrder(draftProject);
    setIsDraftOrder(true);
    setSelectedProName({
      value: draftProject?.projectName,
      label: draftProject?.projectName,
    });
    setProduct({
      label: draftProject?.vendor,
      id: draftProject?.vendorId,
      value: draftProject?.vendor
        .split(" ")
        .map((word) => word[0])
        .join(""),
    });
    const phases = draftProject?.phasesInfo || [];

    const currentPhaseIndex = phases.findIndex((phase) => phase.isCurrentPhase);

    let totalCount = 0;
    if (currentPhaseIndex > 0) {
      totalCount = phases
        .slice(0, currentPhaseIndex)
        .reduce(
          (sum, phase) =>
            sum +
            (phase?.typeViseQty ? Object.keys(phase.typeViseQty).length : 0),
          0,
        );
    }
    setBaseTypeCount(totalCount);
    const currentPhase = draftProject?.phasesInfo.find(
      (phase) => phase.isCurrentPhase,
    );
    if (currentPhase?.projectTypes?.length > 0) {
      const formattedStepData = currentPhase.projectTypes.map((type, index) => {
        return {
          [index]: {
            ...type,
          },
        };
      });

      formattedStepData.forEach((stepObj, index) => {
        dispatch(
          setPreviousStepData({
            stepIndex: index,
            data: stepObj,
          }),
        );
      });
    }
    setSelectedRows(currentPhase);
    setTypeTotalValue(currentPhase?.qty);
    setSelectedPhases(draftProject?.phasesInfo.length || "");
    setShowProjectTypeQty(true);
    setOpen(false);
    setSelectedQty(draftProject?.overallQty || "");
    setPhasesRowData(draftProject?.phasesInfo || []);
    setOrderReference(draftProject?.orderRef || "");
    setDisplayName(draftProject?.projectDisplayName || "");
    setDraftId(draftProject?.id || "");
    setContainerNo(draftProject?.containerNo || "");
    if (currentPhase && currentPhase?.typeViseQty) {
      const rows = Object.entries(currentPhase.typeViseQty).map(
        ([typeName, qty]) => ({
          typeName,
          qty,
        }),
      );
      setRowData(rows);
      setSteps(rows);
      const totalQty = Object.values(currentPhase.typeViseQty).reduce(
        (total, qty) => total + qty,
        0,
      );

      setPhasesTotalValue(totalQty || 0);

      setTypesPhaseQty(Object.keys(currentPhase.typeViseQty).length || "");
    }
  }, [draftOrder, draftList]);
  useEffect(() => {
    if (!isDraftOrder) return;

    const allProjectTypes =
      Array.isArray(selectedRows) && selectedRows?.[0]
        ? selectedRows[0]?.projectTypes
        : selectedRows?.projectTypes;

    if (!Array.isArray(allProjectTypes)) return;

    const normalized = allProjectTypes.map((type, index) => ({
      ...type,
      projectTypeNum: index + 1,
    }));

    setApiProjectTypes(normalized);
    setDraftProjectInfo(normalized);
  }, [isDraftOrder, selectedRows]);
  useEffect(() => {
    if (isDraftOrder) {
      const currentProjectType =
        previousStepRowData?.[activeStep]?.[activeStep];
      if (
        previousStepRowData?.[0]?.[0]?.drwFileName
          ?.split(".")
          .pop()
          .toLowerCase() === "prw"
      ) {
        setPrwSelected(true);
      }
      if (!currentProjectType) return;

      const transformedTypeRowData = (currentProjectType.orderList || []).map(
        (order) => ({
          typeNum:
            orderReference?.length === 6
              ? (count + 1).toString().padStart(2, "0")
              : (count + 1).toString().padStart(3, "0"),
          typeName: currentProjectType.typeName.toUpperCase(),
          uniqId: order.uniqId || "",
          commisionName: order.commissionName || "",
        }),
      );

      const extractedFormValues = [1, 2, 3]
        .map((setNumber) => {
          const rangeKey = `range${setNumber}`;
          const colorKey = `color${setNumber}`;
          const carcassKey = `carcass${setNumber}`;
          const handleKey = `handle${setNumber}`;
          const priceGroupKey = `priceGroup${setNumber}`;

          if (
            currentProjectType[rangeKey] ||
            currentProjectType[colorKey] ||
            currentProjectType[carcassKey] ||
            currentProjectType[handleKey]
          ) {
            return {
              range: {
                value: currentProjectType[`${rangeKey}Id`] || "",
                label: currentProjectType[rangeKey] || "",
              },
              color: {
                value: currentProjectType[`${colorKey}Id`] || "",
                label: currentProjectType[colorKey] || "",
              },
              carcass: {
                value: currentProjectType[`${carcassKey}Id`] || "",
                label: currentProjectType[carcassKey] || "",
              },
              handle: {
                value: currentProjectType[`${handleKey}Id`] || "",
                label: currentProjectType[handleKey] || "",
              },
              priceGroup: {
                value: currentProjectType[priceGroupKey] || "",
                label: currentProjectType[priceGroupKey] || "",
              },
            };
          }
          return null;
        })
        .filter(Boolean);

      const uploadValue =
        Array.isArray(currentProjectType?.drawingFile) &&
        currentProjectType.drawingFile.length > 0 &&
        currentProjectType.drawingFile[0]?.drawingFileId?.trim().length > 0
          ? currentProjectType.drawingFile.map((file) => ({
              id: file.drawingFileId,
              uploadFile: new File([], file.drawingFileName),
              name: file.drawingFileName,
            }))
          : [{ uploadFile: null }];

      setTypeRowData(transformedTypeRowData);
      setFormValues(
        extractedFormValues.length > 0
          ? extractedFormValues
          : [{ range: {}, priceGroup: {}, color: {}, carcass: {}, handle: {} }],
      );
      setWeight(currentProjectType.weight ?? "");
      setVolume(currentProjectType.volume ?? "");
      setWG1Price(currentProjectType.wg1 ?? "");
      setWG2Price(currentProjectType.wg2 ?? "");
      setSharedLater(currentProjectType.sharedLater);
      setNotApplicable(currentProjectType.na);
      setDiscountChecked(currentProjectType.isSpecialDiscount);
      setSDFile(currentProjectType.specialDiscountFile);
      setComment(currentProjectType.specialComments);
      setFreight({
        id: currentProjectType.freightId,
        value: currentProjectType.freight,
        label: currentProjectType.freight,
      });
      setLoadingWeek({
        value: currentProjectType.loadingWeek,
        label: currentProjectType.loadingWeek,
      });
      if (!prwSelected) {
        setDRWFile(
          currentProjectType.drwFileId && currentProjectType.drwFileName
            ? {
                id: currentProjectType.drwFileId,
                name: currentProjectType.drwFileName,
              }
            : null,
        );
      }

      setAppliancesDetail(
        currentProjectType.applianceDetailId &&
          currentProjectType.applianceDetailName
          ? {
              id: currentProjectType.applianceDetailId,
              name: currentProjectType.applianceDetailName,
            }
          : null,
      );

      setOrderCheckFile(
        currentProjectType.orderCheckListId &&
          currentProjectType.orderCheckListName
          ? {
              id: currentProjectType.orderCheckListId,
              name: currentProjectType.orderCheckListName,
            }
          : null,
      );

      setDrwFileId(currentProjectType?.drwFileId);
      setAppliancesDetailFileId(currentProjectType?.applianceDetailId);
      setOrderCheckFileId(currentProjectType?.orderCheckListId);
      setUploadValue(uploadValue);
      setDrwFileSupersedes(currentProjectType?.drawFileSupersedes);
    }
  }, [activeStep, isDraftOrder, selectedRows]);
  useEffect(() => {
    if (!isDraftOrder) {
      setTypeRowData([]);
      setFormValues([
        { range: {}, priceGroup: {}, color: {}, carcass: {}, handle: {} },
      ]);
      setWeight("");
      setVolume("");
      setWG1Price("");
      setWG2Price("");
      setFreight(null);
      setLoadingWeek(null);
      setSelectedDraftOrder(null);
      setSelectedProName(null);
      setProduct(null);
      setSelectedRows([]);
      setTypeTotalValue(0);
      setSelectedPhases("");
      setShowProjectTypeQty(false);
      setSelectedQty("");
      setPhasesRowData([]);
      setOrderReference("");
      setDisplayName("");
      setDraftId("");
      setContainerNo("");
      setRowData([]);
      setSteps("");
      setPhasesTotalValue("");
      setTypesPhaseQty("");
      setDRWFile(null);
      setDrwFileId("");
      setAppliancesDetail(null);
      setAppliancesDetailFileId("");
      setOrderCheckFile(null);
      setOrderCheckFileId("");
      setSharedLater(false);
      setNotApplicable(false);
      setDiscountChecked(false);
      setSDFile(null);
      setComment("");
      setDrwFileSupersedes(false);
      setUploadValue([{ uploadFile: null }]);
      setDraftList([]);
      setSelectedDraftOrder(null);
      setDraftOrderOptions([]);
    }
  }, [isDraftOrder]);

  const handleDealNameChange = (event) => {
    setSelectedDeal(event);
    setProductOptions(defaultProductOption);
    //const filterDeals = deals.find((item) => item.hs_object_id === event.value);
    const getDealProducts = event?.product_group_quoted__test_?.split(";");
    const dealUpperCase = getDealProducts?.map((item) => item?.toUpperCase());
    const changeWord = dealUpperCase?.map((item) =>
      item?.replace("KITCHEN", "KUECHEN"),
    );
    const filterProduct = defaultProductOption?.filter((item, index) => {
      return changeWord?.includes(item?.label);
    });
    setHubSpotReference(event.reference_number);
    setProductOptions(filterProduct);
    setProduct(null);
    setCostOfHubSpot(0);
  };

  // useEffect(() => {
  //   if (orderCategoryValue?.value === "PRJ" && product && exitingProject.length > 0) {
  //     // console.log('exitingProject', exitingProject)
  //     setOrderReference(exitingProject.project);
  //   }
  // }, [orderCategoryValue, product, exitingProject]);

  const handleMainProductChange = (event) => {
    setProduct({
      value: event.value,
      label: event.label,
      id: event.id,
    });
    resetFormValues();
    if (event.id == 60001) {
      setCostOfHubSpot(selectedDeal?.final_amount_nk || 0);
    } else if (event.id == 60002) {
      setCostOfHubSpot(selectedDeal?.final_amount_ek || 0);
    } else if (event.id == 60006) {
      setCostOfHubSpot(selectedDeal?.final_amount_eco || 0);
    } else if (event.id == 60009) {
      setCostOfHubSpot(selectedDeal?.final_amount_neo || 0);
    } else if (event.id == 60008) {
      setCostOfHubSpot(selectedDeal?.final_amount_spa || 0);
    }
  };

  useEffect(() => {
    if (hasSupperUser) {
      getCustomer();
    }
  }, [hasSupperUser]);

  useEffect(() => {
    if (selectedPartner) {
      getShowroom();
    }
  }, [selectedPartner, hasSupperUser]);

  const materialDetailsSection = (
    <Box
      className="shadow mb-20 mt-10"
      style={{
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
      }}
      sx={{
        backgroundColor: theme.palette.background.paper,
        p: 2,
        position: "relative",
        borderRadius: "1.6rem",
        borderBottomRightRadius: 0,
        mb: 2.5,
        width: "100%",
        border: `1px solid ${theme.palette.divider}`,
      }}
    >
      {formValues.map((element, index) => (
        <>
          <Grid
            container
            xs={12}
            spacing={2}
            className={index ? "mt-4 relative" : "relative"}
          >
            <Grid item xs={12} sm={6} md={3}>
              <label className="pb-8 flex">*Range</label>
              <Select
                value={formValues?.[index]?.range}
                onChange={(e) => handleRangeChange(e, index, "range")}
                name="range"
                options={range}
                styles={customStyles(
                  ((checksubmit && !selectedRange) ||
                    validError.selectedRange) &&
                    theme.palette.error.main,
                )}
                className="w-full"
              />
              <Typography
                sx={{
                  color: "error.main",
                  fontSize: "0.875rem",
                  ml: "14px",
                }}
              >
                {checksubmit && !selectedRange
                  ? "This field is required"
                  : validError.selectedRange}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <label className="pb-8 flex">*Color</label>
              <Select
                value={formValues?.[index]?.color}
                onChange={(e) => handleRangeChange(e, index, "color")}
                name="color"
                options={color[index]}
                styles={customStyles(
                  ((checksubmit && !selectedColor) ||
                    validError.selectedColor) &&
                    theme.palette.error.main,
                )}
                className="w-full"
              />
              <Typography
                sx={{
                  color: theme.palette.error.main,
                  fontSize: "0.875rem",
                  ml: "14px",
                }}
              >
                {checksubmit && !selectedColor
                  ? "This field is required"
                  : validError.selectedColor}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <label className="pb-8 flex">*Carcass</label>
              <Select
                value={formValues?.[index]?.carcass}
                onChange={(e) => handleRangeChange(e, index, "carcass")}
                name="carcass"
                options={carcass}
                styles={customStyles(
                  ((checksubmit && !selectedCarcass) ||
                    validError.selectedCarcass) &&
                    theme.palette.error.main,
                )}
                className="w-full"
              />
              <Typography
                sx={{
                  color: theme.palette.error.main,
                  fontSize: "0.875rem",
                  ml: "14px",
                }}
              >
                {checksubmit && !selectedCarcass
                  ? "This field is required"
                  : validError.selectedCarcass}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <label className="pb-8 flex">*Handle</label>
              <Select
                value={formValues?.[index]?.handle}
                onChange={(e) => handleRangeChange(e, index, "handle")}
                name="handle"
                options={handles}
                styles={customStyles(
                  ((checksubmit && !selectedHandle) ||
                    validError.selectedHandle) &&
                    theme.palette.error.main,
                )}
                className="w-full"
              />
              <Typography
                sx={{
                  color: theme.palette.error.main,
                  fontSize: "0.875rem",
                  ml: "14px",
                }}
              >
                {checksubmit && !selectedHandle
                  ? "This field is required"
                  : validError.selectedHandle}
              </Typography>
            </Grid>
            {index ? (
              <IconButton
                color="secondary"
                onClick={() => removeFormFields(index)}
                sx={{
                  position: "absolute",
                  right: { xs: 0, md: "-30px" },
                  top: { xs: 0, md: "auto" },
                  bottom: { xs: "auto", md: 4 },
                }}
              >
                <FuseSvgIcon size={14}>heroicons-outline:x</FuseSvgIcon>
              </IconButton>
            ) : null}
          </Grid>
        </>
      ))}
      {formValues.length < 3 && (
        <Button
          variant="contained"
          color="secondary"
          onClick={() => addFormFields()}
          size="small"
          sx={{
            position: "absolute",
            bottom: "-32px",
            right: 0,
            borderTopRightRadius: 0,
            borderTopLeftRadius: 0,
          }}
        >
          <FuseSvgIcon>heroicons-outline:plus</FuseSvgIcon>
        </Button>
      )}
    </Box>
  );

  return (
    <>
      <FormPageHeader
        componentName="Create Order"
        pageName="Create Order"
        currentPage={
          mode === "edit"
            ? "Edit Order"
            : mode === "new-type"
            ? "Create Type Order"
            : "Create Order"
        }
        orderHeaderAction={placeOrder()}
        successMsg={successMsg}
        snackState={snackState}
        error={error}
      >
        {(orderCategoryValue?.value === "PRJ" ||
          orderCategoryValue?.value === "CPRJ") &&
          showProjectTypeQty && (
            <ProjectStepper
              steps={steps}
              activeStep={activeStep}
              completed={completed}
              handleStep={handleStep}
            />
          )}
      </FormPageHeader>
      <div className="px-10">
        <Grid container spacing={2}>
          {(hasSupperUser ||
            token.scope.includes("ROLE_PARTNRORDPROCESS") ||
            token.scope.includes("ROLE_PARTNER_ADMIN") ||
            token.scope.includes("ROLE_SHWRMMGR")) && (
            <Grid item xs={12}>
              <Box
                className=" mt-10"
                sx={{
                  p: 2,
                  border: `1px dashed ${theme.palette.divider}`,
                  borderRadius: 4,
                }}
              >
                <span style={{ fontSize: "1.4rem" }}>
                  If you are placing a bulk project order{" "}
                </span>

                <Button
                  component={Link}
                  to="/order/special-project-order"
                  variant="contained"
                  color="secondary"
                  size="small"
                  sx={{
                    ml: 1,
                    textTransform: "none",
                    fontSize: "1.4rem",
                    padding: "4px 12px",
                  }}
                >
                  Click here →
                </Button>
              </Box>
            </Grid>
          )}
          <Grid item xs={12} md={6}>
            <Box
              className="mb-10"
              sx={{
                p: 2,
                border: `1px dashed ${theme.palette.divider}`,
                borderRadius: 4,
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <label className="pb-8 block">*Partner</label>
                  {hasSupperUser ? (
                    <Select
                      placeholder={"Select Partner"}
                      name="partner"
                      value={selectedPartner}
                      options={customerOptions}
                      //  disabled={orderCategoryValue?.value === "PRJ" && steps.length>0 && selectedPartner.value?true:false}
                      onChange={(event) => {
                        setSelectedPartner({
                          value: event.value,
                          label: event.label,
                        });
                        setShowroom(null);
                        setOrderCategoryValue(null);
                        setSelectedProName(null);
                        setProduct(null);
                        setSelectedPhases("");
                        setSelectedQty("");
                        setPhasesRowData([]);
                        setRowData([]);
                        setDisplayName("");
                        setVolume("");
                        setWeight("");
                        setWG1Price("");
                        setWG2Price("");
                        setLoadingWeek(null);
                        setFreight(null);
                        setFormValues([
                          {
                            range: {},
                            priceGroup: {},
                            color: {},
                            carcass: {},
                            handle: {},
                          },
                        ]);
                        setDraftOrder("");
                        setIsDraftOrder(false);
                        setDraftList([]);
                        setSelectedDraftOrder(null);
                        setDRWFile(null);
                        setDrwFileId("");
                        setPRWFile(null);
                        setPrwFileId("");
                        setAppliancesDetail(null);
                        setAppliancesDetailFileId("");
                        setOrderCheckFile(null);
                        setOrderCheckFileId("");
                        setSharedLater(false);
                        setNotApplicable(false);
                        setDiscountChecked(false);
                        setSDFile(null);
                        setComment("");
                        setDrwFileSupersedes(false);
                        setUploadValue([{ uploadFile: null }]);
                        setEditPhases(false);
                        setShowPhasesAlert(false);
                        setPrwSelected(false);
                      }}
                      styles={customStyles()}
                      className="select"
                    />
                  ) : (
                    <TextField
                      name="customer"
                      fullWidth
                      variant="outlined"
                      type="text"
                      value={customerName}
                      disabled
                    />
                  )}
                </Grid>
                <Grid item xs={12} md={6}>
                  <label className="pb-8 block">*Showroom</label>
                  <Select
                    // value={showroom}
                    value={showroom}
                    onChange={(event) =>
                      setShowroom({ value: event.value, label: event.label })
                    }
                    name="showroom"
                    options={showroomOptions}
                    styles={customStyles(
                      ((checksubmit && !showroom) || validError.showroom) &&
                        theme.palette.error.main,
                    )}
                    className="select"
                    //  disabled={orderCategoryValue?.value === "PRJ" && steps.length>0 && showroom.label?true:false }
                    isDisabled={mode === "new-type"}
                  />
                  <Typography
                    sx={{
                      color: "error.main",
                      fontSize: "0.875rem",
                      ml: "14px",
                    }}
                  >
                    {checksubmit && !showroom
                      ? "This field is required"
                      : validError.showroom}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
            {orderCategoryValue?.value !== "PRJ" &&
              orderCategoryValue?.value !== "CPRJ" && (
                <Box
                  className="mb-10 mt-10"
                  sx={{
                    p: 2,
                    border: `1px dashed ${theme.palette.divider}`,
                    borderRadius: 4,
                  }}
                >
                  <Grid container xs={12} spacing={2} className="mb-16">
                    <Grid item xs={12} sm={6} md={3}>
                      <label className="pb-8 block">Type Number</label>
                      <TextField
                        value={typeNumber}
                        name="typeNumber"
                        fullWidth
                        variant="outlined"
                        type="text"
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} md={5}>
                      <label className="pb-8 block">*Unique ID</label>
                      <div className="flex gap-2">
                        <TextField
                          name="uniqueID"
                          value={uniqueID}
                          onChange={handleUniqueIDChange}
                          fullWidth
                          variant="outlined"
                          type="text"
                          inputProps={{
                            maxLength: maxUniqueIdLength,
                            style: { textTransform: "uppercase" },
                          }}
                          error={
                            lastEdited === "uniqueID" &&
                            fullUniqueID.length + clientName.length > 21
                          }
                          helperText={
                            lastEdited === "uniqueID" &&
                            fullUniqueID.length + clientName.length > 21 &&
                            `Total characters (Client Name + Unique ID) must be 21 or less`
                          }
                        />
                        {currentCustomer === 30004 && (
                          <div style={{ minWidth: "110px" }}>
                            <Select
                              value={uniqueIdSuffix}
                              onChange={(selected) => {
                                const suffixLen = selected
                                  ? selected.value.length + 1
                                  : 0;

                                if (
                                  uniqueID.length +
                                    suffixLen +
                                    clientName.length >
                                  21
                                ) {
                                  toast.warn(
                                    "Total characters (Client Name + Unique ID) must be 21 or less",
                                  );
                                  return;
                                }

                                setUniqueIdSuffix(selected);
                              }}
                              options={kOptions}
                              isClearable
                              placeholder="Suffix"
                              styles={customStyles()}
                            />
                          </div>
                        )}
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label className="pb-8 block">*Client Name</label>
                      <TextField
                        value={clientName}
                        onChange={handleClientNameChange}
                        name="clientName"
                        fullWidth
                        variant="outlined"
                        type="text"
                        disabled={mode === "edit" || mode === "new-type"}
                        inputProps={{
                          maxLength: maxClientNameLength,
                          style: { textTransform: "uppercase" },
                        }}
                        error={
                          lastEdited === "clientName" &&
                          fullUniqueID.length + clientName.length > 21
                        }
                        helperText={
                          lastEdited === "clientName" &&
                          fullUniqueID.length + clientName.length > 21 &&
                          `Total characters (Client Name + Unique ID) must be 21 or less`
                        }
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Alert
                        severity="info"
                        sx={{
                          fontSize: "12px",
                          padding: 0,
                          background: "none",
                          "& .MuiAlert-icon": {
                            padding: 0,
                          },
                          "& .MuiAlert-message": {
                            padding: "2px 0px",
                          },
                        }}
                      >
                        Note: The Commission Name will be combination of Unique
                        ID & Client Name
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <label className="pb-8 block">Commission Name</label>
                      <TextField
                        value={commissionName}
                        name="commissionName"
                        fullWidth
                        variant="outlined"
                        type="text"
                        disabled
                        inputProps={{ style: { textTransform: "uppercase" } }}
                      />
                    </Grid>
                  </Grid>
                </Box>
              )}
            <Box
              className="mb-10 mt-10"
              sx={{
                p: 2,
                border: `1px dashed ${theme.palette.divider}`,
                borderRadius: 4,
              }}
            >
              <Grid container xs={12} spacing={2}>
                <Grid item xs={12} md={6}>
                  <label className="pb-8 block">*Volume(cbm)</label>
                  <TextField
                    value={volume}
                    onChange={(e) => {
                      const inputValue = e.target.value.replace(/[^\d.]/g, ""); //e.target.value.replace(/[^0-9.]/g, '')
                      setVolume(inputValue);
                    }}
                    onKeyDown={blockInvalidKeys}
                    name="volume"
                    fullWidth
                    variant="outlined"
                    type="text"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <label className="pb-8 block">Weight (kg)</label>
                  <TextField
                    value={
                      weight !== undefined && weight !== ""
                        ? weight
                        : hasBack &&
                          previousStepRowData[activeStep]?.[activeStep]?.weight
                        ? previousStepRowData[activeStep][activeStep].weight
                        : ""
                    }
                    onChange={(e) => {
                      const inputValue = e.target.value.replace(/[^\d.]/g, "");
                      setWeight(inputValue);
                    }}
                    name="weight"
                    fullWidth
                    variant="outlined"
                    type="text"
                  />
                </Grid>
              </Grid>
            </Box>
            {!isMobile && materialDetailsSection}
          </Grid>
          <Grid item xs={12} md={6}>
            <Box
              className="mb-10"
              sx={{
                p: 2,
                border: `1px dashed ${theme.palette.divider}`,
                borderRadius: 4,
              }}
            >
              <Grid container spacing={2}>
                <Grid
                  item
                  xs={12}
                  sm={
                    orderCategoryValue?.value === "RET" &&
                    (newOrderData.hubspotEnabled ||
                      typeOrderData.hubspotEnabled)
                      ? 3
                      : 4
                  }
                >
                  <label className="pb-8 block">*Order Category</label>
                  <Select
                    value={orderCategoryValue}
                    options={orderCategoryOptions}
                    styles={customStyles(
                      ((checksubmit && !orderCategoryValue) ||
                        validError.orderCategoryValue) &&
                        theme.palette.error.main,
                    )}
                    className="w-full"
                    onChange={handleChangeOrderCategory}
                    isDisabled={
                      mode === "edit" ||
                      mode === "new-type" ||
                      orderCategoryValue?.value === "PRJ" ||
                      orderCategoryValue?.value === "CPRJ"
                    }
                  />
                  <Typography
                    sx={{
                      color: "error.main",
                      fontSize: "0.875rem",
                      ml: "14px",
                    }}
                  >
                    {checksubmit && !orderCategoryValue
                      ? "This field is required"
                      : validError.orderCategoryValue}
                  </Typography>
                </Grid>
                {orderCategoryValue?.value === "RET" &&
                  (newOrderData.hubspotEnabled ||
                    typeOrderData.hubspotEnabled) && (
                    <Grid item xs={12} sm={6} md={3}>
                      <label className="pb-8 block">*Hubspot Deal</label>
                      <AsyncPaginate
                        value={selectedDeal}
                        loadOptions={(inputValue, _, { page }) =>
                          getHubSpotDeal(inputValue, page)
                        }
                        getOptionValue={(option) => option.hs_object_id}
                        getOptionLabel={(option) => option.dealname}
                        onChange={handleDealNameChange}
                        styles={customStyles()}
                        className="w-full"
                        isSearchable
                        isDisabled={mode === "edit"}
                        additional={{
                          page: currentPage,
                        }}
                      />
                      {/**
                      <Select
                        value={selectedDeal}
                        options={dealOptions}
                        styles={customStyles()}
                        className="w-full"
                        onChange={handleDealNameChange}
                        isDisabled={mode === "edit" || mode === "new-type"}
                      />*/}
                    </Grid>
                  )}
                {orderCategoryValue?.value !== "PRJ" &&
                  orderCategoryValue?.value !== "CPRJ" && (
                    <Grid
                      item
                      xs={12}
                      sm={
                        orderCategoryValue?.value === "RET" &&
                        (newOrderData.hubspotEnabled ||
                          typeOrderData.hubspotEnabled)
                          ? 3
                          : 4
                      }
                    >
                      <label className="pb-8 block">*Product</label>
                      <Select
                        value={product}
                        onChange={handleMainProductChange}
                        name="product"
                        options={productOptions}
                        styles={customStyles(
                          ((checksubmit && !product) || validError.product) &&
                            theme.palette.error.main,
                        )}
                        className="w-full"
                        // isDisabled={!selectedDeal}
                      />
                      <Typography
                        sx={{
                          color: "error.main",
                          fontSize: "0.875rem",
                          ml: "14px",
                        }}
                      >
                        {checksubmit && !product
                          ? "This field is required"
                          : validError.product}
                      </Typography>
                    </Grid>
                  )}
                <Grid
                  item
                  xs={12}
                  sm={
                    orderCategoryValue?.value === "RET" &&
                    (newOrderData.hubspotEnabled ||
                      typeOrderData.hubspotEnabled)
                      ? 3
                      : 4
                  }
                >
                  <label className="pb-8 block">Order Reference</label>
                  <TextField
                    value={orderReference}
                    name="orderReference"
                    fullWidth
                    variant="outlined"
                    type="text"
                    disabled
                  />
                </Grid>

                {orderCategoryValue?.value === "RET" &&
                  (newOrderData.hubspotEnabled ||
                    typeOrderData.hubspotEnabled) &&
                  selectedDeal && (
                    <>
                      <Grid item xs={12}>
                        <Box
                          sx={{
                            textAlign: "center",
                            borderRadius: "4px",
                            background: theme.palette.action.hover,
                            padding: "5px",
                            border: `1px solid ${theme.palette.divider}`,
                          }}
                        >
                          HubSpot Reference: {hubSpotReference}
                        </Box>
                      </Grid>
                    </>
                  )}
              </Grid>
            </Box>
            {(orderCategoryValue?.value === "PRJ" ||
              orderCategoryValue?.value === "CPRJ") &&
              showProjectTypeQty && (
                <Box
                  className="mb-10 mt-10"
                  sx={{
                    p: 2,
                    border: `1px dashed ${theme.palette.divider}`,
                    borderRadius: 4,
                  }}
                >
                  <div
                    className={
                      theme.palette.mode === "dark"
                        ? "ag-theme-alpine-dark"
                        : "ag-theme-alpine"
                    }
                    // style={{ maxHeight: 300 }}
                  >
                    <AgGridReact
                      ref={typeGridRef}
                      rowData={typeRowData}
                      columnDefs={typeColumnDefs}
                      defaultColDef={defaultColDef}
                      autoGroupColumnDef={autoGroupColumnDef}
                      animateRows={true}
                      headerHeight={28}
                      rowHeight={22}
                      domLayout={"autoHeight"}
                      onCellValueChanged={typeCellValueChanged}
                      onCellEditingStarted={typeCellValueChanged}
                      onCellEditingStopped={typeCellEditingStopped}
                      stopEditingWhenGridLosesFocus={true}
                      cellSelection={true}
                    />
                  </div>
                </Box>
              )}
            <Box
              className="mb-10 mt-10"
              sx={{
                p: 2,
                border: `1px dashed ${theme.palette.divider}`,
                borderRadius: 4,
              }}
            >
              <Grid container xs={12} spacing={2}>
                <Grid item xs={12} sm={4}>
                  <label className="pb-8 block">*WG1 List Price (Euros)</label>
                  <TextField
                    value={WG1Price}
                    onChange={(e) => {
                      const inputValue = e.target.value.replace(/[^\d.]/g, "");
                      setWG1Price(inputValue);
                    }}
                    name="WG1Price"
                    fullWidth
                    variant="outlined"
                    type="text"
                    // inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                    // error={
                    //   (checksubmit && !WG1Price) || validError.WG1Price
                    //     ? true
                    //     : false
                    // }
                    // helperText={
                    //   checksubmit && !WG1Price
                    //     ? "This field is required"
                    //     : validError.WG1Price
                    // }
                    // InputLabelProps={{
                    //   shrink: WG1Price ? true : false,
                    // }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <label className="pb-8 block">*WG2 List Price (Euros)</label>
                  <TextField
                    // value={WG2Price}
                    // onChange={(e) => {
                    //   setWG2Price(e.target.value);
                    //   setValidError({
                    //     ...validError,
                    //     WG2Price: checkNumber(e.target.value),
                    //   });
                    // }}
                    value={WG2Price}
                    onChange={(e) => {
                      const inputValue = e.target.value.replace(/[^\d.]/g, "");
                      setWG2Price(inputValue);
                    }}
                    name="WG2Price"
                    fullWidth
                    variant="outlined"
                    type="text"
                    // error={
                    //   (checksubmit && !WG2Price) || validError.WG2Price
                    //     ? true
                    //     : false
                    // }
                    // helperText={
                    //   checksubmit && !WG2Price
                    //     ? "This field is required"
                    //     : validError.WG2Price
                    // }
                    // InputLabelProps={{
                    //   shrink: WG2Price ? true : false,
                    // }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <label className="pb-8 block">
                    Total List Price (Euros){" "}
                  </label>
                  <Box
                    sx={{
                      padding: "4px 10px",
                      borderRadius: "4px",
                      background: theme.palette.action.hover,
                      border: `1px solid ${theme.palette.divider}`,
                    }}
                  >
                    {totalListPrice}
                  </Box>
                </Grid>
                {orderCategoryValue?.value !== "PRJ" &&
                  orderCategoryValue?.value !== "CPRJ" && (
                    <Grid item xs={8}>
                      <label className="pb-8 block">
                        Any special discount agreed?
                      </label>
                      <Stack direction="row" spacing={1} alignItems="center">
                        <Typography>No</Typography>
                        <AntSwitch
                          checked={discountChecked}
                          onChange={handleSpecialDicount}
                        />
                        <Typography>Yes</Typography>
                        {discountChecked && (
                          <ColorButton
                            variant="contained"
                            component="label"
                            disabled={SDFile}
                          >
                            <FuseSvgIcon
                              size={16}
                              sx={{ display: "inline-block" }}
                            >
                              heroicons-outline:upload
                            </FuseSvgIcon>{" "}
                            Upload
                            <input
                              type="file"
                              className="file"
                              onChange={handleSDUpload}
                              key={key}
                              ref={hiddenDicountFile}
                              disabled={SDFile}
                            />
                          </ColorButton>
                        )}
                        {SDFile && (
                          <Box className="mt-16">
                            <Chip
                              label={SDFile.name || SDFile.attachmentName}
                              onDelete={removeSDFile}
                            />
                          </Box>
                        )}
                      </Stack>
                    </Grid>
                  )}
                {orderCategoryValue?.value === "RET" &&
                  (newOrderData.hubspotEnabled ||
                    typeOrderData.hubspotEnabled) && (
                    <Grid item xs={12} sm={4}>
                      <label className="pb-8 block">Cost in HubSpot</label>
                      <Box
                        sx={{
                          padding: "4px 10px",
                          borderRadius: "4px",
                          background: theme.palette.action.hover,
                          border: `1px solid ${theme.palette.divider}`,
                        }}
                      >
                        {costOfHubSpot
                          .toFixed(2)
                          .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                      </Box>
                    </Grid>
                  )}
              </Grid>
            </Box>
            <Box
              className="mb-10 mt-10"
              sx={{
                p: 2,
                border: `1px dashed ${theme.palette.divider}`,
                borderRadius: 4,
              }}
            >
              <Grid container xs={12} spacing={2}>
                <Grid item xs={12} sm={4}>
                  <label className="pb-8 block">Container No</label>
                  <TextField
                    value={containerNo}
                    inputProps={{ style: { textTransform: "uppercase" } }}
                    onChange={(e) => setContainerNo(e.target.value)}
                    name="containerNo"
                    fullWidth
                    variant="outlined"
                    type="text"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <label className="pb-8 block">*Loading Week</label>
                  <Select
                    value={loadingWeek}
                    onChange={(event) =>
                      setLoadingWeek({ value: event.value, label: event.label })
                    }
                    name="loadingWeek"
                    options={filterLoadingWeekOptions}
                    styles={customStyles(
                      ((checksubmit && !loadingWeek) ||
                        validError.loadingWeek) &&
                        theme.palette.error.main,
                    )}
                    className="w-full"
                    isDisabled={sharedLater}
                  />
                  <Typography
                    sx={{
                      color: "error.main",
                      fontSize: "0.875rem",
                      ml: "14px",
                    }}
                  >
                    {checksubmit && !loadingWeek
                      ? "This field is required"
                      : validError.loadingWeek}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <label className="pb-8 block">*Freight</label>
                  <Select
                    value={freight}
                    onChange={(event) =>
                      setFreight({
                        id: event.id,
                        value: event.value,
                        label: event.label,
                      })
                    }
                    name="freight"
                    options={freightOptions}
                    styles={customStyles(
                      ((checksubmit && !freight) || validError.freight) &&
                        theme.palette.error.main,
                    )}
                    className="w-full"
                  />
                  <Typography
                    sx={{
                      color: "error.main",
                      fontSize: "0.875rem",
                      ml: "14px",
                    }}
                  >
                    {checksubmit && !freight
                      ? "This field is required"
                      : validError.freight}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <label className="pb-8 block">Special Comments</label>
                  <TextField
                    multiline
                    value={comment}
                    inputProps={{ style: { textTransform: "uppercase" } }}
                    onChange={(e) => setComment(e.target.value)}
                    name="comment"
                    fullWidth
                    rows={2}
                  />
                </Grid>
              </Grid>
            </Box>
            {isMobile && materialDetailsSection}
          </Grid>
        </Grid>
      </div>
      <Container
        component="main"
        maxWidth="md"
        sx={{ py: 3, px: { xs: 2, md: 3 } }}
      >
        <Grid container xs={12} className="mb-16">
          <Grid container xs={12} spacing={1} sx={{ position: "relative" }}>
            <Grid item xs={12} sm={6} md={3}>
              <Card>
                <CardContent>
                  <label className="pb-8 flex">*DRW File</label>
                  {mode === "edit" && (
                    <ColorButton
                      sx={{ mb: 1 }}
                      variant="contained"
                      fullWidth
                      onClick={() =>
                        handleDownloadFile(DRWFile.id, DRWFile.attachmentName)
                      }
                    >
                      <FuseSvgIcon size={18} sx={{ display: "inline-block" }}>
                        heroicons-solid:download
                      </FuseSvgIcon>{" "}
                      Download
                    </ColorButton>
                  )}
                  <ColorButton
                    variant="contained"
                    component="label"
                    disabled={DRWFile || prwSelected}
                  >
                    <FuseSvgIcon size={18} sx={{ display: "inline-block" }}>
                      heroicons-outline:upload
                    </FuseSvgIcon>{" "}
                    Upload
                    <input
                      type="file"
                      className="file"
                      onChange={handleDRWUpload}
                      key={key}
                      ref={hiddenDRWFile}
                      disabled={DRWFile || prwSelected}
                      accept=".drw, .prw"
                    />
                  </ColorButton>
                  {(DRWFile || prwSelected) && (
                    <Box className="mt-16">
                      <Chip
                        label={
                          DRWFile?.name ||
                          DRWFile?.attachmentName ||
                          previousStepRowData[activeStep]?.[activeStep]
                            ?.drwFileName ||
                          ""
                        }
                        onDelete={removeDRWFile}
                      />
                    </Box>
                  )}
                </CardContent>
              </Card>
              <Typography
                sx={{
                  color: "error.main",
                  fontSize: "0.875rem",
                  ml: "14px",
                }}
              >
                {checksubmit && !DRWFile
                  ? "This field is required"
                  : validError.DRWFile}
              </Typography>
              {(orderCategoryValue?.value === "PRJ" ||
                orderCategoryValue?.value === "CPRJ") &&
                isPRWFile &&
                rowData.length - 1 !== 0 && (
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={prwSelected}
                          onChange={(event) => {
                            const checked = event.target.checked;
                            setPrwSelected(checked);
                            if (checked) {
                              applyPrwToAllTypes(DRWFile, drwFileId);
                              toast.success("PRW file applied to all types");
                            }
                          }}
                        />
                      }
                      label="Apply PRW for all types"
                      sx={{ "& span": { fontSize: "11px" } }}
                    />
                  </FormGroup>
                )}
              {previousTypesMissingDrw.length > 0 && (
                <Alert severity="warning" sx={{ mt: 1 }}>
                  Please upload the corresponding .prw file for Type
                  {previousTypesMissingDrw.length > 1 ? "s" : ""}{" "}
                  {previousTypesMissingDrw.join(", ")} before continuing.
                </Alert>
              )}
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Card>
                <CardContent>
                  <label className="pb-8 flex">*Appliances Detail</label>
                  {mode === "edit" && (
                    <ColorButton
                      sx={{ mb: 1 }}
                      variant="contained"
                      fullWidth
                      onClick={() =>
                        handleDownloadFile(
                          appliancesDetail.id,
                          appliancesDetail.attachmentName,
                        )
                      }
                    >
                      <FuseSvgIcon size={18} sx={{ display: "inline-block" }}>
                        heroicons-solid:download
                      </FuseSvgIcon>{" "}
                      Download
                    </ColorButton>
                  )}
                  <ColorButton
                    variant="contained"
                    component="label"
                    disabled={appliancesDetail || sharedLater || notApplicable}
                  >
                    <FuseSvgIcon size={18} sx={{ display: "inline-block" }}>
                      heroicons-outline:upload
                    </FuseSvgIcon>{" "}
                    Upload
                    <input
                      type="file"
                      className="file"
                      key={key}
                      onChange={handleADUpload}
                      ref={hiddenADFile}
                      disabled={
                        appliancesDetail || sharedLater || notApplicable
                      }
                    />
                  </ColorButton>
                  {(appliancesDetail ||
                    (isDraftOrder &&
                      appliancesDetail?.id &&
                      appliancesDetail?.name)) && (
                    <Box className="mt-16">
                      <Chip
                        label={
                          hasBack && !isDraftOrder
                            ? previousStepRowData[activeStep]?.appliancesDetail
                                ?.name
                            : appliancesDetail.name
                        }
                        onDelete={removeADFile}
                      />
                    </Box>
                  )}
                </CardContent>
              </Card>
              <Typography
                sx={{
                  color: "error.main",
                  fontSize: "0.875rem",
                  ml: "14px",
                }}
              >
                {checksubmit &&
                !(appliancesDetail || sharedLater || notApplicable)
                  ? "This field is required"
                  : validError.appliancesDetail}
              </Typography>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={sharedLater}
                      onChange={(event) => {
                        setSharedLater(event.target.checked);
                        setNotApplicable(false);
                      }}
                    />
                  }
                  label="Will be shared later"
                  sx={{ "& span": { fontSize: "11px" } }}
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={notApplicable}
                      onChange={(event) => {
                        setNotApplicable(event.target.checked);
                        setSharedLater(false);
                      }}
                    />
                  }
                  label="NA"
                  sx={{ "& span": { fontSize: "11px" } }}
                />
              </FormGroup>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Card>
                <CardContent>
                  <label className="pb-8 flex">*Order Checklist</label>
                  {mode === "edit" && (
                    <ColorButton
                      sx={{ mb: 1 }}
                      variant="contained"
                      fullWidth
                      onClick={() =>
                        handleDownloadFile(
                          orderCheckFile.id,
                          orderCheckFile.attachmentName,
                        )
                      }
                    >
                      <FuseSvgIcon size={18} sx={{ display: "inline-block" }}>
                        heroicons-solid:download
                      </FuseSvgIcon>{" "}
                      Download
                    </ColorButton>
                  )}
                  <ColorButton
                    variant="contained"
                    component="label"
                    disabled={orderCheckFile || drwFileSupersedes}
                  >
                    <FuseSvgIcon size={18} sx={{ display: "inline-block" }}>
                      heroicons-outline:upload
                    </FuseSvgIcon>{" "}
                    Upload
                    <input
                      type="file"
                      className="file"
                      key={key}
                      onChange={handleOrderCheckUpload}
                      ref={hiddenOrderCheckFile}
                      disabled={orderCheckFile || drwFileSupersedes}
                    />
                  </ColorButton>
                  {orderCheckFile && (
                    <Box className="mt-16">
                      <Chip
                        label={
                          hasBack && !isDraftOrder
                            ? previousStepRowData[activeStep]?.orderCheckFile
                                ?.name
                            : orderCheckFile.name
                        }
                        onDelete={removeOrderCheckFile}
                      />
                    </Box>
                  )}
                </CardContent>
              </Card>
              <Typography
                sx={{
                  color: "error.main",
                  fontSize: "0.875rem",
                  ml: "14px",
                }}
              >
                {checksubmit && !(orderCheckFile || drwFileSupersedes)
                  ? "This field is required"
                  : validError.orderCheckFile}
              </Typography>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={drwFileSupersedes}
                      onChange={(event) =>
                        setDrwFileSupersedes(event.target.checked)
                      }
                    />
                  }
                  label="DRW file supersedes"
                  sx={{ "& span": { fontSize: "11px" } }}
                />
              </FormGroup>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              {(uploadValue?.length
                ? uploadValue
                : [{ id: "", uploadFile: null }]
              ).map((element, index) => (
                <Card sx={{ position: "relative", mb: 1 }}>
                  <CardContent>
                    <label className="pb-8 flex">Drawing File</label>
                    {mode === "edit" && (
                      <ColorButton
                        sx={{ mb: 1 }}
                        variant="contained"
                        fullWidth
                        onClick={() =>
                          handleDownloadFile(
                            drawingFile.id,
                            drawingFile.attachmentName,
                          )
                        }
                      >
                        <FuseSvgIcon size={18} sx={{ display: "inline-block" }}>
                          heroicons-solid:download
                        </FuseSvgIcon>{" "}
                        Download
                      </ColorButton>
                    )}
                    <ColorButton
                      variant="contained"
                      component="label"
                      disabled={
                        uploadValue[index]?.id?.trim().length > 0 ? true : false
                      }
                    >
                      <FuseSvgIcon size={18} sx={{ display: "inline-block" }}>
                        heroicons-outline:upload
                      </FuseSvgIcon>{" "}
                      Upload
                      <input
                        type="file"
                        className="file"
                        key={key}
                        onChange={(event) => handleDrawingUpload(event, index)}
                        ref={hiddenDrawingFile}
                        disabled={
                          uploadValue[index]?.id?.trim().length > 0
                            ? true
                            : false
                        }
                      />
                    </ColorButton>
                    {uploadValue[index]?.uploadFile?.name?.length > 0 && (
                      <Box className="mt-16">
                        <Chip
                          label={
                            uploadValue[index]?.uploadFile?.name ||
                            drawingFile.attachmentName
                          }
                          onDelete={() => removeDrawingFile(index)}
                        />
                      </Box>
                    )}
                  </CardContent>
                  {index ? (
                    <IconButton
                      onClick={() => removeUploadFields(index)}
                      size="small"
                      sx={{
                        position: "absolute",
                        top: 0,
                        right: 0,
                      }}
                    >
                      <FuseSvgIcon size={18}>heroicons-outline:x</FuseSvgIcon>
                    </IconButton>
                  ) : null}
                </Card>
              ))}
            </Grid>
            <IconButton
              variant="contained"
              color="secondary"
              onClick={() => addUploadFields()}
              size="small"
              sx={{
                marginRight: { xs: 0, md: "-34px" },
                height: "34px",
                top: { xs: 0, md: "45px" },
                ml: { xs: "auto", md: 0 },
                mt: { xs: 1, md: 0 },
              }}
            >
              <FuseSvgIcon>heroicons-outline:plus</FuseSvgIcon>
            </IconButton>
          </Grid>
        </Grid>
      </Container>
      <Box
        sx={{
          display: "flex",
          p: 2,
          justifyContent: "flex-end",
          borderTop: `1px solid ${theme.palette.divider}`,
        }}
      >
        {orderCategoryValue?.value === "PRJ" ||
        orderCategoryValue?.value === "CPRJ" ? (
          <>
            <Button
              color="secondary"
              onClick={activeStep === 0 ? handleBackProjectForm : handleBack}
              sx={{ mr: 1 }}
            >
              Back
            </Button>

            <Button
              variant="contained"
              color="secondary"
              onClick={(e) => handleNext(e)}
              disabled={
                btnDisable ||
                prwNotYetApplied ||
                previousTypesMissingDrw.length > 0
              }
            >
              {activeStep === rowData.length - 1 ? "Submit" : "Next"}
            </Button>
          </>
        ) : (
          <Button
            variant="contained"
            color="secondary"
            onClick={handleSubmit}
            type="submit"
            sx={{ ml: 1 }}
            disabled={
              btnDisable ||
              loading ||
              placeOrderBtnDisable ||
              clientName.length < 1 ||
              uniqueID.length < 1 ||
              clientName.length + uniqueID.length > 21
            }
          >
            {mode === "edit" ? "Save" : "Place Order"}
          </Button>
        )}
      </Box>

      <Dialog
        open={open || hasBackForm}
        onClose={handleClose}
        fullWidth
        maxWidth="lg"
          fullScreen={isMobile}
      >
        <AppBar position="static" elevation={0}>
          <Toolbar className="flex w-full justify-between">
            <Typography variant="h6" color="inherit" sx={{ fontWeight: 600 }}>
              Select the Project Order
            </Typography>
            <IconButton onClick={handleClose} color="inherit" size="small">
              <Icon>close</Icon>
            </IconButton>
          </Toolbar>
        </AppBar>
        <DialogContent
          sx={{
            minHeight: 500,
            color: theme.palette.text.primary,
            backgroundColor: theme.palette.background.default,
            p: 3,
          }}
        >
          <ModalToast message={toastMessage} show={showToast} />
          <Paper
            variant="outlined"
            sx={{
              p: 2.5,
              mb: 3,
              borderRadius: 2,
            }}
          >
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 600, mb: 2 }}
              color="text.primary"
            >
              Project Details
            </Typography>
            <Grid container spacing={2} alignItems="flex-start">
              <Grid item xs={12} sm={6} md={4}>
                <Typography
                  component="label"
                  variant="subtitle2"
                  color="text.secondary"
                  sx={{ display: "block", mb: 0.75 }}
                >
                  Project Name *
                </Typography>

                <AsyncPaginate
                  value={selectedProName}
                  loadOptions={loadProjectOptions}
                  onChange={handleChangeProject}
                  additional={{
                    page: 0,
                  }}
                  debounceTimeout={500}
                  isClearable
                  isSearchable
                  placeholder="Type to search or create..."
                  styles={customStyles()}
                  className="capitalize"
                  noOptionsMessage={({ inputValue }) =>
                    inputValue
                      ? `No options found for "${inputValue}"`
                      : "Start typing to search or create a project"
                  }
                />
              </Grid>
              <Grid item xs={6} sm={3} md={2}>
                <Typography
                  component="label"
                  variant="subtitle2"
                  color="text.secondary"
                  sx={{ display: "block", mb: 0.75 }}
                >
                  Product *
                </Typography>
                <Select
                  value={product}
                  onChange={handleProductChange}
                  name="product"
                  options={foreCastProduct}
                  // disabled={orderCategoryValue?.value === "PRJ" && steps.length>0  && product.label?true:false }
                  styles={customStyles(
                    ((checksubmit && !product) || validError.product) &&
                      theme.palette.error.main,
                  )}
                  className="w-full"
                  isDisabled={existingProjectOptions?.some(
                    (name) =>
                      normalize(name) === normalize(selectedProName?.label),
                  )}
                />
              </Grid>
              <Grid item xs={6} sm={3} md={2}>
                <Typography
                  component="label"
                  variant="subtitle2"
                  color="text.secondary"
                  sx={{ display: "block", mb: 0.75 }}
                >
                  PRJ Reference
                </Typography>

                <TextField
                  value={orderReference}
                  size="small"
                  fullWidth
                  variant="outlined"
                  disabled
                />
              </Grid>

              <Grid item xs={6} sm={3} md={2}>
                <Typography
                  component="label"
                  variant="subtitle2"
                  color="text.secondary"
                  sx={{ display: "block", mb: 0.75 }}
                >
                  Overall Qty *
                </Typography>
                <TextField
                  value={selectedQty}
                  onChange={handleChangeQty}
                  onBlur={handleBlur}
                  fullWidth
                  variant="outlined"
                  size="small"
                  onKeyDown={blockInvalidKeys}
                  disabled={
                    existingProjectOptions?.some(
                      (name) =>
                        normalize(name) === normalize(selectedProName?.label),
                    ) && !editPhases
                  }
                  type="number"
                  inputProps={{ min: originalQty || 10 }}
                  helperText={
                    !hasSupperUser && originalQty
                      ? `Max allowed: ${Math.floor(originalQty * 1.05)}`
                      : ""
                  }
                />
              </Grid>
              <Grid item xs={6} sm={3} md={2}>
                <Typography
                  component="label"
                  variant="subtitle2"
                  color="text.secondary"
                  sx={{ display: "block", mb: 0.75 }}
                >
                  No. of Phases *
                </Typography>
                <TextField
                  value={selectedPhases}
                  onChange={handleChangePhases}
                  onKeyDown={blockInvalidKeys}
                  fullWidth
                  size="small"
                  variant="outlined"
                  disabled={
                    existingProjectOptions?.some(
                      (name) =>
                        normalize(name) === normalize(selectedProName?.label),
                    ) && !editPhases
                  }
                  type="number"
                />
              </Grid>
              {(existingProjectOptions?.some(
                (name) => normalize(name) === normalize(selectedProName?.label),
              ) &&
                selectedProName && (
                  <Grid
                    item
                    xs={12}
                    sm="auto"
                    sx={{ display: "flex", alignItems: "flex-end" }}
                  >
                    {!editPhases ? (
                      <Button
                        variant="contained"
                        color="secondary"
                        size="medium"
                        onClick={handleUpdateProject}
                        fullWidth
                      >
                        Update
                      </Button>
                    ) : (
                      <Button
                        variant="outlined"
                        color="secondary"
                        size="medium"
                        disabled={!hasChanges}
                        onClick={handleRevertChanges}
                        fullWidth
                      >
                        Revert
                      </Button>
                    )}
                  </Grid>
                )) ||
                null}
            </Grid>
          </Paper>
          {!selectedProName && (
            <Paper
              variant="outlined"
              sx={{
                p: 3,
                mb: 3,
                borderRadius: 2,
                textAlign: "center",
                backgroundColor: theme.palette.action.hover,
              }}
            >
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 600, mb: 2 }}
                color="text.primary"
              >
                Or open an existing draft project
              </Typography>

              <Grid container spacing={2} justifyContent="center">
                <Grid item xs={12} sm={6} md={4}>
                  <Typography
                    component="label"
                    variant="subtitle2"
                    color="text.secondary"
                    sx={{ display: "block", mb: 0.75, textAlign: "left" }}
                  >
                    Draft Project Name
                  </Typography>
                  <Select
                    value={draftOrder}
                    onChange={handleDraftOrderChange}
                    name="draftOrder"
                    options={draftOrderOptions}
                    styles={customStyles()}
                    className="w-full"
                    components={{
                      Option: CustomOption,
                    }}
                    setSelectedDeleteOption={setSelectedDeleteOption}
                    setOpenDeleteModel={setOpenDeleteModel}
                  />
                </Grid>
              </Grid>
            </Paper>
          )}

          {/* ---------- Section 2: Phases grid ---------- */}
          {selectedPhases && selectedProName && product && (
            <Paper variant="outlined" sx={{ p: 2.5, mb: 3, borderRadius: 2 }}>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 600, mb: 2 }}
                color="text.primary"
              >
                Phases
              </Typography>

              {showPhasesAlert && (
                <Alert severity="error" sx={{ mb: 2 }} variant="outlined">
                  {phasesTotalValue > selectedQty
                    ? "Total value exceeds " + selectedQty
                    : "Total value less " + selectedQty}
                </Alert>
              )}

              <Box
                sx={{
                  borderRadius: 1,
                  overflow: "hidden",
                  border: `1px solid ${theme.palette.divider}`,
                }}
              >
                <div
                  className={
                    theme.palette.mode === "dark"
                      ? "ag-theme-alpine-dark"
                      : "ag-theme-alpine"
                  }
                >
                  <AgGridReact
                    ref={phaseGridRef}
                    rowData={phasesRowData}
                    columnDefs={phasesColumnDefs}
                    defaultColDef={defaultColDef}
                    autoGroupColumnDef={autoGroupColumnDef}
                    rowSelection={"single"}
                    animateRows={true}
                    headerHeight={28}
                    rowHeight={22}
                    domLayout={"autoHeight"}
                    enableRangeSelection={true}
                    onCellValueChanged={onCellValueChangedPhases}
                    onSelectionChanged={onSelectionChanged}
                    getRowStyle={getRowStyle}
                    isRowSelectable={isRowSelectable}
                    onGridReady={onGridReadyPhaseGrid}
                    cellSelection={true}
                    stopEditingWhenGridLosesFocus={true}
                  />
                </div>
                <Box
                  className="text-right"
                  sx={{
                    fontSize: 13,
                    padding: "6px 12px",
                    background: theme.palette.background.paper,
                    borderTop: `1px solid ${theme.palette.divider}`,
                  }}
                >
                  Total Qty/Phases: <strong>{phasesTotalValue}</strong>
                </Box>
              </Box>
            </Paper>
          )}

          {/* ---------- Section 3: Add types to phase ---------- */}
          {selectedPhases &&
            selectedRows.length > 0 &&
            isSectionVisible &&
            selectedProName && (
              <Paper variant="outlined" sx={{ p: 2.5, mb: 3, borderRadius: 2 }}>
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 600, mb: 2 }}
                  color="text.primary"
                >
                  Phase Configuration
                </Typography>

                <Grid container spacing={2} alignItems="flex-end">
                  <Grid item xs={12} sm={4}>
                    <Typography
                      component="label"
                      variant="subtitle2"
                      color="text.secondary"
                      sx={{ display: "block", mb: 0.75 }}
                    >
                      Project Short Name
                    </Typography>
                    <TextField
                      name="displayName"
                      inputProps={{ style: { textTransform: "uppercase" } }}
                      fullWidth
                      size="small"
                      variant="outlined"
                      type="text"
                      value={displayName}
                      onChange={handleChangeDisplayName}
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <Typography
                      component="label"
                      variant="subtitle2"
                      color="text.secondary"
                      sx={{ display: "block", mb: 0.75 }}
                    >
                      Project Phase
                    </Typography>
                    <TextField
                      name="projectPhase"
                      fullWidth
                      size="small"
                      variant="outlined"
                      type="text"
                      inputProps={{ maxLength: 3 }}
                      value={phaseNameCode}
                      disabled
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <Typography
                      component="label"
                      variant="subtitle2"
                      color="text.secondary"
                      sx={{ display: "block", mb: 0.75 }}
                    >
                      No. of Types in this Phase
                    </Typography>
                    <Box className="flex" sx={{ gap: 1 }}>
                      <TextField
                        value={typesPhaseQty}
                        onChange={handleChangeTypesPhaseQty}
                        fullWidth
                        size="small"
                        variant="outlined"
                        onKeyDown={blockInvalidKeys}
                        type="number"
                      />
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={handleAddRow}
                        disabled={
                          !displayName ||
                          !typesPhaseQty ||
                          !phaseNameCode ||
                          typesPhaseQty < 1
                        }
                      >
                        Add
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </Paper>
            )}

          {/* ---------- Section 4: Types grid ---------- */}
          {showType &&
            selectedPhases &&
            typesPhaseQty > 0 &&
            displayName &&
            phaseNameCode && (
              <Paper variant="outlined" sx={{ p: 2.5, borderRadius: 2 }}>
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 600, mb: 2 }}
                  color="text.primary"
                >
                  Types
                </Typography>

                {showAlert &&
                  phaseGridRef?.current?.api.getSelectedNodes().length > 0 &&
                  (() => {
                    const selectedNode =
                      phaseGridRef.current.api.getSelectedNodes()[0];
                    const phaseViseQty = selectedNode?.data?.phaseViseQty;
                    if (phaseViseQty === undefined) {
                      return null; // Do not show alert if there is no phaseViseQty available
                    }

                    if (typeTotalValue > phaseViseQty) {
                      return (
                        <Alert
                          severity="error"
                          sx={{ mb: 2 }}
                          variant="outlined"
                        >
                          Total quantity exceeds {phaseViseQty}
                        </Alert>
                      );
                    } else if (typeTotalValue < phaseViseQty) {
                      return (
                        <Alert
                          severity="error"
                          sx={{ mb: 2 }}
                          variant="outlined"
                        >
                          Total quantity is less than {phaseViseQty}
                        </Alert>
                      );
                    }

                    return null; // Do not show alert if equal
                  })()}

                <Box
                  sx={{
                    borderRadius: 1,
                    overflow: "hidden",
                    border: `1px solid ${theme.palette.divider}`,
                  }}
                >
                  <div
                    className={
                      theme.palette.mode === "dark"
                        ? "ag-theme-alpine-dark"
                        : "ag-theme-alpine"
                    }
                  >
                    <AgGridReact
                      ref={gridRef}
                      rowData={rowData}
                      columnDefs={columnDefs}
                      defaultColDef={defaultColDef}
                      autoGroupColumnDef={autoGroupColumnDef}
                      // rowSelection={"single"}
                      animateRows={true}
                      headerHeight={28}
                      rowHeight={22}
                      domLayout={"autoHeight"}
                      onCellValueChanged={onCellValueChanged}
                      onCellEditingStopped={onCellEditingStopped}
                      onPasteStart={() => setIsPasting(true)}
                      onPasteEnd={() => {
                        setIsPasting(false);
                        recalculateTotals();
                      }}
                      onRowClicked={onRowClicked}
                      onRowSelected={onRowSelected}
                      onFirstDataRendered={onFirstDataRendered}
                      cellSelection={true}
                      enableRangeSelection={true}
                    />
                  </div>

                  <Box
                    className="text-right"
                    sx={{
                      fontSize: 13,
                      padding: "6px 12px",
                      background: theme.palette.background.paper,
                      borderTop: `1px solid ${theme.palette.divider}`,
                    }}
                  >
                    Total Qty/Phases: <strong>{typeTotalValue}</strong>
                  </Box>
                </Box>

                <Box
                  sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}
                >
                  <Button
                    variant="contained"
                    color="secondary"
                    size="medium"
                    onClick={handleSubmitRowAdd}
                    disabled={isSubmitEnabled}
                  >
                    Next
                  </Button>
                </Box>
              </Paper>
            )}
        </DialogContent>
      </Dialog>
      <Dialog open={openDeleteModel} onClose={handleCloseDeleteModel}>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this draft project? Once deleted, it
            cannot be recovered.
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleDeleteDraftOrder}>Yes</Button>

          <Button onClick={handleCloseDeleteModel} autoFocus>
            No
          </Button>
        </DialogActions>
      </Dialog>
      <ProjectOverview
        open={projectOverviewOpen}
        handleClose={handleProjectOverviewClose}
        // stepData={stepData}
        // setOpen={setPrjOrderOpen}
        // typeRowData={typeRowData}
      />
      <OrderSuccess
        open={openSuccessOrder}
        commissionName={commissionName}
        currentOrder={currentOrder}
        setOpenSuccessOrder={setOpenSuccessOrder}
        setPlaceOrderBtnDisable={setPlaceOrderBtnDisable}
        token={token}
      />
    </>
  );
};

export default CreateOrder;
